/**
 * Manual locale strings (no i18n library). Keys are flat dot-notation.
 */
export const messages = {
  th: {
    "brand.university": "มหาวิทยาลัยแม่ฟ้าหลวง",
    "brand.maintenanceShort": "Maintenance System",
    "notification.bell": "การแจ้งเตือน",
    "notification.panelTitle": "การแจ้งเตือน",
    "notification.markAllRead": "อ่านทั้งหมด",
    "notification.clearRead": "ล้างที่อ่านแล้ว",
    "notification.delete": "ลบ",
    "notification.read": "อ่านแล้ว",
    "notification.unread": "ยังไม่อ่าน",
    "notification.empty": "ไม่มีการแจ้งเตือน",
    "notification.loading": "กำลังโหลด...",

    "common.cancel": "ยกเลิก",
    "common.other": "อื่น ๆ",
    "common.all": "ทั้งหมด",
    "common.items": "รายการ",
    "common.technician": "ช่างเทคนิค",
    "common.logout": "ออกจากระบบ",
    "common.langTh": "TH",
    "common.langEn": "EN",
    "common.viewDetails": "รายละเอียด",
    "common.close": "ปิด",
    "common.deleteSuccess": "ลบข้อมูลสำเร็จ",
    "common.dialog": "กล่องโต้ตอบ",
    "common.search": "ค้นหา",
    "common.clearSearch": "ล้างคำค้นหา",
    "common.filterLabel": "ค้นหา:",
    "common.filterPlaceholder": "ค้นหาชื่อช่าง หรือ แผนก...",

    "table.noResults": "ไม่พบข้อมูลที่ค้นหา",
    "table.filterLabel": "ค้นหา:",
    "table.filterPlaceholder": "พิมพ์เพื่อค้นหา...",
    "table.itemsPerPageLabel": "แสดงต่อหน้า:",

    "login.title": "ระบบแจ้งซ่อมออนไลน์",
    "login.subtitle": "มหาวิทยาลัยแม่ฟ้าหลวง",
    "login.signIn": "ลงชื่อเข้าใช้",
    "login.mfuHint": "* โปรดใช้ MFU Mail ในการลงชื่อเข้าใช้",
    "login.externalNotice":
      "* พนักงานรายวัน (อีเมลภายนอก) ต้องได้รับการลงทะเบียนรายชื่อจากผู้ดูแลระบบก่อนจึงจะเข้าใช้งานได้",
    "login.userManual": "คู่มือการใช้งาน",
    "login.swalGoogleLoadingTitle": "กำลังโหลด",
    "login.swalGoogleLoadingText":
      "ระบบกำลังเชื่อมต่อกับ Google กรุณารอสักครู่และพยายามใหม่อีกครั้ง",
    "login.ok": "ตกลง",
    "login.verifyingTitle": "กำลังตรวจสอบข้อมูล...",
    "login.verifyingText": "กรุณารอสักครู่ ระบบกำลังนำท่านเข้าสู่ระบบ",
    "login.successTitle": "เข้าสู่ระบบสำเร็จ",
    "login.errorTitle": "เกิดข้อผิดพลาด",
    "login.failGeneric": "เข้าสู่ระบบล้มเหลว",
    "login.mockTitle": "DEVELOPMENT LOGIN",
    "login.mockRoleLabel": "เลือกบทบาทสำหรับทดสอบ",
    "login.mockRoleUser": "ผู้แจ้งซ่อม",
    "login.mockRoleTech": "ช่างซ่อม",
    "login.mockRoleSup": "Supervisor",
    "login.mockRoleAdmin": "Admin",
    "login.mockPersonaLabel": "เลือกผู้ใช้งานจำลอง",
    "login.mockPersonaPlaceholder": "-- กรุณาเลือกบุคคลสำหรับทดสอบ --",
    "login.mockPersonaRequired": "กรุณาเลือกบุคคลจำลองก่อนเข้าใช้งาน",
    "login.mockSelectJobLabel": "เลือกประเภทงานช่าง",
    "login.mockSelectJobPlaceholder": "-- กรุณาเลือกประเภทงานช่าง --",
    "login.mockSelectSectionLabel": "เลือกส่วนงาน",
    "login.mockSelectSectionPlaceholder": "-- กรุณาเลือกส่วนงาน --",
    "login.mockLoginBtn": "เข้าใช้งานในบทบาท {role}",
    "login.mockNote": "ใช้สำหรับทดสอบระบบในเครื่อง Local เท่านั้น",
    "login.mockJobRequired": "กรุณาเลือกประเภทงานของช่างก่อนเข้าใช้งาน",
    "login.mockSectionRequired":
      "กรุณาเลือกส่วนงานของ Supervisor ก่อนเข้าใช้งาน",

    "nav.userManual": "คู่มือการใช้งาน",
    "nav.studentHistory": "ประวัติแจ้งซ่อมนักศึกษา",
    "nav.logout": "ออกจากระบบ",
    "nav.dashboard": "แดชบอร์ด",
    "nav.evaluation": "ประเมินผลช่างเทคนิค",
    "nav.repairs": "งานซ่อม",
    "nav.staff": "จัดการข้อมูล เจ้าหน้าที่",
    "nav.jobTypes": "จัดการส่วนงานและประเภทงาน",
    "nav.departments": "จัดการข้อมูล ฝ่าย",
    "nav.buildings": "จัดการข้อมูล อาคาร",
    "nav.requesterOrgSync": "เชื่อมข้อมูลสังกัดผู้แจ้งซ่อม",
    "nav.manageData": "จัดการข้อมูล",
    "nav.new": "แจ้งซ่อม",
    "nav.main": "หน้าหลัก",
    "nav.history": "ประวัติ",
    "nav.navigation": "เมนูนำทาง",
    "requesterOrgSync.title": "เชื่อมข้อมูลสังกัดผู้แจ้งซ่อม",
    "requesterOrgSync.description":
      "เชื่อมโยงและนำเข้าข้อมูลสังกัดผู้แจ้งจาก University Master Data เข้าสู่ระบบแจ้งซ่อม",
    "requesterOrgSync.createOnlyNotice":
      "การยืนยันจะเพิ่มเฉพาะข้อมูลใหม่ที่ผ่านการตรวจสอบแล้วเท่านั้น",
    "requesterOrgSync.checkUpdates": "ตรวจสอบข้อมูลล่าสุด",
    "requesterOrgSync.checking": "กำลังตรวจสอบ",
    "requesterOrgSync.previewSummary": "สรุปผลการตรวจสอบ",
    "requesterOrgSync.newData": "ข้อมูลใหม่",
    "requesterOrgSync.unchanged": "มีอยู่แล้ว",
    "requesterOrgSync.conflicts": "Conflict",
    "requesterOrgSync.reviewRequired": "ต้องตรวจสอบ",
    "requesterOrgSync.upToDate": "ข้อมูลเป็นปัจจุบันแล้ว",
    "requesterOrgSync.noApplyNeeded": "ไม่มีรายการที่ต้องเพิ่ม",
    "requesterOrgSync.reviewBlocked":
      "มีรายการที่ต้องตรวจสอบ จึงยังไม่สามารถยืนยันได้",
    "requesterOrgSync.applyUpdates": "ซิงก์ข้อมูล {count} รายการ",
    "requesterOrgSync.confirmTitle": "ยืนยันการซิงก์ข้อมูลหรือไม่?",
    "requesterOrgSync.confirmText":
      "ระบบจะเพิ่มข้อมูลใหม่จากแผนที่ตรวจสอบแล้วจำนวน {count} รายการ",
    "requesterOrgSync.applyNow": "ซิงก์ตอนนี้",
    "requesterOrgSync.completed": "ซิงก์ข้อมูลเรียบร้อย",
    "requesterOrgSync.added": "เพิ่มข้อมูลใหม่: {count}",
    "requesterOrgSync.previewFailed": "ไม่สามารถตรวจสอบข้อมูลได้",
    "requesterOrgSync.applyFailed": "ไม่สามารถซิงก์ข้อมูลได้",
    "requesterOrgSync.errorCode": "รหัสข้อผิดพลาด",
    "requesterOrgSync.planId": "รหัสแผน",
    "requesterOrgSync.planHash": "ลายนิ้วมือแผน",
    "requesterOrgSync.sourceFingerprint": "ลายนิ้วมือข้อมูลต้นทาง",
    "requesterOrgSync.alwaysCheck": "ตรวจสอบ Blendata อัตโนมัติ",
    "requesterOrgSync.autoSync": "ซิงก์อัตโนมัติ",
    "requesterOrgSync.autoSyncNotice":
      "ตรวจและเตรียมรายการซิงค์ตามเวลา — รอ Admin ยืนยันก่อนบันทึก",
    "requesterOrgSync.tabCreateNew": "เพิ่มสังกัดใหม่",
    "requesterOrgSync.tabUpdateName": "แก้ไขสังกัดเดิม",
    "requesterOrgSync.tabRequiresReview": "ต้องตรวจเพิ่มเติม",
    "requesterOrgSync.tabChangeHistory": "ประวัติการแก้ไข",
    "requesterOrgSync.historyTitle": "ประวัติการแก้ไขและอนุมัติสังกัด",
    "requesterOrgSync.historySearchPlaceholder":
      "ค้นหารหัส, ชื่อสังกัด, ค่าเดิม, ค่าใหม่, ผู้ดำเนินการ...",
    "requesterOrgSync.historyActionAll": "ทุกประเภทการดำเนินการ",
    "requesterOrgSync.historyActionCreate": "เพิ่มสังกัดใหม่",
    "requesterOrgSync.historyActionUpdateName": "เปลี่ยนชื่อสังกัด",
    "requesterOrgSync.historyActionUpdateCode": "เปลี่ยนรหัสสังกัด",
    "requesterOrgSync.historyActionKeepDefault": "คงข้อมูลสังกัดเดิมไว้",
    "requesterOrgSync.historyActionPostpone": "เลื่อนการพิจารณา",
    "requesterOrgSync.historyActionResume": "นำกลับมารอพิจารณา",
    "requesterOrgSync.historyDateFrom": "จากวันที่",
    "requesterOrgSync.historyDateTo": "ถึงวันที่",
    "requesterOrgSync.historyEmpty": "ไม่พบประวัติการแก้ไขตามเงื่อนไขที่เลือก",
    "requesterOrgSync.historyColTime": "วัน-เวลา (เวลาไทย)",
    "requesterOrgSync.historyColOperator": "ผู้ดำเนินการ",
    "requesterOrgSync.historyColOrg": "รหัส / ชื่อสังกัด",
    "requesterOrgSync.historyColAction": "การดำเนินการ",
    "requesterOrgSync.historyColChanges": "การเปลี่ยนแปลง (ก่อน → หลัง)",
    "requesterOrgSync.historyColAlias": "ชื่อเดิม (Alias)",
    "requesterOrgSync.historyColProvenance": "แหล่งที่มาของรายการ",
    "requesterOrgSync.historyColResult": "ผลลัพธ์",
    "requesterOrgSync.noActionableItems": "ไม่มีรายการรอจัดการ",
    "requesterOrgSync.noActionableItemsDesc":
      "ไม่มีรายการที่ต้องอนุมัติหรือจัดการในขณะนี้",
    "requesterOrgSync.viewChangeHistoryBtn": "ดูประวัติการแก้ไข",
    "requesterOrgSync.confirmBatchBtn":
      "ยืนยันเพิ่ม {createCount} รายการ และแก้ไข {updateCount} รายการ",
    "requesterOrgSync.postponeBtn": "เลื่อนการตัดสินใจ",
    "requesterOrgSync.selectAll": "เลือกทั้งหมด",
    "requesterOrgSync.deselectAll": "ยกเลิกเลือก",
    "requesterOrgSync.batchConfirmTitle": "ยืนยันการบันทึกข้อมูลสังกัด?",
    "requesterOrgSync.batchConfirmDesc":
      "ต้องการบันทึกการเพิ่มสังกัดใหม่ {createCount} รายการ และแก้ไขสังกัดเดิม {updateCount} รายการ หรือไม่?",
    "requesterOrgSync.preservedIdBadge": "คง _id เดิม",
    "requesterOrgSync.missingInMaster": "ไม่พบใน Master Data",
    "requesterOrgSync.missingInMasterDesc":
      "คงข้อมูลเดิมเป็นค่าเริ่มต้น (ไม่มีการลบข้อมูล)",
    "requesterOrgSync.codeDriftDetail": "ระบุความสัมพันธ์ของรหัส",
    "requesterOrgSync.pendingBadge": "รอการตรวจและยืนยัน {count} รายการ",
    "requesterOrgSync.scheduleEvery": "ความถี่การตรวจสอบ: ทุก ๆ",
    "requesterOrgSync.unitDay": "วัน",
    "requesterOrgSync.unitMonth": "เดือน",
    "requesterOrgSync.unitYear": "ปี",
    "requesterOrgSync.syncNowBtn": "ซิงค์ข้อมูลตอนนี้",
    "requesterOrgSync.syncNowDesc":
      "ตรวจสอบข้อมูลสังกัดล่าสุดจาก Blendata และเปรียบเทียบกับฐานข้อมูล",
    "requesterOrgSync.confirmSyncNowTitle":
      "ยืนยันการเชื่อมข้อมูลสังกัดผู้แจ้งซ่อม?",
    "requesterOrgSync.confirmSyncNowText":
      "ระบบจะอ่าน Master Data ตรวจสอบข้อมูลและจัดเตรียมรายการรอ Admin อนุมัติ โดยไม่มีการแก้ไขหรือเพิ่มข้อมูลลงระบบโดยตรง",
    "requesterOrgSync.syncNowComplete":
      "ซิงค์ข้อมูลเรียบร้อย: เพิ่มข้อมูลใหม่ {count} รายการ",
    "requesterOrgSync.syncNowUpToDate":
      "ข้อมูลสังกัดตรงกับ Master Data แล้ว ไม่มีรายการใหม่ที่ต้องเพิ่ม",
    "requesterOrgSync.syncNowBlocked":
      "พบรายการที่ต้องตรวจสอบหรือถูกระงับ: {reason}",
    "requesterOrgSync.syncNowWarning":
      "ซิงค์ข้อมูลสำเร็จพร้อมคำเตือน: เพิ่มหน่วยงานใหม่แล้ว แต่อัปเดตสถานะล่าสุดไม่สมบูรณ์ (กรุณาอย่ากดซ้ำ)",
    "requesterOrgSync.statusGreenTitle":
      "ข้อมูลสังกัดตรงกับ Master Data — ยังไม่พบความเปลี่ยนแปลง",
    "requesterOrgSync.statusGreenDesc":
      "ข้อมูลหน่วยงานสังกัดในระบบเป็นปัจจุบันตรงกับ University Master Data แล้ว",
    "requesterOrgSync.statusRedTitle": "พบความเปลี่ยนแปลงจาก Master Data",
    "requesterOrgSync.statusRedDesc":
      "ตรวจพบรายการข้อมูลใหม่หรือรายการที่ต้องตรวจทานจาก Master Data",
    "requesterOrgSync.statusWarningTitle":
      "ยังไม่ได้ตรวจสอบ หรือไม่สามารถเชื่อมต่อ Blendata ได้",
    "requesterOrgSync.statusWarningDesc":
      "ระบบยังไม่ได้รับผลการเปรียบเทียบที่สมบูรณ์ หรือการเชื่อมต่อกับ Blendata ขัดข้อง",
    "requesterOrgSync.autoSyncTitle": "ตั้งค่าซิงค์อัตโนมัติ (Auto Sync)",
    "requesterOrgSync.autoSyncDesc":
      "กำหนดตารางเวลาให้ระบบทำการซิงค์ข้อมูลหน่วยงานและบันทึกลงฐานข้อมูลอัตโนมัติ",
    "requesterOrgSync.cancel": "ยกเลิก",
    "requesterOrgSync.modeDay": "แบบวัน",
    "requesterOrgSync.modeMonth": "แบบเดือน",
    "requesterOrgSync.modeYear": "แบบปี",
    "requesterOrgSync.everyNDays": "ทุก ๆ (1–7 วัน)",
    "requesterOrgSync.dayOfMonth": "วันที่ (1–30)",
    "requesterOrgSync.monthOfYear": "เดือน",
    "requesterOrgSync.syncTime": "เวลา (HH:mm)",
    "requesterOrgSync.timeThaiLabel": "เวลาไทย (Asia/Bangkok)",
    "requesterOrgSync.nextSyncCalculated": "กำหนดซิงค์ครั้งถัดไป:",
    "requesterOrgSync.previewScheduleTitle": "ตัวอย่างรอบซิงค์ที่จะบันทึก:",
    "requesterOrgSync.clampingNote":
      "กรณีเดือนที่มีวันน้อยกว่า (เช่น กุมภาพันธ์) ระบบจะทำงานในวันสุดท้ายของเดือนโดยอัตโนมัติ",
    "requesterOrgSync.autoSyncUnconfigured":
      "ยังไม่ได้ตั้งตารางเวลาซิงค์อัตโนมัติ (กรุณาตั้งค่าตารางเวลา)",
    "requesterOrgSync.saveAutoSyncSettings": "บันทึกการตั้งค่าซิงค์อัตโนมัติ",
    "requesterOrgSync.alwaysCheckTitle":
      "ตั้งค่าตรวจความเปลี่ยนแปลง (Always Check)",
    "requesterOrgSync.alwaysCheckDesc":
      "ระบบจะตรวจจับความต่างระหว่างฐานข้อมูลกับ Blendata ในเบื้องหลัง (เปิดทำงานตลอด ไม่สามารถปิดได้)",
    "requesterOrgSync.alwaysCheckMandatory": "เปิดทำงานตลอด (Mandatory)",
    "requesterOrgSync.checkIntervalDaysLabel":
      "ตรวจความเปลี่ยนแปลงทุก ๆ (1–365 วัน):",
    "requesterOrgSync.saveAlwaysCheckSettings":
      "บันทึกรอบการตรวจความเปลี่ยนแปลง",
    "requesterOrgSync.saveSettings": "บันทึกการตั้งค่า",
    "requesterOrgSync.settingsSaved": "บันทึกการตั้งค่าสำเร็จ",
    "requesterOrgSync.statusPanel": "สถานะการซิงก์และการตรวจสอบ",
    "requesterOrgSync.blendataStatus": "สถานะ Blendata",
    "requesterOrgSync.lastCheck": "ตรวจสอบล่าสุดเมื่อ",
    "requesterOrgSync.lastSuccessfulSync": "ซิงก์สำเร็จล่าสุดเมื่อ",
    "requesterOrgSync.nextCheck": "กำหนดตรวจสอบครั้งถัดไป (ตามแผน)",
    "requesterOrgSync.masterDataStatus": "สถานะ Master Data",
    "requesterOrgSync.lastSafeError": "ข้อผิดพลาดล่าสุด",
    "requesterOrgSync.checkNow": "ตรวจสอบ Blendata ตอนนี้",
    "requesterOrgSync.checkingNow": "กำลังตรวจสอบ Blendata...",
    "requesterOrgSync.checkSuccess": "ตรวจสอบ Blendata เรียบร้อย",
    "requesterOrgSync.schedulerStatus": "สถานะระบบตั้งเวลาอัตโนมัติ",
    "requesterOrgSync.schedulerActive": "ทำงาน (Active)",
    "requesterOrgSync.schedulerInactive":
      "ไม่ทำงาน (Worker ไม่ได้เริ่มทำงาน / Flags ปิด)",
    "requesterOrgSync.schedulerWarning": "คำเตือนระบบตั้งเวลา",
    "requesterOrgSync.autoSyncDecision": "ผลการตัดสินใจ Auto Sync",
    "requesterOrgSync.decisionUpToDate": "ข้อมูลตรงกันแล้ว (Up to date)",
    "requesterOrgSync.decisionSafeCreateNew":
      "มีข้อมูลเพิ่มใหม่อย่างปลอดภัย (Safe Create-Only)",
    "requesterOrgSync.decisionReviewRequired":
      "ต้องตรวจสอบก่อน (Review Required)",
    "requesterOrgSync.decisionBlocked": "ถูกระงับ (Blocked)",
    "requesterOrgSync.decisionReason": "เหตุผลการตัดสินใจ",
    "requesterOrgSync.safeCreateNotice":
      "ตรวจพบรายการเพิ่มใหม่ที่ปลอดภัย ระบบยังไม่เปิดใช้งานการซิงก์อัตโนมัติ (automaticApplyActive = false)",
    "requesterOrgSync.reviewRequiredNotice":
      "จำเป็นต้องตรวจสอบโดยผู้ดูแลระบบ กรุณาใช้การตรวจสอบล่วงหน้า (Preview) และซิงก์แบบควบคุมด้วยตนเอง",
    "requesterOrgSync.blockedNotice":
      "ระบบระงับการตัดสินใจอัตโนมัติเนื่องจากข้อผิดพลาดในการตรวจสอบ",
    "requesterOrgSync.decisionFingerprint":
      "ลายนิ้วมือการเปรียบเทียบ (Fingerprint)",
    "requesterOrgSync.saveSettingsFailed": "ไม่สามารถบันทึกการตั้งค่าได้",
    "requesterOrgSync.checkFailed": "ไม่สามารถตรวจสอบ Blendata ได้",
    "requesterOrgSync.saving": "กำลังบันทึกการตั้งค่า...",
    "requesterOrgSync.checkingUpdates": "กำลังตรวจสอบการเปลี่ยนแปลง...",
    "requesterOrgSync.applying": "กำลังเพิ่มหน่วยงานใหม่...",
    "requesterOrgSync.refreshStatusWarning":
      "เพิ่มหน่วยงานใหม่สำเร็จแล้ว แต่การอัปเดตสถานะล่าสุดไม่สำเร็จ ข้อมูลถูกบันทึกเรียบร้อยแล้ว กรุณาอย่ากดซ้ำ",
    "requesterOrgSync.statusPanelNotice":
      "ผลการตรวจสอบรอบล่าสุด ไม่ใช่การเชื่อมต่อสดตลอดเวลา",
    "requesterOrgSync.intervalRequired": "กรุณาระบุความถี่เป็นจำนวนเต็มบวก",
    "requesterOrgSync.intervalMinError": "ความถี่ต้องไม่ต่ำกว่า 1",
    "requesterOrgSync.intervalMaxDay":
      "ความถี่รอบตรวจสอบแบบวัน ต้องอยู่ระหว่าง 1 ถึง 365 วัน",
    "requesterOrgSync.intervalMaxMonth":
      "ความถี่รอบตรวจสอบแบบเดือน ต้องอยู่ระหว่าง 1 ถึง 120 เดือน",
    "requesterOrgSync.intervalMaxYear":
      "ความถี่รอบตรวจสอบแบบปี ต้องอยู่ระหว่าง 1 ถึง 10 ปี",
    "requesterOrgSync.confirmAddTitle": "ยืนยันการเพิ่มหน่วยงานใหม่?",
    "requesterOrgSync.confirmAddText":
      "ระบบจะดำเนินการเพิ่มหน่วยงานใหม่จำนวน {count} รายการลงในฐานข้อมูล โดยไม่มีการแก้ไขหรือลบข้อมูลเดิม (Create-Only)",
    "requesterOrgSync.applyNowBtn": "เพิ่มหน่วยงานใหม่ตอนนี้",
    "requesterOrgSync.addUpdatesBtn": "เพิ่มหน่วยงานใหม่ {count} รายการ",
    "requesterOrgSync.secondarySettingsTitle":
      "ตั้งค่ารอบการตรวจสอบและระบบอัตโนมัติ",
    "requesterOrgSync.secondarySettingsDesc":
      "จัดการรอบการตรวจสอบ Blendata อัตโนมัติและการตั้งค่าที่เกี่ยวข้อง",
    "requesterOrgSync.secondaryCheckTitle":
      "ตรวจและบันทึกสถานะรอบปัจจุบันทันที",
    "requesterOrgSync.secondaryCheckDesc":
      "อ่านและเปรียบเทียบข้อมูลหน่วยงานกับ Blendata พร้อมบันทึกผลการตรวจสอบล่าสุดลงระบบ (แตกต่างจาก 'ตรวจสอบการเปลี่ยนแปลง' ที่จัดเตรียมแผนสำหรับเพิ่มหน่วยงานใหม่)",
    "requesterOrgSync.technicalDetails":
      "รายละเอียดทางเทคนิคสำหรับการตรวจสอบ (Technical Audit Details)",
    "requesterOrgSync.reviewRequiredDesc":
      "ตรวจพบรายการที่ต้องตรวจทาน ระบบระงับการเพิ่มข้อมูลจนกว่ารายการเหล่านี้จะได้รับการตรวจสอบ",
    "requesterOrgSync.noNewItems": "ไม่มีรายการใหม่ที่ต้องเพิ่ม",
    "requesterOrgSync.showDetails": "แสดงรายละเอียด",
    "requesterOrgSync.hideDetails": "ซ่อนรายละเอียด",
    "requesterOrgSync.autoApplyInactive": "ไม่ทำงาน (Inactive)",
    "requesterOrgSync.autoApplyActive": "ทำงาน (Active)",
    "requesterOrgSync.alwaysCheckWorkerStatus":
      "สถานะ Worker ตรวจสอบอัตโนมัติ (Always Check)",
    "requesterOrgSync.autoSyncWorkerStatus":
      "สถานะ Worker ซิงค์อัตโนมัติ (Auto Sync)",
    "requesterOrgSync.savedAutoSyncSetting":
      "การตั้งค่า Auto Sync ที่บันทึกไว้",
    "requesterOrgSync.nextSyncTime": "เวลาซิงค์ถัดไป",
    "requesterOrgSync.previewActionDesc":
      "ตรวจสอบความแตกต่างจาก University Master Data เพื่อจัดเตรียมแผนสำหรับเพิ่มหน่วยงานใหม่ (ไม่บันทึกสถานะลงระบบจนกว่าจะยืนยันเพิ่มหน่วยงาน)",
    "requesterOrgSync.blockerPrefix": "เหตุผลที่ระงับการบันทึก:",
    "requesterOrgSync.createCandidates":
      "รายการที่พร้อมเพิ่มใหม่ (Create-Only)",
    "requesterOrgSync.reviewItemsTitle":
      "รายการที่ต้องตรวจทาน (Review Required)",
    "requesterOrgSync.applyDisabledTooltip":
      "กรุณาตรวจสอบการเปลี่ยนแปลงก่อน หรือแก้ไขรายการที่ต้องตรวจทาน",

    "mainuser.pageTitle": "แจ้งซ่อม",
    "mainuser.pageSubtitle":
      "สร้างคำร้องแจ้งซ่อมใหม่หรือดูรายละเอียดการแจ้งซ่อมล่าสุด",
    "mainuser.createNewRequest": "แจ้งซ่อม",
    "mainuser.detailsTitle": "คำร้องแจ้งซ่อมล่าสุด",
    "mainuser.activeRequestsTitle": "รายการแจ้งซ่อม",
    "mainuser.activeRequestLabel": "รายการแจ้งซ่อม",
    "mainuser.noActiveRequestTitle": "ไม่มีรายการแจ้งซ่อมที่กำลังดำเนินการ",
    "mainuser.noActiveRequestText":
      "รายการแจ้งซ่อมใหม่ที่ยังไม่เสร็จจะแสดงที่นี่",
    "mainuser.detailsSubtitle": "แสดงเพียงคำร้องล่าสุดเพื่อเข้าถึงได้รวดเร็ว",
    "mainuser.noLatestRequestTitle": "ยังไม่มีคำร้องล่าสุด",
    "mainuser.noLatestRequestText":
      "เมื่อมีคำร้องล่าสุด ระบบจะแสดงบัตรรายละเอียดที่นี่",
    "mainuser.reportBtn": "แจ้งซ่อม",
    "mainuser.tabReports": "รายการแจ้งซ่อม",
    "mainuser.tabHistory": "ประวัติแจ้งซ่อม",
    "userHistory.subtitle": "ตรวจสอบรายการแจ้งซ่อมที่ผ่านมาและผลการดำเนินงาน",
    "userHistory.allTransactions": "รายการย้อนหลังทั้งหมด",
    "userHistory.empty": "ยังไม่มีประวัติการแจ้งซ่อม",
    "userHistory.ticketNo": "เลขที่ใบแจ้งซ่อม",
    "userHistory.dateTime": "วัน/เวลา แจ้ง",
    "userHistory.details": "รายละเอียดปัญหา",
    "userHistory.problemDetails": "รายละเอียดปัญหา",
    "userHistory.routing": "หน่วยงานที่รับแจ้ง",
    "userHistory.section": "ส่วนงาน",
    "userHistory.department": "ฝ่าย",
    "userHistory.jobType": "ประเภทงาน",
    "userHistory.satisfaction": "ความพึงพอใจ",
    "userHistory.reporterAndRole": "ผู้แจ้ง / ความเกี่ยวข้อง",
    "userHistory.roleReporter": "ผู้แจ้ง",
    "userHistory.roleAssigned": "งานที่รับผิดชอบ",
    "mainuser.ticketCancelledTitle": "ใบแจ้งซ่อมถูกยกเลิก",
    "mainuser.ticketCancelledText": "ใบแจ้งซ่อมนี้ถูกยกเลิกแล้ว",
    "mainuser.evalBeforeNewTitle": "แจ้งเตือนจากระบบ",
    "mainuser.evalBeforeNewText":
      "กรุณาทำการประเมินการซ่อมที่เสร็จสิ้นแล้วก่อน จึงจะสามารถแจ้งซ่อมใหม่ได้",
    "mainuser.thanksEvalTitle": "ขอบคุณสำหรับการประเมิน",
    "mainuser.evalTicketNo": "เลขที่ใบงาน:",
    "mainuser.evalScore": "คะแนน:",
    "mainuser.evalStars": "ดาว",
    "mainuser.evalComment": "ความคิดเห็น:",
    "mainuser.evalNoComment": "ไม่มี",

    "home.kpiTotalReported": "งานแจ้งทั้งหมด",
    "home.kpiCompleted": "งานที่เสร็จ",
    "home.kpiAwaitingEval": "งานที่ค้างประเมิน",
    "home.kpiUnassigned": "รอมอบหมาย",
    "home.kpiNewJobs": "งานที่เข้าใหม่",
    "home.kpiInProgressAll": "กำลังซ่อมทั้งหมด",
    "home.kpiCompletedJobs": "งานที่ซ่อมเสร็จ",
    "home.kpiOverdue": "งานค้าง",

    "dashboard.kpiTotalRequests": "จำนวนการแจ้งซ่อมทั้งหมด",
    "dashboard.kpiPending": "รอดำเนินการ",
    "dashboard.kpiAssigned": "งานที่ได้รับมอบหมาย",
    "dashboard.kpiInProgress": "กำลังดำเนินการ",
    "dashboard.kpiCompleted": "ปิดงานแล้ว",
    "dashboard.kpiOverSla": "เกิน SLA",
    "dashboard.kpiSatisfaction": "คะแนนความพึงพอใจเฉลี่ย",
    "dashboard.kpiAwaitingEval": "รอประเมิน",
    "dashboard.pieByDepartment": "สัดส่วนงานแจ้งซ่อมตามหน่วยงาน",
    "dashboard.pieByCategory": "สัดส่วนงานแจ้งซ่อมตามหมวดหมู่",
    "dashboard.barMonthly": "สถิติการแจ้งซ่อมรายเดือน",
    "dashboard.heatmap": "แผนที่ความร้อน",
    "dashboard.ticketDetails": "รายละเอียดใบงาน",
    "dashboard.reportPdf": "รายงาน",
    "dashboard.noData": "ไม่มีข้อมูล",
    "dashboard.slaTarget": "เป้า:",
    "dashboard.rangeCustom": "กำหนดเอง",
    "dashboard.rangeToday": "วันนี้",
    "dashboard.rangeWeek": "สัปดาห์",
    "dashboard.rangeMonth": "เดือน",
    "dashboard.rangeHalfYear": "ครึ่งปี",
    "dashboard.rangeYear": "ปี",
    "dashboard.rangeAll": "ทั้งหมด",
    "dashboard.rangeEval": "รอบประเมิน",
    "dashboard.evalMonthsSuffix": "เดือนย้อนหลัง",
    "dashboard.filterAllDepts": "ทุกแผนก",
    "dashboard.filterAllTechs": "ช่างทุกคน",
    "dashboard.periodPrefix": "ช่วงเวลา:",
    "dashboard.pdfTitle": "รายงานสรุปผลการแจ้งซ่อม",
    "dashboard.pdfPrintedAt": "พิมพ์เมื่อ:",
    "dashboard.shortMon": "จ.",
    "dashboard.shortTue": "อ.",
    "dashboard.shortWed": "พ.",
    "dashboard.shortThu": "พฤ.",
    "dashboard.shortFri": "ศ.",
    "dashboard.shortSat": "ส.",
    "dashboard.shortSun": "อา.",
    "dashboard.downloadPdf": "ดาวน์โหลด PDF",
    "dashboard.downloadExcel": "ดาวน์โหลด Excel",
    "dashboard.colDepartment": "หน่วยงาน",
    "dashboard.colReporter": "ผู้แจ้ง",
    "dashboard.colCategory": "ประเภทงาน",
    "dashboard.closedJobsProportion": "สัดส่วนงานที่ปิดแล้ว",
    "dashboard.calcFromAllJobsHint": "คำนวณจากงานทั้งหมดในช่วงเวลาที่เลือก",
    "dashboard.pendingManagementTasks": "งานที่รอการจัดการ",

    "evaluation.detailsFor": "รายละเอียดผลงานของ",
    "evaluation.excelExportError": "เกิดข้อผิดพลาดในการสร้างไฟล์รายงาน Excel",
    "dashboard.searchPlaceholder": "ค้นหาใบแจ้งซ่อม หรือประเภทงาน...",
    "evaluation.searchPlaceholder": "ค้นหาชื่อช่าง หรือ แผนก...",
    "buildingMgmt.searchPlaceholder": "ค้นหาอาคาร หรือ ชื่อห้อง...",
    "evaluation.field.name": "ชื่อ-สกุล",
    "evaluation.field.department": "แผนก",
    "evaluation.field.totalJobs": "รับงานทั้งหมด",
    "evaluation.field.completedJobs": "ปิดงานแล้ว",
    "evaluation.field.slaMetPercent": "% ทัน SLA",
    "evaluation.field.avgRating": "ดาวเฉลี่ย",
    "evaluation.field.rating": "ดาว",
    "evaluation.field.comment": "ความคิดเห็น",
    "evaluation.excelExportSubtitle": "ระบบจัดการและส่งออกข้อมูลรายงาน SmartFix MFU",
    "evaluation.quickPresets": "ช่วงเวลาด่วน:",
    "evaluation.presetAll": "ทั้งหมด",
    "evaluation.presetThisMonth": "เดือนนี้",
    "evaluation.presetLast30Days": "30 วันล่าสุด",
    "evaluation.presetThisYear": "ปีนี้",
    "evaluation.ownDepartmentOnly": "ดาวน์โหลดเฉพาะฝ่ายตัวเอง",
    "evaluation.supervisorDepartmentNote": "* สิทธิ์หัวหน้างาน (Supervisor) สามารถดาวน์โหลดรายงานและผลการประเมินได้เฉพาะฝ่ายตัวเองเท่านั้น",
    "evaluation.scopeDepartment": "ขอบเขตแผนก:",
    "evaluation.allDepartments": "ทุกแผนก (ทั้งหมด)",
    "evaluation.matchingTickets": "จำนวนใบงานที่เข้าเงื่อนไข:",
    "evaluation.itemsCount": "{count} รายการ",
    "evaluation.sheet1Title": "แผ่นงานที่ 1 (รายงานการแจ้งซ่อม):",
    "evaluation.sheet1Desc": "รายละเอียดใบงาน 15 คอลัมน์ครบถ้วน หัวตารางสีน้ำเงินเข้ม สลับสีแถว พร้อมไฮเปอร์ลิงก์รูปภาพผลงาน และสรุปยอดค่าใช้จ่ายท้ายตาราง",
    "evaluation.sheet2Title": "แผ่นงานที่ 2 (สรุปผลการประเมินช่าง):",
    "evaluation.sheet2Desc": "สรุปผลการปฏิบัติงาน อัตรา SLA Met %, คะแนนประเมินเฉลี่ย รายการอะไหล่ที่ใช้ และยอดรวมค่าใช้จ่ายแต่ละช่าง",
    "evaluation.generatingFile": "กำลังสร้างไฟล์...",
    "evaluation.downloadExcelFile": "ดาวน์โหลดไฟล์ Excel (.xlsx)",
    "evaluation.yourDepartment": "ฝ่ายงานของท่าน",
    "evaluation.generalExpense": "ค่าใช้จ่ายทั่วไป",
    "evaluation.exportError": "เกิดข้อผิดพลาดในการสร้างไฟล์รายงาน Excel",

    "dashboard.pdfKpiTotal": "จำนวนงานทั้งหมด",
    "dashboard.pdfKpiCompleted": "ปิดงานแล้ว",
    "dashboard.pdfKpiInProgress": "กำลังดำเนินการ",
    "dashboard.pdfKpiOverdue": "เกินกำหนด (SLA)",
    "dashboard.pdfKpiAwaiting": "รอประเมิน",
    "dashboard.pdfKpiSatisfaction": "ความพึงพอใจเฉลี่ย",
    "dashboard.pdfWorkListTitle": "รายละเอียดของงานที่มีมา",
    "dashboard.colTicketNo": "เลขที่ใบแจ้งซ่อม",
    "dashboard.colDateReported": "วันที่แจ้ง",
    "dashboard.colReporterDept": "ผู้แจ้ง/หน่วยงาน",
    "dashboard.colStatus": "สถานะ",
    "dashboard.colSla": "SLA",
    "dashboard.colClosedAt": "เวลาปิดงาน",
    "dashboard.noRowsInPeriod": "ไม่มีข้อมูลในช่วงเวลานี้",
    "dashboard.summaryTitle": "สรุปข้อมูลรายหมวดหมู่ (Summary)",
    "dashboard.summaryColDept": "หน่วยงาน / แผนก",
    "dashboard.summaryColCategory": "หมวดหมู่ / หน่วยงาน",
    "dashboard.summaryColTotal": "จำนวนงานทั้งหมด",
    "dashboard.summaryColCompleted": "ปิดงานแล้ว",
    "dashboard.summaryColInProgress": "กำลังดำเนินการ",
    "dashboard.summaryColOverdue": "เกินกำหนด",
    "dashboard.noSummaryRows": "ไม่มีข้อมูลสรุป",
    "dashboard.pdfModalTitle": "เลือกช่วงเวลาสำหรับดาวน์โหลด",
    "dashboard.dateFrom": "ตั้งแต่วันที่",
    "dashboard.dateTo": "ถึงวันที่",
    "dashboard.download": "ดาวน์โหลด",
    "dashboard.slaOverdue": "เกินกำหนด",
    "dashboard.slaOnTime": "ทันเวลา",
    "dashboard.supervisorPrefix": "หัวหน้างาน:",
    "dashboard.status.pending": "รอดำเนินการ",
    "dashboard.status.assigned": "มอบหมายช่าง",
    "dashboard.status.in_progress": "กำลังดำเนินการ",
    "dashboard.status.done": "เสร็จสิ้น",
    "dashboard.status.welldone": "เสร็จสิ้น (ประเมินแล้ว)",
    "dashboard.status.cancelled": "ยกเลิก",
    "dashboard.status.rejected": "ปฏิเสธ",
    "dashboard.field.ticketNo": "เลขที่ใบแจ้งซ่อม",
    "dashboard.field.dateInformed": "วันที่แจ้ง",
    "dashboard.field.reporter": "ผู้แจ้ง / หน่วยงาน",
    "dashboard.field.reporterName": "ผู้แจ้ง",
    "dashboard.field.department": "หน่วยงาน",
    "dashboard.field.category": "ประเภทงาน",
    "dashboard.field.status": "สถานะ",
    "dashboard.field.sla": "SLA",
    "dashboard.field.assignee": "ผู้รับผิดชอบ",
    "dashboard.field.closedDate": "วันที่ปิดงาน",
    "dashboard.techDashboardSubtitle":
      "ภาพรวมงานซ่อมและประสิทธิภาพการทำงานของคุณ",
    "dashboard.projectAnalytics": "การวิเคราะห์งาน",
    "dashboard.workProgress": "ความคืบหน้าของงาน",
    "dashboard.workProgressSubtitle": "สัดส่วนงานตามหมวดหมู่",
    "dashboard.workloadLabel": "ภาระงานปัจจุบัน",
    "dashboard.noActiveWork": "ไม่มีงานที่ได้รับมอบหมาย",
    "dashboard.assignedPercentPrefix": "สัดส่วนที่ได้รับ",
    "dashboard.remainingAccumulatedShare": "เศษสะสมคงเหลือ",
    "dashboard.ticketDetailsSubtitle": "รายการงานซ่อมที่อยู่ในความรับผิดชอบ",
    "dashboard.supervisorTicketDetailsSubtitle":
      "รายการงานแจ้งซ่อมทั้งหมดในช่วงเวลาที่เลือก",
    "dashboard.highlight": "ภาพรวม (Highlight)",
    "dashboard.highlightSubtitle": "แนวโน้มจำนวนงานแจ้งซ่อมตามช่วงเวลาที่เลือก",
    "dashboard.donutCompleted": "ปิดงานแล้ว",
    "dashboard.donutRemaining": "รอดำเนินการ",
    "dashboard.barDatasetLabel": "จำนวนงานที่ได้รับ",
    "dashboard.subtitleToday": "จำนวน Ticket แยกตามช่วงเวลา",
    "dashboard.subtitleWeek": "จำนวน Ticket แยกตามวัน",
    "dashboard.subtitleMonth": "จำนวน Ticket แยกตามวันที่",
    "dashboard.subtitleHalfYear": "จำนวน Ticket แยกตามเดือน",
    "dashboard.subtitleYear": "จำนวน Ticket แยกตามเดือน",
    "dashboard.subtitleAll": "จำนวน Ticket แยกตามปี",
    "dashboard.pdfPeriodTpl": "ข้อมูลตั้งแต่วันที่ {from} ถึง {to}",
    "dashboard.shortMonth1": "ม.ค.",
    "dashboard.shortMonth2": "ก.พ.",
    "dashboard.shortMonth3": "มี.ค.",
    "dashboard.shortMonth4": "เม.ย.",
    "dashboard.shortMonth5": "พ.ค.",
    "dashboard.shortMonth6": "มิ.ย.",
    "dashboard.shortMonth7": "ก.ค.",
    "dashboard.shortMonth8": "ส.ค.",
    "dashboard.shortMonth9": "ก.ย.",
    "dashboard.shortMonth10": "ต.ค.",
    "dashboard.shortMonth11": "พ.ย.",
    "dashboard.shortMonth12": "ธ.ค.",

    "ticketDetail.title": "รายละเอียดใบแจ้งซ่อม",
    "ticketDetail.timeline.waitShort": "รอ",
    "ticketDetail.timeline.submitted": "แจ้งซ่อม",
    "ticketDetail.timeline.received": "รับเรื่องแล้ว",
    "ticketDetail.timeline.inRepair": "กำลังดำเนินการซ่อม",
    "ticketDetail.timeline.eval": "ประเมินการบริการ",
    "ticketDetail.timeline.awaitingEval": "รอประเมิน",
    "ticketDetail.timeline.done": "เสร็จสิ้น",
    "ticketDetail.role.user": "User",
    "ticketDetail.role.supervisor": "Supervisor",
    "ticketDetail.role.technician": "Technician",
    "ticketDetail.role.userConfirm": "User Confirm",
    "ticketDetail.rating.n1": "ปรับปรุง",
    "ticketDetail.rating.n2": "พอใช้",
    "ticketDetail.rating.n3": "ปานกลาง",
    "ticketDetail.rating.n4": "ดี",
    "ticketDetail.rating.n5": "ดีมาก",
    "ticketDetail.evalPlease": "กรุณาให้คะแนนความพึงพอใจ",
    "ticketDetail.evalResult": "ผลการประเมินความพึงพอใจ",
    "ticketDetail.evalSubmit": "ยืนยันการประเมิน",
    "ticketDetail.saving": "กำลังบันทึก...",
    "ticketDetail.cancelWhy": "สาเหตุการยกเลิกงาน",
    "ticketDetail.noReason": "ไม่ระบุเหตุผล",
    "ticketDetail.assignees": "ผู้รับผิดชอบงาน",
    "ticketDetail.supervisorAssigner": "หัวหน้าผู้มอบหมาย:",
    "ticketDetail.when": "เมื่อ:",
    "ticketDetail.technician": "ช่างผู้ปฏิบัติงาน:",
    "ticketDetail.waitTechAccept": "(รอช่างกดรับงาน)",
    "ticketDetail.tech.acceptJob": "รับงาน",
    "ticketDetail.finishedWhen": "ซ่อมเสร็จเมื่อ:",
    "ticketDetail.sectionReport": "ข้อมูลการแจ้งซ่อม",
    "ticketDetail.ticketNo": "เลขที่ใบแจ้งซ่อม (Ticket No.)",
    "ticketDetail.reporter": "ชื่อผู้แจ้ง:",
    "ticketDetail.affiliation": "หน่วยงาน:",
    "ticketDetail.section": "หน่วยงานผู้รับแจ้ง:",
    "ticketDetail.onBehalf": "แจ้งแทน:",
    "ticketDetail.phoneMobile": "เบอร์โทรศัพท์ส่วนตัว:",
    "ticketDetail.phoneWork": "เบอร์โทรศัพท์ที่ทำงาน:",
    "ticketDetail.jobType": "ประเภทงานซ่อม:",
    "ticketDetail.workArea": "พื้นที่ปฏิบัติงาน:",
    "ticketDetail.timeSlot": "ช่วงเวลาที่สะดวก:",
    "ticketDetail.mapPoint": "แผนที่จุดแจ้งซ่อม:",
    "ticketDetail.openMaps": "เปิดใน Google Maps",
    "ticketDetail.problem": "ปัญหา/งานซ่อม:",
    "ticketDetail.assetCode": "รหัสครุภัณฑ์:",
    "ticketDetail.photoBefore": "รูปภาพประกอบ (ก่อนซ่อม):",
    "ticketDetail.workOutcome": "สรุปผลการดำเนินงาน",
    "ticketDetail.fixDetail": "รายละเอียดการแก้ไข:",
    "ticketDetail.photoAfter": "รูปจากช่าง (หลังซ่อม):",
    "ticketDetail.close": "ปิด",
    "ticketDetail.outdoor": "นอกอาคาร",
    "ticketDetail.locationBuilding": "ตึก {b} / ห้อง {r}",
    "ticketDetail.mapPinTitle": "จุดแจ้งซ่อม",
    "ticketDetail.swalEvalOk": "บันทึกการประเมินเรียบร้อย",
    "ticketDetail.swalWarn": "แจ้งเตือน",
    "ticketDetail.swalError": "เกิดข้อผิดพลาด",
    "ticketDetail.swalSaveFail": "ไม่สามารถบันทึกได้",
    "ticketDetail.techUnknown": "ไม่ระบุชื่อ (ID Only)",
    "ticketDetail.techPending": "- (รอดำเนินการ)",
    "ticketDetail.cancelTicketBtn": "ยกเลิกงานซ่อม",
    "ticketDetail.deptCombined": "หน่วยงาน:",
    "ticketDetail.phonePersonalShort": "เบอร์โทรส่วนตัว:",
    "ticketDetail.phoneWorkShort": "เบอร์โทรที่ทำงาน:",
    "ticketDetail.phoneTechnician": "เบอร์โทรช่าง:",
    "ticketDetail.technicianPhone": "เบอร์โทรช่าง:",
    "ticketDetail.otherCatBanner": 'งานประเภท "อื่นๆ" - ต้องมอบหมายหน่วยงาน',
    "ticketDetail.userSpecifiedJob": "ประเภทงานที่ผู้ใช้ระบุ:",
    "ticketDetail.pickDept": "เลือกหน่วยงานที่เหมาะสม:",
    "ticketDetail.placeholderDept": "-- กรุณาเลือกหน่วยงาน --",
    "ticketDetail.assigningDept": "กำลังมอบหมาย...",
    "ticketDetail.assignDeptBtn": "มอบหมายหน่วยงาน",
    "ticketDetail.assignTechHeading": "มอบหมายงานให้ช่าง",
    "ticketDetail.changeTechHeading": "เปลี่ยนช่างผู้ปฏิบัติงาน",
    "ticketDetail.pickTech": "เลือกช่างผู้ปฏิบัติงาน:",
    "ticketDetail.placeholderTech": "-- กรุณาเลือกช่าง --",
    "ticketDetail.addAssignee": "เพิ่มช่าง",
    "ticketDetail.assignmentNetworkError":
      "เบราว์เซอร์เชื่อมต่อ API มอบหมายงานไม่ได้ กรุณารีเฟรชแล้วลองใหม่",
    "ticketDetail.confirmAssignTech": "ยืนยันการมอบหมาย",
    "ticketDetail.selectTechFirst": "กรุณาเลือกช่างก่อน",
    "ticketDetail.assignSelectedTech": "มอบหมายงานให้ช่างที่เลือก",
    "ticketDetail.confirmChangeTechBtn": "ยืนยัน",
    "ticketDetail.waitUserEval": "รอ User ประเมิน",
    "ticketDetail.adminAssignBox": "ข้อมูลการมอบหมายโดย Admin",
    "ticketDetail.originalUserType": "ประเภทงานเดิมที่ User ระบุ:",
    "ticketDetail.adminAssignedDeptLabel": "หน่วยงานที่ Admin มอบหมาย:",
    "ticketDetail.adminAssignerLabel": "Admin ผู้มอบหมาย:",
    "ticketDetail.assignDateLabel": "วันที่มอบหมาย:",
    "ticketDetail.supervisorLabelRole": "หัวหน้าผู้มอบหมาย (Supervisor):",
    "ticketDetail.technicianLabelRole": "ช่างผู้ปฏิบัติงาน (Technician):",
    "ticketDetail.techLeader": "หัวหน้างาน",
    "ticketDetail.techHelper": "ผู้ช่วย",
    "ticketDetail.assignInline": "มอบหมาย",
    "ticketDetail.maxTechHint":
      "เพิ่มได้สูงสุด 3 คน (หัวหน้างาน 1 + ผู้ช่วย 2)",
    "ticketDetail.changeTechShort": "เปลี่ยนช่าง",
    "ticketDetail.otherAssignedSuffix": "(มอบหมายแล้ว)",
    "ticketDetail.otherWaitSuffix": "(รอมอบหมาย)",
    "ticketDetail.noLocationDetail": "ไม่ระบุรายละเอียด",
    "ticketDetail.timeSuffix": "น.",
    "ticketDetail.youMarker": "(คุณ)",
    "ticketDetail.noName": "ไม่ระบุชื่อ",
    "ticketDetail.techNotYet": "- (ยังไม่ระบุ)",
    "ticketDetail.confirmAssignDeptTitle": "ยืนยันการมอบหมายหน่วยงาน?",
    "ticketDetail.confirmAssignDeptHtml":
      "คุณต้องการมอบหมายงานนี้ให้<br><strong>{name}</strong><br>ใช่หรือไม่?",
    "ticketDetail.assignDeptSuccess":
      "มอบหมายหน่วยงานเรียบร้อยแล้ว ระบบได้ส่ง Email แจ้งเตือนไปยัง Supervisor ของหน่วยงานแล้ว",
    "ticketDetail.assignDeptFail": "ไม่สามารถมอบหมายหน่วยงานได้",
    "ticketDetail.fetchCategoriesFail": "ไม่สามารถดึงข้อมูลหน่วยงานได้",
    "ticketDetail.connectFail": "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้",
    "ticketDetail.confirmChangeTechTitle": "ยืนยันการเปลี่ยนช่าง?",
    "ticketDetail.confirmAssignTitle": "ยืนยันการมอบหมาย?",
    "ticketDetail.confirmChangeTechHtml":
      "คุณต้องการเปลี่ยนช่างผู้ปฏิบัติงานให้เป็น<br><strong>{name}</strong><br>ใช่หรือไม่?",
    "ticketDetail.confirmAssignTechHtml":
      "คุณต้องการมอบหมายงานนี้ให้<br><strong>{name}</strong><br>ใช่หรือไม่?",
    "ticketDetail.selectedTechFallback": "ช่างที่เลือก",
    "ticketDetail.assignTechOk":
      "มอบหมายงานเรียบร้อยแล้ว ระบบได้ส่ง Email แจ้งเตือนไปยังช่างแล้ว",
    "ticketDetail.changeTechOk": "เปลี่ยนช่างเรียบร้อยแล้ว",
    "ticketDetail.assignTechFail": "ไม่สามารถมอบหมายงานได้",
    "ticketDetail.cancelTicketTitle": "ยืนยันการยกเลิกงานซ่อม?",
    "ticketDetail.cancelTicketHtml":
      'คุณแน่ใจหรือไม่ที่จะยกเลิกงานซ่อมนี้? การยกเลิกไม่สามารถย้อนกลับได้<br><br><b style="color:red;">*กรุณาระบุเหตุผลการยกเลิกงาน</b>',
    "ticketDetail.cancelPlaceholder": "กรอกเหตุผล...",
    "ticketDetail.cancelAria": "เหตุผลการยกเลิก",
    "ticketDetail.cancelConfirmBtn": "ยืนยัน",
    "ticketDetail.closeBtn": "ยกเลิก",
    "ticketDetail.closeDetail": "ปิดหน้ารายละเอียด",
    "ticketDetail.removeAssignee": "นำออก",
    "jobList.uploadIcon": "อัปโหลด",
    "ticketDetail.cancelReasonRequired": "กรุณาระบุเหตุผลการยกเลิกงาน!",
    "ticketDetail.cancelOk": "ยกเลิกงานซ่อมเรียบร้อยแล้ว",
    "ticketDetail.cancelFail": "ไม่สามารถยกเลิกงานซ่อมได้",
    "ticketDetail.supervisor.forwardOther": "ส่งต่อไปยังหน่วยงานอื่น",
    "ticketDetail.supervisor.forwardOtherShort": "ส่งงานให้หน่วยงานอื่น",
    "ticketDetail.supervisor.pickTargetDept": "เลือกหน่วยงานปลายทาง:",
    "ticketDetail.supervisor.placeholderDept": "-- กรุณาเลือกหน่วยงาน --",
    "ticketDetail.supervisor.yourDeptTag": "(หน่วยงานของคุณ)",
    "ticketDetail.supervisor.processing": "กำลังดำเนินการ...",
    "ticketDetail.supervisor.confirmForward": "ยืนยันการส่งต่อ",
    "ticketDetail.supervisor.forwardConfirmTitle": "ยืนยันการส่งต่อ?",
    "ticketDetail.supervisor.forwardConfirmText":
      "คุณต้องการส่งต่องานนี้ให้หน่วยงานอื่นใช่หรือไม่?",
    "ticketDetail.supervisor.forwardOk":
      "ส่งต่องานซ่อมให้หน่วยงานอื่นเรียบร้อยแล้ว",
    "ticketDetail.supervisor.forwardFail": "ไม่สามารถส่งต่องานได้",
    "ticketDetail.supervisor.waitEvalLine": "รอ User ประเมิน",
    "ticketDetail.tech.pageTitle": "รายละเอียดงานซ่อม",
    "ticketDetail.tech.newJobTitle": "งานใหม่ได้รับมอบหมาย",
    "ticketDetail.tech.newJobHint":
      "ตรวจสอบรายละเอียดงานซ่อม แล้วกดรับงานเพื่อเริ่มดำเนินการ",
    "ticketDetail.tech.closeSection": "รายงานผลการซ่อม (ปิดงาน)",
    "ticketDetail.tech.closeWorkHeading": "รายงานผลการซ่อม (ปิดงาน)",
    "ticketDetail.tech.repairDetailLabel": "รายละเอียดการซ่อม/แก้ไข:",
    "ticketDetail.tech.fixDetailLabel": "รายละเอียดการซ่อม/แก้ไข:",
    "ticketDetail.tech.repairPlaceholder":
      "อธิบายสิ่งที่ได้ดำเนินการซ่อมแซม...",
    "ticketDetail.tech.fixDetailPlaceholder":
      "อธิบายสิ่งที่ได้ดำเนินการซ่อมแซม...",
    "ticketDetail.tech.photoAfterRequired": "รูปภาพหลังซ่อมเสร็จ:",
    "ticketDetail.tech.photoAfterLabel": "รูปภาพหลังซ่อมเสร็จ:",
    "ticketDetail.tech.choosePhoto": "เลือกรูปภาพ...",
    "ticketDetail.tech.pickPhotoPlaceholder": "เลือกรูปภาพ...",
    "ticketDetail.tech.photoHint": "รองรับไฟล์ภาพ JPG, PNG ขนาดไม่เกิน 10MB",
    "ticketDetail.tech.confirmClose": "ยืนยันการปิดงาน",
    "ticketDetail.tech.uploading": "กำลังอัปโหลด...",
    "ticketDetail.tech.sparePartsLabel": "อะไหล่ที่ใช้:",
    "ticketDetail.tech.sparePartsPlaceholder":
      "ระบุชื่ออะไหล่ หรือ - หากไม่ได้ใช้",
    "ticketDetail.tech.quantityLabel": "ปริมาณ:",
    "ticketDetail.tech.costLabel": "มูลค่า (บาท):",
    "ticketDetail.parts.title": "รายการอะไหล่ / อุปกรณ์ที่ใช้",
    "ticketDetail.parts.itemNo": "ลำดับ",
    "ticketDetail.parts.name": "ชื่ออะไหล่ / อุปกรณ์",
    "ticketDetail.parts.qty": "จำนวน",
    "ticketDetail.parts.unitPrice": "ราคาต่อหน่วย (บาท)",
    "ticketDetail.parts.lineTotal": "รวม (บาท)",
    "ticketDetail.parts.totalCost": "มูลค่ารวมทั้งสิ้น",
    "ticketDetail.parts.noParts": "ไม่ใช้อะไหล่",
    "ticketDetail.parts.noneRecorded": "ไม่มีการบันทึกการใช้อะไหล่",
    "ticketDetail.parts.currency": "บาท",
    "ticketDetail.tech.selfReporterBadge": "แจ้งซ่อมโดยคุณ",
    "ticketDetail.tech.statusLine": "สถานะ:",
    "ticketDetail.tech.waitReporterEval":
      "งานนี้ดำเนินการเสร็จสิ้นแล้ว รอผู้แจ้งประเมิน",
    "ticketDetail.tech.jobWelldone": "งานซ่อมเสร็จสิ้นแล้ว",
    "ticketDetail.tech.etaTitle": "ระยะเวลาซ่อมโดยประมาณ",
    "ticketDetail.tech.etaHint":
      "ผู้แจ้งจะเห็นข้อมูลนี้ในหน้าติดตามสถานะโดยอัตโนมัติ",
    "ticketDetail.tech.etaPromptHint":
      "โปรดเลือกระยะเวลาซ่อมโดยประมาณก่อนเข้าสู่หน้ารายงานผลการซ่อม",
    "ticketDetail.tech.etaLabel": "เลือกช่วงเวลา",
    "ticketDetail.tech.etaCustomLabel": "ระบุวันที่หรือรายละเอียดเพิ่มเติม",
    "ticketDetail.tech.etaCustomPlaceholder":
      "เช่น: ภายใน 2 สัปดาห์, รออะไหล่จากซัพพลายเออร์",
    "ticketDetail.tech.saveEtaBtn": "บันทึกระยะเวลา",
    "ticketDetail.tech.etaSaveBtn": "บันทึกระยะเวลา",
    "ticketDetail.tech.etaSaving": "กำลังบันทึก...",
    "ticketDetail.tech.etaSavedPrefix": "บันทึกแล้ว:",
    "ticketDetail.tech.etaNone": "ไม่ระบุ",
    "ticketDetail.tech.eta1_3d": "1 - 3 วัน",
    "ticketDetail.tech.eta3_7d": "3 - 7 วัน",
    "ticketDetail.tech.etaWaitingParts": "รออะไหล่ (> 7 วัน)",
    "ticketDetail.tech.etaPostponed": "เลื่อนซ่อม",
    "ticketDetail.tech.etaPostponeLimit": "เลื่อนซ่อม (ครบจำนวนการเลื่อนซ่อม)",
    "ticketDetail.tech.etaCustomOption": "ระบุเอง",
    "ticketDetail.tech.step1Tab": "บันทึกระยะเวลาซ่อม (ETA)",
    "ticketDetail.tech.step2Tab": "บันทึกผลการซ่อมแซมและปิดงาน",
    "ticketDetail.tech.step1Heading": "ขั้นตอนที่ 1: ระยะเวลาซ่อมโดยประมาณ",
    "ticketDetail.tech.step2Heading": "ขั้นตอนที่ 2: รายงานผลการซ่อม (ปิดงาน)",
    "ticketDetail.tech.step2Subheading":
      "กรอกรายละเอียดการดำเนินงานซ่อมแซม อะไหล่ และแนบภาพถ่ายเพื่อปิดงาน",
    "ticketDetail.tech.ifRepairFinished": "หากดำเนินการซ่อมแซมเสร็จสิ้นแล้ว:",
    "ticketDetail.tech.goToCloseJob": "ไปยังขั้นตอนปิดงานซ่อม ➔",
    "ticketDetail.tech.estimatedTimeSummary": "ระยะเวลาซ่อมโดยประมาณ:",
    "ticketDetail.tech.editEtaBtn": "แก้ไขระยะเวลาซ่อม (ETA)",
    "ticketDetail.tech.onePhotoLimit": "(1 รูป)",
    "ticketDetail.tech.dragDropClick": "คลิกเพื่อเลือกรูป",
    "ticketDetail.tech.dragDropOr": "หรือลากไฟล์มาวาง",
    "ticketDetail.tech.changePhoto": "เปลี่ยนรูป",
    "ticketDetail.tech.removePhoto": "ลบ",
    "ticketDetail.tech.partsHeading": "อะไหล่/อุปกรณ์",
    "ticketDetail.tech.noPartsUsed": "ไม่ใช้อะไหล่",
    "ticketDetail.tech.partNameLabel": "ชื่ออะไหล่",
    "ticketDetail.tech.partNamePlaceholder": "ระบุชื่ออะไหล่",
    "ticketDetail.tech.partQtyLabel": "จำนวน",
    "ticketDetail.tech.partPriceLabel": "ราคาต่อหน่วย",
    "ticketDetail.tech.partTotalLabel": "รวม (บาท)",
    "ticketDetail.tech.addPartBtn": "เพิ่มอะไหล่/อุปกรณ์",
    "ticketDetail.tech.removePartTitle": "ลบรายการอะไหล่",
    "ticketDetail.tech.backToEta": "← ย้อนกลับไปขั้นตอนบันทึกระยะเวลา (ETA)",
    "ticketDetail.tech.supervisorWhen": "เมื่อ:",
    "ticketDetail.tech.youTechnician": "ช่างผู้ปฏิบัติงาน (คุณ):",
    "ticketDetail.tech.locationDetailLabel": "รายละเอียดสถานที่:",
    "ticketDetail.tech.problemLabel": "รายละเอียดปัญหา:",
    "ticketDetail.tech.photoAfterOptional": "รูปภาพประกอบ (ก่อนซ่อม):",
    "ticketDetail.tech.acceptConfirmTitle": "ยืนยันรับงาน",
    "ticketDetail.tech.acceptConfirmText": "คุณต้องการรับงานนี้ใช่หรือไม่?",
    "ticketDetail.tech.acceptConfirmBtn": "รับงาน",
    "ticketDetail.tech.acceptOkTitle": "รับงานเรียบร้อย",
    "ticketDetail.tech.acceptOkText": "สามารถเริ่มดำเนินการได้เลย",
    "ticketDetail.tech.acceptFail": "ไม่สามารถรับงานได้",
    "ticketDetail.tech.rejectJob": "ปฏิเสธงาน",
    "ticketDetail.tech.rejectNotice": "คุณได้ปฏิเสธงานซ่อมนี้แล้ว",
    "ticketDetail.tech.rejectReasonLabel": "เหตุผล: ",
    "ticketDetail.tech.rejectConfirmTitle": "ยืนยัน",
    "ticketDetail.tech.rejectConfirmText":
      "โปรดระบุเหตุผลในการปฏิเสธงานซ่อมนี้",
    "ticketDetail.tech.rejectPlaceholder": "ระบุเหตุผลในการปฏิเสธงาน",
    "ticketDetail.tech.rejectRequired": "กรุณาระบุเหตุผลในการปฏิเสธงาน",
    "ticketDetail.tech.rejectConfirmBtn": "ยืนยัน",
    "ticketDetail.tech.rejectOkTitle": "ปฏิเสธงานเรียบร้อย",
    "ticketDetail.tech.rejectOkText": "ระบบได้แจ้งผู้ดูแลเรียบร้อยแล้ว",
    "ticketDetail.tech.rejectFail": "ไม่สามารถปฏิเสธงานได้",
    "ticketDetail.tech.badgeAccepted": "รับงานแล้ว",
    "ticketDetail.tech.badgeRejected": "ปฏิเสธงาน",
    "ticketDetail.tech.badgeWaiting": "รอตอบรับ",
    "ticketDetail.tech.selfAssignBtn": "ฉันต้องการซ่อมเอง",
    "ticketDetail.tech.changeSelfAssignBtn": "เปลี่ยนเป็นฉันซ่อมเอง",
    "ticketDetail.tech.selfAssignTitle": "ยืนยันดำเนินการซ่อมเอง",
    "ticketDetail.tech.selfAssignText":
      "คุณต้องการรับผิดชอบและดำเนินการซ่อมรายการนี้ด้วยตนเองใช่หรือไม่? (ระบบจะมอบหมายงานให้คุณและเริ่มดำเนินการทันที)",
    "ticketDetail.tech.selfAssignConfirmBtn": "ยืนยันรับงานซ่อมเอง",
    "ticketDetail.tech.selfAssignOkTitle": "รับงานซ่อมเรียบร้อย",
    "ticketDetail.tech.selfAssignOkText":
      "ระบบได้บันทึกสถานะเริ่มดำเนินการแล้ว",
    "ticketDetail.tech.selfAssignFail": "เกิดข้อผิดพลาดในการมอบหมายงานซ่อมเอง",
    "ticketDetail.tech.etaCustomEmptyTitle": "กรุณาระบุรายละเอียด",
    "ticketDetail.tech.etaCustomEmptyText":
      'กรณีเลือก "ระบุเอง" กรุณากรอกรายละเอียดเพิ่มเติมด้วยครับ',
    "ticketDetail.tech.etaSaveOk": "บันทึกระยะเวลาซ่อมสำเร็จ",
    "ticketDetail.tech.etaSaveFail": "ไม่สามารถบันทึกระยะเวลาซ่อมได้",
    "ticketDetail.tech.noUserProfile": "ไม่พบข้อมูลโปรไฟล์ผู้ใช้",
    "ticketDetail.tech.selfAdmin": "ฉัน (Admin)",
    "ticketDetail.tech.selfSupervisor": "ฉัน (Supervisor)",
    "ticketDetail.tech.receivedJobsCount": "จำนวนงานที่ได้รับ",
    "ticketDetail.tech.imgOnlyError": "กรุณาเลือกไฟล์รูปภาพเท่านั้น",
    "ticketDetail.tech.invalidData": "ข้อมูลไม่ถูกต้อง",
    "ticketDetail.tech.invalidQty":
      "ปริมาณต้องเป็นตัวเลขที่มากกว่าหรือเท่ากับ 0",
    "ticketDetail.tech.invalidCost":
      "มูลค่าต้องเป็นตัวเลขที่มากกว่าหรือเท่ากับ 0",
    "ticketDetail.tech.partInvalidTitle": "ข้อมูลอะไหล่ไม่ถูกต้อง",
    "ticketDetail.tech.partInvalidText":
      "กรุณาระบุชื่อ จำนวนเต็มมากกว่า 0 และราคาต่อหน่วยตั้งแต่ 0 ขึ้นไป หรือเลือกไม่ใช้อะไหล่",
    "dashboard.invalidDateRangeTitle": "ช่วงวันที่ไม่ถูกต้อง",
    "dashboard.invalidDateRangeText":
      "วันที่สิ้นสุดต้องไม่น้อยกว่าวันที่เริ่มต้น",
    "dashboard.noDataPeriodText": "ไม่มีข้อมูลรายการ Ticket ในช่วงเวลาที่เลือก",
    "ticketDetail.tech.fileTooBig": "ขนาดไฟล์ใหญ่เกินไป กรุณาเลือกไฟล์ใหม่",
    "ticketDetail.tech.needPhotoTitle": "กรุณาอัปโหลดรูปภาพ",
    "ticketDetail.tech.needPhotoText": "ต้องอัปโหลดรูปหลังซ่อมเสร็จก่อนปิดงาน",
    "ticketDetail.tech.needDetailTitle": "กรุณากรอกรายละเอียด",
    "ticketDetail.tech.needDetailText":
      "ต้องระบุรายละเอียดการซ่อมแซมก่อนปิดงาน",
    "ticketDetail.tech.closeConfirmTitle": "ยืนยันปิดงาน",
    "ticketDetail.tech.closeConfirmText": "คุณต้องการปิดงานซ่อมนี้ใช่หรือไม่?",
    "ticketDetail.tech.closeOkTitle": "บันทึกสำเร็จ",
    "ticketDetail.tech.closeOkText": "ส่งงานซ่อมเรียบร้อยแล้ว",
    "ticketDetail.tech.closeFail": "ไม่สามารถส่งงานได้",
    "ticketDetail.statusFull.pending": "ส่งเรื่องแล้ว (รอทีมงาน)",
    "ticketDetail.statusFull.assigned": "รับเรื่องแล้ว (รอช่างรับงาน)",
    "ticketDetail.statusFull.in_progress": "กำลังดำเนินการ",
    "ticketDetail.statusFull.done": "ซ่อมเสร็จ",
    "ticketDetail.statusFull.welldone": "ปิดงานสมบูรณ์",

    "table.user.col.ticketNo": "เลขที่ใบแจ้งซ่อม",
    "table.user.col.reportedAt": "วัน/เวลา แจ้ง",
    "table.user.col.department": "ฝ่าย/แผนก",
    "table.user.col.detail": "รายละเอียด",
    "table.user.col.status": "สถานะ",
    "table.user.onBehalf": "แจ้งแทน:",
    "table.user.btn.track": "ติดตาม",
    "table.user.btn.cancelRequest": "ยกเลิกแจ้งซ่อม",
    "table.user.legend1": "ส่งเรื่องแล้ว",
    "table.user.legend2": "รับเรื่องแล้ว",
    "table.user.legend3": "กำลังดำเนินการ",
    "table.user.legend4": "เสร็จสิ้น",
    "table.user.status.pending": "ส่งเรื่องแล้ว",
    "table.user.status.assigned": "รับเรื่องแล้ว",
    "table.user.status.in_progress": "กำลังดำเนินการ",
    "table.user.status.done": "เสร็จสิ้น",
    "table.user.status.welldone": "เสร็จสิ้น",
    "table.user.status.cancelled": "ยกเลิกแล้ว",
    "table.user.unknownDept": "ไม่ระบุ",
    "table.user.swalCancelTitle": "ยืนยันการยกเลิก?",
    "table.user.swalCancelHtml":
      'คุณต้องการยกเลิกการแจ้งซ่อมนี้ใช่หรือไม่?<br><br><b style="color:red;">*กรุณาระบุเหตุผลการยกเลิกงาน</b>',
    "table.user.swalPlaceholder": "กรอกเหตุผล...",
    "table.user.swalReasonRequired": "กรุณาระบุเหตุผลการยกเลิกงาน!",
    "table.user.swalSuccess": "ยกเลิกสำเร็จ!",
    "table.user.swalSuccessText": "รายการแจ้งซ่อมถูกยกเลิกเรียบร้อยแล้ว",
    "table.user.swalErrCancel": "เกิดข้อผิดพลาดในการยกเลิก",
    "table.user.swalErrNetwork": "เชื่อมต่อเซิร์ฟเวอร์ไม่ได้",
    "table.user.btnConfirmCancel": "ยืนยัน",
    "table.user.btnBack": "ยกเลิก",
    "table.user.timeSuffix": "น.",
    "table.admin.col.ticketNo": "เลขที่ใบแจ้งซ่อม",
    "table.admin.col.reportedAt": "วัน/เวลา แจ้ง",
    "table.admin.col.reporter": "ผู้แจ้ง",
    "table.admin.col.detail": "รายละเอียดปัญหา",
    "table.admin.col.routing": "หน่วยงานที่รับแจ้ง",
    "table.admin.section": "ส่วนงาน",
    "table.admin.department": "ฝ่าย",
    "table.admin.jobType": "ประเภทงาน",
    "table.admin.col.status": "สถานะ",
    "table.admin.col.satisfaction": "ความพึงพอใจ",
    "table.admin.onBehalf": "แจ้งแทน:",
    "table.admin.btn.detail": "ดูรายละเอียด",
    "table.admin.btn.assignDept": "มอบหมายหน่วยงาน",
    "table.admin.legend1": "งานเข้าใหม่",
    "table.admin.legend2": "ส่งต่อหน่วยงานแล้ว",
    "table.admin.legend3": "กำลังซ่อม",
    "table.admin.legend4": "รอผู้แจ้งยืนยัน",
    "table.admin.legend5": "ยกเลิกแจ้งซ่อม",
    "table.admin.col.reporterDetail": "ผู้แจ้ง / รายละเอียด",
    "table.admin.col.actions": "จัดการ",
    "table.admin.status.pending": "งานเข้าใหม่",
    "table.admin.status.assigned": "ส่งต่อหน่วยงานแล้ว",
    "table.admin.status.in_progress": "กำลังซ่อม",
    "table.admin.status.done": "รอผู้แจ้งยืนยัน",
    "table.admin.status.welldone": "ปิดงานสมบูรณ์",
    "table.admin.status.cancelled": "ยกเลิกแล้ว",
    "table.admin.subAssigned": "(มอบหมายแล้ว)",
    "table.admin.subWaitAssign": "(รอมอบหมาย)",
    "table.admin.noUserName": "ไม่ระบุชื่อ",
    "table.tech.col.date": "วันที่",
    "table.tech.col.issueDetail": "รายละเอียดงาน / ผู้แจ้ง",
    "table.tech.reportedDateLabel": "วันที่แจ้งซ่อม",
    "table.tech.byPrefix": "โดย:",
    "table.tech.supervisorFallback": "หัวหน้า",
    "table.tech.reportedBy": "แจ้งโดย:",
    "table.tech.badgeReporter": "แจ้งซ่อม",
    "table.tech.badgeAssignee": "งานรับ",
    "table.tech.legend1": "งานใหม่",
    "table.tech.legend2": "รับงานแล้ว",
    "table.tech.legend3": "กำลังซ่อม",
    "table.tech.legend4": "ซ่อมเสร็จแล้ว",
    "table.tech.status.pending": "ส่งเรื่องแล้ว (รอทีมงาน)",
    "table.tech.status.assigned": "งานใหม่",
    "table.tech.status.in_progress": "กำลังซ่อม",
    "table.tech.status.done": "ซ่อมเสร็จแล้ว",
    "table.tech.status.welldone": "ปิดงานสมบูรณ์",
    "table.tech.status.cancelled": "ยกเลิกแล้ว",
    "table.tech.action.acceptJob": "รับงาน",
    "table.tech.action.finishJob": "เสร็จงาน",
    "table.tech.action.detail": "ดูรายละเอียด",
    "table.tech.noUserName": "ไม่ระบุชื่อ",
    "table.supervisor.col.reporterDetail": "ผู้แจ้ง / รายละเอียด",
    "table.supervisor.badgeReporter": "แจ้งซ่อม",
    "table.supervisor.badgeDept": "งานแผนก",
    "table.supervisor.noCategory": "ไม่ระบุหมวดหมู่",
    "table.supervisor.noUserName": "ไม่ระบุชื่อ",
    "table.supervisor.action.assign": "มอบหมายงาน",
    "table.supervisor.legend1": "งานเข้าใหม่",
    "table.supervisor.legend2": "มอบหมายช่างแล้ว",
    "table.supervisor.legend3": "กำลังซ่อม",
    "table.supervisor.legend4": "รอผู้แจ้งยืนยัน",
    "table.supervisor.status.pending": "งานเข้าใหม่",
    "table.supervisor.status.assigned": "มอบหมายช่างแล้ว",
    "table.supervisor.status.in_progress": "กำลังซ่อม",
    "table.supervisor.status.done": "รอผู้แจ้งยืนยัน",
    "table.supervisor.status.welldone": "ปิดงานสมบูรณ์",
    "table.supervisor.status.cancelled": "ยกเลิกแล้ว",
    "table.supervisor.action.track": "ติดตาม",

    "reportList.pageTitle": "งานซ่อม",
    "reportList.newRequest": "แจ้งซ่อม",
    "reportList.tabActive": "รายการแจ้งซ่อม",
    "reportList.tabHistory": "ประวัติแจ้งซ่อม",

    "sendReport.modalTitle": "แจ้งซ่อม",
    "sendReport.pageTitle": "แจ้งซ่อม",
    "sendReport.stepLabel": "ขั้นตอน {current} / {total}",
    "sendReport.nextStep": "ถัดไป",
    "sendReport.back": "ย้อนกลับ",
    "sendReport.submitRequest": "ส่งเรื่อง",
    "sendReport.sectionRepair": "รายละเอียดการซ่อม",
    "sendReport.sectionRepairHint": "ระบุปัญหาและสถานที่",
    "sendReport.jobType": "ประเภทงานซ่อม",
    "sendReport.frequentlyUsed": "หมวดหมู่ที่ใช้บ่อย",
    "sendReport.allCategories": "หมวดหมู่ทั้งหมด",
    "sendReport.searchCategoryPlaceholder": "ค้นหาหมวดหมู่แจ้งซ่อม...",
    "sendReport.noCategoriesFound": "ไม่พบหมวดหมู่ที่ตรงกับการค้นหา",
    "sendReport.noJobTypes": "ไม่พบข้อมูลประเภทงานซ่อม",
    "sendReport.otherTypeLabel": "ระบุประเภทงานอื่นๆ",
    "sendReport.otherTypePlaceholder": "ระบุประเภทงานซ่อมที่ต้องการ...",
    "sendReport.problemLabel": "ปัญหา/งานซ่อม",
    "sendReport.problemPlaceholder": "อธิบายปัญหาหรืองานซ่อมที่ต้องการ...",
    "sendReport.assetCodeLabel": "รหัสครุภัณฑ์",
    "sendReport.assetCodePlaceholder":
      "ระบุรหัสครุภัณฑ์ เช่น MFU-IT-2024-001 หรือ AC-501-01",
    "sendReport.assetCodeHint":
      "กรุณาระบุรหัสครุภัณฑ์ที่ติดอยู่บนตัวอุปกรณ์เพื่อความสะดวกรวดเร็วในการตรวจสอบ",
    "sendReport.imageLabel": "แนบรูปภาพ",
    "sendReport.pickOrCapture": "เลือกไฟล์/ถ่าย รูปภาพ",
    "sendReport.remove": "ลบ",
    "sendReport.changeImage": "เปลี่ยนรูป",
    "sendReport.takePhoto": "ถ่ายรูป",
    "sendReport.choosePhoto": "เลือกรูป",
    "sendReport.attachedPhotos": "รูปภาพที่แนบ",
    "sendReport.takeMore": "ถ่ายรูปเพิ่ม",
    "sendReport.chooseMore": "เลือกรูปเพิ่ม",
    "sendReport.takeOrAddPhoto": "ถ่ายรูป/เพิ่มรูป",
    "sendReport.viewFullPhoto": "ดูรูปภาพขนาดเต็ม",
    "sendReport.clickToView": "คลิกเพื่อดูรูปภาพ",
    "sendReport.prevPhoto": "รูปก่อนหน้า",
    "sendReport.nextPhoto": "รูปถัดไป",
    "sendReport.imageHint": "รองรับไฟล์รูปภาพ เช่น .jpg, .png",
    "sendReport.newRequestHint": "กรอกข้อมูลเพื่อแจ้งซ่อมในหน้าจอใหม่",
    "sendReport.workArea": "พื้นที่ปฏิบัติงาน",
    "sendReport.insideBuilding": "ในอาคาร",
    "sendReport.insideBuildingSub": "Building",
    "sendReport.outsideBuilding": "นอกอาคาร",
    "sendReport.outsideBuildingSub": "Outdoor",
    "sendReport.buildingRoom": "อาคาร - ห้อง",
    "sendReport.buildingPlaceholder":
      "ระบุ อาคาร-ห้อง หรือสถานที่ทรัพย์สิน (เช่น C3-201, ครัวลำดวน)",
    "sendReport.buildingFormatHint":
      "* กรุณาระบุรูปแบบ: อาคาร-ห้อง (เช่น C3-201)",
    "sendReport.buildingFound": "พบข้อมูลอาคาร:",
    "sendReport.propertySectionNotice":
      "หน่วยงานรับผิดชอบ: สำนักงานจัดการทรัพย์สินและรายได้ (ระบบจะส่งเรื่องไปยังสำนักงานจัดการทรัพย์สินและรายได้โดยตรง)",
    "sendReport.pinLocation": "ปักหมุดตำแหน่ง",
    "sendReport.mapMyLocation": "ระบุตำแหน่ง GPS ปัจจุบันของฉัน",
    "sendReport.mapResetMFU": "รีเซ็ตตำแหน่งไปยัง ม.แม่ฟ้าหลวง",
    "sendReport.mapMarkerTitle": "ตำแหน่งที่เลือก",
    "sendReport.mapGpsLoading": "กำลังระบุตำแหน่ง GPS...",
    "sendReport.mapGpsPermissionHint": "กรุณาอนุญาตการเข้าถึงตำแหน่งใน Browser",
    "sendReport.mapGpsDeniedAlert":
      "ไม่สามารถระบุ GPS อัตโนมัติได้ — กรุณาคลิกหรือลากหมุดบนแผนที่เพื่อเลือกตำแหน่ง",
    "sendReport.reporterSection": "ข้อมูลผู้แจ้ง",
    "sendReport.reporterHint": "รายละเอียดผู้ติดต่อ",
    "sendReport.reporterName": "ชื่อผู้แจ้ง",
    "sendReport.affiliation": "หน่วยงาน",
    "sendReport.affiliationNotSpecified": "ไม่ระบุหน่วยงาน",
    "sendReport.conflictAffiliationWarning":
      "พบข้อมูลสถานะบุคคลขัดแย้งกัน (นักศึกษา/บุคลากร) โปรดติดต่อผู้ดูแลระบบเพื่อแก้ไขความขัดแย้งก่อนส่งคำขอซ่อม",
    "sendReport.unverifiedAffiliationWarning":
      "ยังไม่มีข้อมูลสังกัดที่ผ่านการตรวจสอบจากระบบ Blendata ไม่สามารถส่งคำขอซ่อมได้",
    "sendReport.outageAffiliationWarning":
      "ระบบ Blendata ไม่พร้อมใช้งานชั่วคราวและยังไม่มีข้อมูลสังกัดเดิมที่ได้รับการยืนยัน",
    "sendReport.ratingLockTitle": "กรุณาประเมินผลงานก่อนแจ้งซ่อมใหม่",
    "sendReport.ratingLockMessage": "คุณมีงานซ่อมที่เสร็จสิ้นแล้วรอการประเมินความพึงพอใจ {count} รายการ{ticketNo} กรุณาประเมินผลงานก่อนแจ้งซ่อมใหม่",
    "sendReport.goToRating": "ไปที่แบบประเมิน",
    "sendReport.onBehalfLabel": "แจ้งแทน (ระบุชื่อผู้ต้องการแจ้งซ่อม)",
    "sendReport.onBehalfPlaceholder": "ระบุชื่อผู้แจ้งแทน (ถ้ามี)",
    "sendReport.personalPhone": "เบอร์โทรศัพท์ส่วนตัว",
    "sendReport.workPhone": "เบอร์โทรศัพท์ที่ทำงาน",
    "sendReport.phonePlaceholderMobile": "เช่น 0900000000",
    "sendReport.phonePlaceholderWork": "เช่น 021234567",
    "sendReport.availability": "วันที่และช่วงเวลาที่สะดวก",
    "sendReport.dateLabel": "วันที่:",
    "sendReport.datePlaceholder": "วว/ดด/ปปปป",
    "sendReport.startLabel": "เริ่ม:",
    "sendReport.endLabel": "สิ้นสุด:",
    "sendReport.availabilityHint": "เลือกวันที่และช่วงเวลาที่สะดวกในการซ่อม",
    "sendReport.cancel": "ยกเลิก",
    "sendReport.confirm": "ยืนยัน",
    "sendReport.submitting": "กำลังส่ง...",
    "sendReport.defaultFirstName": "ผู้ใช้",
    "sendReport.defaultLastName": "งาน",
    "sendReport.timeSuffix": "เวลา",
    "sendReport.errEndAfterStart":
      "เวลาสิ้นสุดต้องมากกว่าเวลาเริ่ม และ ไม่สามารถข้ามวันได้",
    "sendReport.errImageOnly": "กรุณาเลือกไฟล์รูปภาพเท่านั้น",
    "sendReport.optimizingImage":
      "กำลังปรับขนาดรูปภาพอัตโนมัติ (ไม่เกิน 1MB)...",
    "sendReport.errImageSize": "ไฟล์ภาพขนาดใหญ่เกินไป",
    "sendReport.errImageProcess": "เกิดข้อผิดพลาดในการประมวลผลรูปภาพ",
    "sendReport.errPhoneRequired": "กรุณากรอกเบอร์โทรศัพท์ส่วนตัว",
    "sendReport.errPhoneDigits": "กรุณากรอกเบอร์โทร 9–10 หลัก (ตัวเลขเท่านั้น)",
    "sendReport.errPickDate": "กรุณาเลือกวันที่สะดวก",
    "sendReport.errPickTime": "กรุณาเลือกช่วงเวลาที่สะดวก",
    "sendReport.errPickJobType": "กรุณาเลือกประเภทงานซ่อม",
    "sendReport.errSpecifyOther": "กรุณาระบุประเภทงานซ่อม",
    "sendReport.errWorkArea": "กรุณาเลือกพื้นที่ปฏิบัติงาน",
    "sendReport.errBuildingFormat":
      "กรุณาระบุอาคาร-ห้อง ให้ถูกต้องตามรูปแบบ (เช่น C3-201)",
    "sendReport.errMapPin": "กรุณาปักหมุดตำแหน่งบนแผนที่",
    "sendReport.errProblem": "กรุณาอธิบายปัญหาหรืองานซ่อม",
    "sendReport.errAssetCode": "กรุณาระบุรหัสครุภัณฑ์",
    "sendReport.errAttachImage": "กรุณาแนบรูปภาพ",
    "sendReport.swalIncompleteTitle": "ข้อมูลไม่ครบถ้วน",
    "sendReport.swalIncompleteText": "กรุณากรอกข้อมูลให้ครบถ้วนก่อนส่งแจ้งซ่อม",
    "sendReport.otherPrefix": "อื่นๆ",
    "sendReport.confirmLocation": "สถานที่:",
    "sendReport.outdoorLocated": "นอกอาคาร (ระบุพิกัดแล้ว)",
    "sendReport.confirmJobType": "ประเภทงาน:",
    "sendReport.confirmProblem": "ปัญหา:",
    "sendReport.confirmOnBehalf": "แจ้งแทน:",
    "sendReport.confirmPersonalPhone": "เบอร์ส่วนตัว:",
    "sendReport.confirmWorkPhone": "เบอร์ที่ทำงาน:",
    "sendReport.confirmAvailability": "เวลาที่สะดวก:",
    "sendReport.pickDate": "เลือกวันที่",
    "sendReport.pickTime": "เลือกเวลา",
    "sendReport.swalConfirmTitle": "ยืนยันข้อมูลการแจ้งซ่อม",
    "sendReport.swalEdit": "แก้ไข",
    "sendReport.swalSuccessTitle": "แจ้งซ่อมเรียบร้อย",
    "sendReport.swalErrorTitle": "เกิดข้อผิดพลาด",
    "sendReport.swalErrorText":
      "ไม่สามารถส่งข้อมูลแจ้งซ่อมได้ กรุณาลองใหม่อีกครั้ง",

    "mgmt.cancel": "ยกเลิก",
    "mgmt.save": "บันทึก",
    "mgmt.add": "เพิ่ม",
    "mgmt.edit": "แก้ไข",
    "mgmt.delete": "ลบ",
    "mgmt.actions": "จัดการ",
    "mgmt.confirm": "ยืนยัน",
    "mgmt.confirmDelete": "ยืนยันลบ",
    "mgmt.processing": "กำลังดำเนินการ...",
    "mgmt.loadingDelete": "กำลังลบข้อมูล...",
    "mgmt.loadingRead": "กำลังอ่านไฟล์...",
    "mgmt.loadingSave": "กำลังบันทึกข้อมูล...",
    "mgmt.loadingDept": "กำลังโหลดข้อมูลหน่วยงาน...",
    "mgmt.errFillAll": "กรุณากรอกข้อมูลให้ครบทุกช่อง",
    "mgmt.errFillAllShort": "กรุณากรอกข้อมูลให้ครบ",
    "mgmt.success": "สำเร็จ",
    "mgmt.warn": "แจ้งเตือน",
    "mgmt.error": "ผิดพลาด",
    "mgmt.editSaved": "แก้ไขข้อมูลแล้ว",
    "mgmt.saveSaved": "บันทึกข้อมูลเรียบร้อย",
    "mgmt.manage": "จัดการข้อมูล",
    "mgmt.edit": "แก้ไข",
    "mgmt.delete": "ลบ",
    "mgmt.confirm": "ยืนยัน",
    "mgmt.cancel": "ยกเลิก",
    "mgmt.save": "บันทึก",
    "mgmt.add": "เพิ่ม",
    "mgmt.deleteMultiple": "ลบรายการที่เลือก",
    "mgmt.confirmDelete": "ยืนยันการลบ",
    "mgmt.addSaved": "เพิ่มข้อมูลเรียบร้อย",
    "mgmt.deleteUserTitle": "ต้องการลบผู้ใช้นี้หรือไม่?",
    "mgmt.deleteUserBulkTitle": "ต้องการลบผู้ใช้ที่เลือกหรือไม่?",
    "mgmt.sureDelete": "คุณแน่ใจที่จะลบจริงๆใช่ไหม?",
    "mgmt.demoteUserSuffix": "จะถูกเปลี่ยนเป็น User ทั่วไป",
    "mgmt.demoteUsersBulk": "ผู้ใช้ที่เลือกทั้งหมดจะถูกเปลี่ยนเป็น User ทั่วไป",
    "mgmt.demoteSuccess": "ปรับสิทธิ์ผู้ใช้เป็น User เรียบร้อย",
    "mgmt.countItems": "จำนวน",
    "mgmt.itemsUnit": "รายการ",
    "mgmt.batchDeleted": "ลบสำเร็จ",
    "mgmt.batchFailed": "ล้มเหลว",
    "mgmt.batchAdded": "เพิ่มสำเร็จ",
    "mgmt.doneTitle": "เสร็จสิ้น",
    "mgmt.donePartial": "เสร็จสิ้น (บางรายการมีปัญหา)",
    "mgmt.noData": "ไม่มีข้อมูล",
    "mgmt.noDataToSave": "ไม่พบข้อมูลที่จะบันทึก",
    "mgmt.fileReadError": "ไม่สามารถอ่านไฟล์ได้ หรือรูปแบบไม่ถูกต้อง",
    "mgmt.errOperation": "เกิดข้อผิดพลาดในการทำรายการ กรุณาลองใหม่อีกครั้ง",
    "mgmt.accessDenied": "ท่านไม่มีสิทธิ์ในการเข้าถึงหรือดำเนินการในส่วนนี้",
    "mgmt.deleteUserFailed": "ไม่สามารถลบเจ้าหน้าที่ได้ กรุณาลองใหม่อีกครั้ง",
    "mgmt.cannotDelete": "ไม่สามารถลบได้",
    "mgmt.cannotDeleteActiveTasks": "มีงานที่กำลังดำเนินการอยู่ ไม่สามารถลบได้",
    "mgmt.activeTasksCount": "งานค้าง {count} รายการ",
    "mgmt.deleteBuildingTitle": "ยืนยันการลบ?",
    "mgmt.deleteBuildingBulkTitle": "ยืนยันการลบอาคาร?",
    "mgmt.deleteBuildingSure": "คุณแน่ใจที่จะลบจริงๆใช่ไหม?",
    "mgmt.deleteBuildingText": "คุณต้องการลบอาคาร",
    "mgmt.deleteBuildingAndRooms": "และห้องทั้งหมดใช่หรือไม่?",
    "mgmt.buildingWillDelete": "จะถูกลบถาวร",
    "mgmt.buildingsSelectedWillDelete": "อาคารที่เลือกทั้งหมด จะถูกลบถาวร",
    "mgmt.deleteBuildingBulkText": "คุณต้องการลบอาคารที่เลือกจำนวน",
    "mgmt.deleteOk": "ลบสำเร็จ",
    "mgmt.deleteBuildingDone": "ลบข้อมูลอาคารเรียบร้อยแล้ว",
    "mgmt.cannotDelete": "ไม่สามารถลบข้อมูลได้",
    "mgmt.editRoomSaved": "แก้ไขชื่อห้องเรียบร้อย",
    "mgmt.editFail": "แก้ไขไม่สำเร็จ",
    "mgmt.addFail": "เพิ่มข้อมูลไม่สำเร็จ",
    "mgmt.loadFail": "โหลดข้อมูลไม่สำเร็จ",
    "mgmt.saveFail": "บันทึกไม่สำเร็จ",
    "mgmt.deleteFail": "ลบไม่สำเร็จ",

    "jobList.pageTitle": "โครงสร้างส่วนงาน ฝ่าย และประเภทงานซ่อม",
    "jobList.pageSubtitle":
      "จัดการส่วนงาน (Section) ➔ ฝ่าย (Department) ➔ ประเภทงานแจ้งซ่อม (Job Types)",
    "jobList.addSection": "เพิ่มส่วนงานใหม่",
    "jobList.searchPlaceholder":
      "ค้นหาชื่อส่วนงาน, รหัส, ชื่อฝ่าย, หรือชื่องาน...",
    "jobList.collapseAll": "ย่อทั้งหมด",
    "jobList.expandAll": "ขยายทั้งหมด",
    "jobList.sectionsCount": "ส่วนงาน",
    "jobList.deptsCount": "ฝ่าย",
    "jobList.hasDataBadge": "มีข้อมูลฝ่ายและงาน",
    "jobList.noDataBadge": "ยังไม่มีประเภทงาน",
    "jobList.activeSectionsGroup": "ส่วนงานที่มีฝ่ายและประเภทงานแจ้งซ่อม",
    "jobList.activeSectionsDesc": "ส่วนงานที่เปิดรับใบแจ้งซ่อมและกำหนดประเภทงานในระบบ",
    "jobList.emptySectionsGroup": "ส่วนงานทั่วไปที่ยังไม่มีฝ่ายหรือประเภทงานแจ้งซ่อม",
    "jobList.emptySectionsDivider": "ส่วนงานที่ยังไม่มีการตั้งค่าฝ่ายหรือประเภทงาน",
    "jobList.emptySectionsHint": "ส่วนงานในสังกัดมหาวิทยาลัยที่ยังไม่ได้เปิดรับใบแจ้งซ่อม (คลิกที่ส่วนงานเพื่อเพิ่มฝ่ายหรือประเภทงาน)",
    "jobList.affiliatedDepts": "ฝ่ายในสังกัด",
    "jobList.jobTypesCount": "ประเภทงานแจ้งซ่อม",
    "jobList.addDept": "เพิ่มฝ่าย",
    "jobList.editSection": "แก้ไขส่วนงาน",
    "jobList.deleteSection": "ลบส่วนงาน",
    "jobList.activeStatus": "เปิดใช้งาน",
    "jobList.inactiveStatus": "ปิดใช้งาน",
    "jobList.jobsUnit": "งาน",
    "jobList.addJobInDept": "เพิ่มประเภทงาน",
    "jobList.editDept": "แก้ไข",
    "jobList.deleteDept": "ลบฝ่าย",
    "jobList.responsibleAreas": "พื้นที่ในความรับผิดชอบ",
    "jobList.emptyJobsInDept":
      "- ยังไม่มีประเภทงานในฝ่ายนี้ กดปุ่ม เพิ่มประเภทงาน ด้านบนได้เลย -",
    "jobList.centralJobsTitle": "งานส่วนกลาง (ไม่ระบุฝ่ายย่อย)",
    "jobList.addCentralJob": "เพิ่มงานส่วนกลาง",
    "jobList.emptyCentralJobs":
      "- ยังไม่มีประเภทงานส่วนกลาง กดปุ่ม เพิ่มงานส่วนกลาง ด้านบนได้เลย -",
    "jobList.iconCol": "ไอคอน",
    "jobList.jobNameCol": "ชื่อประเภทงานแจ้งซ่อม",
    "jobList.slaCol": "SLA มาตรฐาน",
    "jobList.statusCol": "สถานะ",
    "jobList.actionsCol": "การจัดการ",
    "jobList.clickToUploadIcon": "คลิกเพื่อเปลี่ยนรูปไอคอน",
    "jobList.hoursUnit": "ชม.",
    "jobList.active": "เปิด",
    "jobList.inactive": "ปิด",
    "jobList.collapse": "ย่อ",
    "jobList.expand": "ขยาย",
    "jobList.emptyDepts": "ยังไม่มีฝ่ายในส่วนงานนี้",
    "jobList.emptyDeptsSub":
      "คุณสามารถเพิ่มฝ่ายเพื่อจัดกลุ่มประเภทงานให้เป็นระเบียบได้ทันที",
    "jobList.addFirstDept": "เพิ่มฝ่ายแรกในส่วนงานนี้",
    "jobList.notFoundTitle": "ไม่พบข้อมูลส่วนงานที่ตรงกับคำค้นหา",
    "jobList.notFoundSub":
      'ลองค้นหาด้วยคำอื่น หรือกดปุ่ม "เพิ่มส่วนงานใหม่" ด้านบน',
    "jobList.editSectionTitle": "แก้ไขข้อมูลส่วนงาน (Section)",
    "jobList.addSectionTitle": "เพิ่มส่วนงานใหม่ (Section)",
    "jobList.sectionCodeLabel": "รหัสส่วนงาน (Section Code)",
    "jobList.sectionNameLabel": "ชื่อส่วนงาน (Section Name)",
    "jobList.sectionNameEnLabel": "ชื่อส่วนงานภาษาอังกฤษ (Section Name EN)",
    "jobList.sectionCodePlaceholder": "เช่น IT, MAINT, HR",
    "jobList.sectionNamePlaceholder": "เช่น ส่วนอาคารสถานที่",
    "jobList.sectionNameEnPlaceholder": "เช่น Division of Buildings and Grounds",
    "jobList.saveSectionBtn": "บันทึกการแก้ไข",
    "jobList.createSectionBtn": "เพิ่มส่วนงาน",
    "jobList.editDeptTitle": "แก้ไขข้อมูลฝ่าย (Department)",
    "jobList.addDeptTitle": "เพิ่มฝ่ายใหม่ในส่วนงาน",
    "jobList.affiliatedSection": "สังกัดส่วนงาน:",
    "jobList.deptCodeLabel": "รหัสฝ่าย (Department Code)",
    "jobList.deptNameLabel": "ชื่อฝ่าย (Department Name)",
    "jobList.deptNameEnLabel": "ชื่อฝ่ายภาษาอังกฤษ (Department Name EN)",
    "jobList.deptCodePlaceholder": "เช่น IT-SUP, ENG-MEP",
    "jobList.deptNamePlaceholder": "เช่น ฝ่ายบริการและสนับสนุนเทคนิค",
    "jobList.deptNameEnPlaceholder": "เช่น Technical Service and Support Division",
    "jobList.deptActiveSwitch": "เปิดใช้งานฝ่ายนี้",
    "jobList.deptInactiveSwitch": "ปิดใช้งานฝ่ายนี้",
    "jobList.saveDeptBtn": "บันทึกฝ่าย",
    "jobList.createDeptBtn": "เพิ่มฝ่าย",
    "jobList.editJobTitle": "แก้ไขประเภทงานแจ้งซ่อม",
    "jobList.addJobTitle": "เพิ่มประเภทงานแจ้งซ่อมใหม่",
    "jobList.sectionColon": "ส่วนงาน:",
    "jobList.deptColon": "ฝ่ายในสังกัด:",
    "jobList.affiliationColon": "สังกัด:",
    "jobList.jobNameLabel": "ชื่อประเภทงานแจ้งซ่อม",
    "jobList.jobNameEnLabel": "ชื่อประเภทงานภาษาอังกฤษ (Job Type Name EN)",
    "jobList.jobNamePlaceholder": "เช่น ไฟฟ้าและแสงสว่าง, ติดตั้งซอฟต์แวร์",
    "jobList.jobNameEnPlaceholder": "เช่น Computers & Equipment",
    "jobList.slaLabel": "SLA ระยะเวลาแก้ไขมาตรฐาน (ชั่วโมง)",
    "jobList.deptSelectLabel": "ฝ่ายในสังกัด",
    "jobList.centralOption": "-- งานส่วนกลาง (ไม่ระบุฝ่ายย่อย) --",
    "jobList.jobActiveSwitch": "เปิดใช้งานประเภทงานนี้",
    "jobList.jobInactiveSwitch": "ปิดใช้งานประเภทงานนี้",
    "jobList.saveJobBtn": "บันทึกประเภทงาน",
    "jobList.createJobBtn": "เพิ่มประเภทงาน",
    "jobList.deleteSectionConfirm": "ยืนยันการลบส่วนงาน",
    "jobList.deleteDeptConfirm": "ยืนยันการลบฝ่าย",
    "jobList.deleteJobConfirm": "ยืนยันการลบประเภทงาน",
    "jobList.sectionNameRequired": "กรุณากรอกชื่อส่วนงาน",
    "jobList.deptCodeAndNameRequired": "กรุณากรอกรหัสฝ่ายและชื่อฝ่ายให้ครบถ้วน",
    "jobList.jobNameAndSlaRequired": "กรุณาระบุชื่อประเภทงานและ SLA",
    "jobList.saveSectionSuccess": "บันทึกข้อมูลส่วนงานเรียบร้อย",
    "jobList.saveDeptSuccess": "บันทึกข้อมูลฝ่ายเรียบร้อย",
    "jobList.saveJobSuccess": "บันทึกประเภทงานเรียบร้อย",
    "jobList.deleteSectionSuccess": "ลบส่วนงานเรียบร้อย",
    "jobList.deleteDeptSuccess": "ลบฝ่ายเรียบร้อย",
    "jobList.deleteJobSuccess": "ลบประเภทงานเรียบร้อย",

    "staffMgmt.pageTitle": "จัดการข้อมูล เจ้าหน้าที่",
    "staffMgmt.totalStaff": "เจ้าหน้าที่ทั้งหมด",
    "staffMgmt.peopleUnit": "คน",
    "staffMgmt.scope": "ขอบเขตข้อมูล",
    "staffMgmt.allSections": "ทุกหน่วยงาน",
    "staffMgmt.searchPlaceholder":
      "ค้นหาชื่อ อีเมล หน่วยงาน หรืองานที่รับผิดชอบ",
    "staffMgmt.noResults": "ไม่พบเจ้าหน้าที่ที่ค้นหา",
    "staffMgmt.addStaff": "เพิ่มเจ้าหน้าที่",
    "staffMgmt.deleteSelected": "ลบที่เลือก",
    "staffMgmt.addModal": "เพิ่มเจ้าหน้าที่",
    "staffMgmt.editModal": "แก้ไขข้อมูลเจ้าหน้าที่",
    "staffMgmt.previewModal": "ตัวอย่างข้อมูลจากไฟล์",
    "staffMgmt.firstName": "ชื่อ",
    "staffMgmt.lastName": "นามสกุล",
    "staffMgmt.email": "อีเมล",
    "staffMgmt.invalidEmailFormat": "รูปแบบอีเมลไม่ถูกต้อง",
    "staffMgmt.phone": "เบอร์โทรศัพท์",
    "staffMgmt.userType": "ประเภทผู้ใช้",
    "staffMgmt.section": "ฝ่ายรับผิดชอบงาน",
    "staffMgmt.selectSection": "โปรดเลือกฝ่ายรับผิดชอบงาน",
    "staffMgmt.department": "หน่วยงาน",
    "staffMgmt.jobType": "ประเภทงานของช่าง",
    "staffMgmt.responsibleJob": "งานที่รับผิดชอบ",
    "staffMgmt.selectJobType": "โปรดเลือกประเภทงานของช่าง",
    "staffMgmt.jobTypeUnassigned": "ยังไม่กำหนด",
    "staffMgmt.allDepts": "ทุกหน่วยงาน",
    "staffMgmt.selectDept": "โปรดเลือกหน่วยงาน",
    "staffMgmt.addViaXlsx": "เพิ่มด้วยไฟล์ .xlsx",
    "staffMgmt.downloadTemplate": "ดาวน์โหลดตัวอย่าง",
    "staffMgmt.templateFile": "ตัวอย่างไฟล์",
    "staffMgmt.confirmBulk": "ยืนยันการเพิ่มข้อมูล",
    "staffMgmt.readyToImport": "พร้อมนำเข้า",
    "staffMgmt.invalidData": "ข้อมูลไม่สมบูรณ์",
    "staffMgmt.status": "สถานะ",
    "staffMgmt.previewSummary":
      "พบข้อมูลทั้งหมด {total} รายการ (พร้อมนำเข้า {ready} รายการ, ข้อมูลไม่สมบูรณ์ {invalid} รายการ)",
    "staffMgmt.onlyValidImported":
      "ระบบจะนำเข้าเฉพาะรายการที่ข้อมูลถูกต้องและครบถ้วนเท่านั้น",
    "staffMgmt.deptLabel": "หน่วยงาน:",
    "staffMgmt.yourDept": "แผนกของคุณ",

    "deptMgmt.title": "จัดการฝ่าย (Department)",
    "deptMgmt.addDept": "เพิ่มฝ่ายใหม่",
    "deptMgmt.editDept": "แก้ไขข้อมูลฝ่าย",
    "deptMgmt.filterSection": "กรองตามส่วนงาน",
    "deptMgmt.deptName": "ชื่อฝ่าย",
    "deptMgmt.section": "ส่วนงานที่สังกัด",
    "deptMgmt.code": "รหัสฝ่าย",
    "deptMgmt.name": "ชื่อฝ่าย",
    "deptMgmt.nameEn": "ชื่อฝ่ายภาษาอังกฤษ",
    "deptMgmt.nameEnPlaceholder": "เช่น Technical Support Division",
    "deptMgmt.status": "สถานะ",
    "deptMgmt.active": "ใช้งาน",
    "deptMgmt.inactive": "ปิดใช้งาน",
    "deptMgmt.activeStatus": "เปิดใช้งานฝ่ายนี้",
    "deptMgmt.allSections": "ทั้งหมด (ทุกส่วนงาน)",
    "deptMgmt.successAdd": "เพิ่มฝ่ายเรียบร้อย",
    "deptMgmt.successEdit": "แก้ไขข้อมูลฝ่ายเรียบร้อย",
    "deptMgmt.successDelete": "ลบฝ่ายเรียบร้อย",
    "deptMgmt.deleteTitle": "ยืนยันการลบฝ่าย",
    "deptMgmt.deleteMultipleTitle": "ยืนยันการลบหลายรายการ",

    "jobTypeMgmt.pageTitle": "จัดการข้อมูล ประเภทงาน",
    "jobTypeMgmt.addDept": "เพิ่มหน่วยงาน",
    "jobTypeMgmt.deptNameCol": "ชื่อหน่วยงาน",
    "jobTypeMgmt.jobTypesCol": "ข้อมูลประเภทงาน",
    "jobTypeMgmt.icon": "ไอคอน",
    "jobTypeMgmt.jobTypeName": "ชื่อประเภทงาน",
    "jobTypeMgmt.slaHours": "SLA (ชั่วโมง)",
    "jobTypeMgmt.slaShort": "SLA (ชม.)",
    "jobTypeMgmt.status": "สถานะ",
    "jobTypeMgmt.active": "เปิดใช้งาน",
    "jobTypeMgmt.inactive": "ปิดใช้งาน",
    "jobTypeMgmt.addDeptModal": "เพิ่มหน่วยงานใหม่",
    "jobTypeMgmt.editModal": "แก้ไขข้อมูลประเภทงาน",
    "jobTypeMgmt.deptNameInput": "ชื่อหน่วยงาน",
    "jobTypeMgmt.deptPlaceholder": "กรอกชื่อหน่วยงาน เช่น ไฟฟ้า, IT, อาคาร...",
    "jobTypeMgmt.colDelete": "ลบ",
    "jobTypeMgmt.addNewSub": "เพิ่มประเภทงานใหม่",
    "jobTypeMgmt.deleteSelectedSub": "ลบที่เลือก",
    "jobTypeMgmt.uploadIconHint": "คลิกเพื่ออัปโหลดรุป icon png/jpg",
    "jobTypeMgmt.removeImage": "ลบรูป",
    "jobTypeMgmt.warnDeptName": "กรุณากรอกชื่อหน่วยงาน",
    "jobTypeMgmt.addDeptOk": "เพิ่มหน่วยงานสำเร็จ",
    "jobTypeMgmt.removeIconTitle": "ยืนยันการลบรูปภาพ?",
    "jobTypeMgmt.removeIconText": "คุณต้องการลบรูปภาพไอคอนนี้ออกใช่หรือไม่?",
    "jobTypeMgmt.uploadToast": "อัปโหลดสำเร็จ",
    "jobTypeMgmt.uploadErr": "อัปโหลดรูปภาพไม่สำเร็จ",
    "jobTypeMgmt.delSubTitle": "ยืนยันการลบ?",
    "jobTypeMgmt.delSubText": "คุณต้องการลบประเภทงานนี้ใช่หรือไม่",
    "jobTypeMgmt.permanent": "ข้อมูลนี้จะถูกลบถาวร",
    "jobTypeMgmt.delBulkSubTitle": "ยืนยันการลบที่เลือก?",
    "jobTypeMgmt.delBulkSubText": "คุณต้องการลบประเภทงานจำนวน",
    "jobTypeMgmt.delBulkSubHint":
      "รายการใช่หรือไม่? (ลบออกจากตาราง ต้องกดบันทึกเพื่อมีผลจริง)",
    "jobTypeMgmt.delBulkSubLine":
      "คุณต้องการลบประเภทงานจำนวน {n} รายการใช่หรือไม่? (ลบออกจากตาราง ต้องกดบันทึกเพื่อมีผลจริง)",
    "jobTypeMgmt.warnComplete": "กรุณากรอกข้อมูลให้ครบถ้วน",
    "jobTypeMgmt.delDeptTitle": "ยืนยันการลบหน่วยงาน?",
    "jobTypeMgmt.delDeptText": "คุณต้องการลบหน่วยงาน",
    "jobTypeMgmt.delDeptLine": 'คุณต้องการลบหน่วยงาน "{name}" ใช่หรือไม่?',
    "jobTypeMgmt.delDeptSure": "จะถูกลบถาวร",
    "jobTypeMgmt.delDeptBulkTitle": "ยืนยันการลบหน่วยงาน?",
    "jobTypeMgmt.delDeptBulkText": "คุณต้องการลบหน่วยงานที่เลือกจำนวน",
    "jobTypeMgmt.deptsWillDelete": "หน่วยงานที่เลือกทั้งหมดจะถูกลบถาวร",
    "jobTypeMgmt.delDeptOk": "ลบหน่วยงานสำเร็จ",
    "jobTypeMgmt.deptWillDeleteLine": 'หน่วยงาน "{name}" จะถูกลบถาวร',
    "jobTypeMgmt.addJobType": "เพิ่มประเภทงาน",
    "jobTypeMgmt.addSubModal": "เพิ่มประเภทงานใหม่",
    "jobTypeMgmt.editSubModal": "แก้ไขประเภทงาน",
    "jobTypeMgmt.subNamePh": "โปรดระบุชื่อประเภทงาน",
    "jobTypeMgmt.slaPh": "โปรดระบุ SLA",
    "jobTypeMgmt.saveEditBtn": "บันทึกแก้ไข",
    "jobTypeMgmt.addSubOk": "เพิ่มประเภทงานเรียบร้อย",
    "jobTypeMgmt.cannotLoadDept": "ไม่สามารถโหลดข้อมูลหน่วยงานของคุณได้",
    "jobTypeMgmt.delSubNameText": "คุณต้องการลบประเภทงาน",
    "jobTypeMgmt.subWillDelete": "จะถูกลบถาวร",
    "jobTypeMgmt.delSubOk": "ลบประเภทงานเรียบร้อย",
    "jobTypeMgmt.delSubLine": 'คุณต้องการลบประเภทงาน "{name}" ใช่หรือไม่?',
    "jobTypeMgmt.subWillDeleteLine": 'ประเภทงาน "{name}" จะถูกลบถาวร',

    "buildingMgmt.pageTitle": "จัดการข้อมูล อาคาร",
    "buildingMgmt.addRoom": "เพิ่มข้อมูลห้อง",
    "buildingMgmt.buildingCol": "อาคาร",
    "buildingMgmt.roomCol": "ห้อง",
    "buildingMgmt.editTooltip": "แก้ไข",
    "buildingMgmt.deleteBuildingTooltip": "ลบอาคาร",
    "buildingMgmt.editRoomModal": "แก้ไขชื่อห้อง",
    "buildingMgmt.newRoomName": "ชื่อห้องใหม่",
    "buildingMgmt.addBuildingModal": "เพิ่มอาคารใหม่",
    "buildingMgmt.nameTh": "ชื่ออาคารภาษาไทย",
    "buildingMgmt.nameEn": "ชื่ออาคารภาษาอังกฤษ",
    "buildingMgmt.buildingName": "ชื่ออาคาร",
    "buildingMgmt.buildingPh": "กรอกชื่ออาคาร....",
    "buildingMgmt.roomName": "ชื่อห้อง",
    "buildingMgmt.roomPh": "กรอกชื่อห้อง....",
    "buildingMgmt.editDataModal": "แก้ไขข้อมูล",
    "buildingMgmt.roomNamesLabel": "ชื่อห้อง",
    "buildingMgmt.roomInputPh": "ชื่อห้อง",
    "buildingMgmt.addRoomBtn": "เพิ่มห้อง",
    "buildingMgmt.addOk": "เพิ่มข้อมูลเรียบร้อย",
    "buildingMgmt.saveEditBuilding": "บันทึกการแก้ไข",
    "buildingMgmt.deleteBuildingLine":
      'คุณต้องการลบอาคาร "{name}" และห้องทั้งหมดใช่หรือไม่?',
    "buildingMgmt.buildingWillDeleteLine": 'อาคาร "{name}" จะถูกลบถาวร',
    "buildingMgmt.deleteBulkLine":
      "คุณต้องการลบอาคารที่เลือกจำนวน {n} รายการ และห้องทั้งหมดใช่หรือไม่?",
    "buildingMgmt.deletingTitle": "กำลังลบข้อมูล...",
    "buildingMgmt.batchResultTitle": "ลบสำเร็จ",
    "buildingMgmt.batchResultHtml": "ลบสำเร็จ {ok} รายการ",
    "buildingMgmt.batchFailLine": "ล้มเหลว {fail} รายการ",
    "buildingMgmt.pageSubtitle": "จัดการข้อมูลอาคารและห้องสถานที่สำหรับระบบแจ้งซ่อม",
    "buildingMgmt.buildingsCount": "อาคาร",
    "buildingMgmt.roomsCount": "ห้อง",
    "buildingMgmt.expandAll": "ขยายทั้งหมด",
    "buildingMgmt.collapseAll": "ยุบทั้งหมด",
    "buildingMgmt.expand": "ขยาย",
    "buildingMgmt.collapse": "ยุบ",
    "buildingMgmt.noRooms": "ยังไม่มีข้อมูลห้องในอาคารนี้",
    "buildingMgmt.addRoomToBuilding": "เพิ่มห้องในอาคารนี้",
    "buildingMgmt.roomNumber": "#",
    "buildingMgmt.deleteRoomConfirm": "คุณต้องการลบห้อง \"{name}\" ใช่หรือไม่?",
    "buildingMgmt.deleteRoomTitle": "ยืนยันการลบห้อง",
    "buildingMgmt.selectAll": "เลือกทั้งหมด",
    "buildingMgmt.deselectAll": "ยกเลิกเลือก",
    "buildingMgmt.deleteSelected": "ลบอาคารที่เลือก",
    "buildingMgmt.quickAddRoom": "เพิ่มห้อง",

    "userManual.title": "คู่มือการใช้งานระบบ (User Manual & Workflow)",
    "userManual.tabUser": "ผู้แจ้งซ่อม (User)",
    "userManual.tabSupervisor": "หัวหน้างาน (Supervisor)",
    "userManual.tabTech": "ช่างซ่อม (Technician)",
    "userManual.tabStudentAffairs": "ส่วนพัฒนานักศึกษา (Student Affairs)",
    "userManual.tabAdmin": "ผู้ดูแลระบบ (Admin)",
    "userManual.userHeading": "ขั้นตอนการทำงานสำหรับ ผู้แจ้งซ่อม (User)",
    "userManual.u1t": "1. แจ้งซ่อม",
    "userManual.u1d": "ระบุรายละเอียดปัญหา สถานที่ และรูปแบบงาน",
    "userManual.u2t": "2. รอการตรวจสอบ",
    "userManual.u2d": "ติดตามสถานะจากหน้าตาราง (สถานะ: รอรับเรื่อง)",
    "userManual.u3t": "3. ช่างดำเนินการซ่อม",
    "userManual.u3d": "ช่างผู้รับผิดชอบเข้าดำเนินการซ่อมแซมหน้างาน",
    "userManual.u4t": "4. ยืนยันและประเมิน",
    "userManual.u4d":
      "เมื่อซ่อมเสร็จ ระบบจะส่งอีเมลและแจ้งเตือนให้ทำประเมินความพึงพอใจ",
    "userManual.supHeading": "ขั้นตอนการทำงานสำหรับ หัวหน้างาน (Supervisor)",
    "userManual.s1t": "1. รับเรื่องแจ้งซ่อม",
    "userManual.s1d": "งานแจ้งซ่อมที่ตรงกับหมวดหมู่ของแผนกจะถูกส่งมาให้ดูแล",
    "userManual.s2t": "2. มอบหมายช่าง",
    "userManual.s2d": "เลือกช่างในสังกัดที่มีความพร้อมเพื่อรับผิดชอบงานนี้",
    "userManual.s3t": "3. ติดตามสถานะ",
    "userManual.s3d": "ตรวจสอบความคืบหน้าของงาน หรือเปลี่ยนช่างได้หากจำเป็น",
    "userManual.s4t": "4. สรุปผลงาน",
    "userManual.s4d":
      "เมื่อช่างซ่อมเสร็จ สามารถตรวจสอบคุณภาพจากประวัติงานได้ครบถ้วน",
    "userManual.techHeading": "ขั้นตอนการทำงานสำหรับ ช่างซ่อม (Technician)",
    "userManual.t1t": "1. รับมอบหมายงาน",
    "userManual.t1d":
      "งานที่ได้รับมอบหมายจาก Supervisor จะปรากฏในรายการของช่าง",
    "userManual.t2t": "2. กดรับงาน",
    "userManual.t2d": "กดยืนยันเพื่อเปลี่ยนสถานะเป็น'กำลังดำเนินการซ่อม'",
    "userManual.t3t": "3. ปฏิบัติงานแก้ไข",
    "userManual.t3d": "ดำเนินการแก้ไขและซ่อมแซมหน้างานจริงตามใบแจ้งซ่อม",
    "userManual.t4t": "4. บันทึกผลสำเร็จ",
    "userManual.t4d":
      "เขียนอธิบายผลการซ่อมและแนบภาพหลังการซ่อมเสร็จ เพื่อปิดงาน",
    "userManual.adminHeading": "ขั้นตอนการทำงานสำหรับ ผู้ดูแลระบบ (Admin)",
    "userManual.a1t": "1. ดูภาพรวมระบบ",
    "userManual.a1d": "ผ่าน Dashboard ตรวจสอบสถิติและสถานะการซ่อมทั้งหมด",
    "userManual.a2t": '2. จัดการหมวดหมู่ "อื่นๆ"',
    "userManual.a2d":
      "ชี้เป้าหมวดหมู่แจ้งซ่อมที่ User ระบุไม่ชัดเจน ส่งให้แผนกที่ถูกต้องดูแล",
    "userManual.a3t": "3. จัดการบุคลากร",
    "userManual.a3d": "เพิ่ม/ลบ ปรับโอนย้ายแผนก และเลื่อนตำแหน่งพนักงาน",
    "userManual.a4t": "4. คุมโครงสร้างข้อมูล",
    "userManual.a4d":
      "ดูแลและอัปเดตข้อมูลประเภทงาน, อาคารสถานที่, และแผนกต่างๆ",

    "profile.title": "โปรไฟล์ของฉัน",
    "profile.subtitle": "ข้อมูลบัญชีผู้ใช้และรายละเอียดการปฏิบัติงาน",
    "profile.personalInfo": "ข้อมูลส่วนบุคคล",
    "profile.fullName": "ชื่อ-นามสกุล",
    "profile.firstName": "ชื่อ",
    "profile.lastName": "นามสกุล",
    "profile.email": "อีเมล",
    "profile.phone": "เบอร์โทรศัพท์",
    "profile.role": "บทบาทในระบบ",
    "profile.affiliation": "สังกัด / สำนักวิชา",
    "profile.department": "ฝ่าย / แผนก",
    "profile.section": "กลุ่มงาน",
    "profile.jobType": "ประเภทงานที่รับผิดชอบ",
    "profile.accountStatus": "สถานะบัญชี",
    "profile.statusActive": "ปกติ (ใช้งานได้)",
    "profile.accountType": "ประเภทบัญชี",
    "profile.accountTypeMfu": "บัญชีมหาวิทยาลัย (MFU Mail)",
    "profile.accountTypeExternal": "บัญชีภายนอก",
    "profile.quickActions": "เมนูดำเนินการด่วน",
    "profile.back": "ย้อนกลับ",
    "profile.viewHistory": "ประวัติการแจ้งซ่อม",
    "profile.newRequest": "แจ้งซ่อมใหม่",
    "profile.dashboard": "แดชบอร์ด",
    "profile.manageStaff": "จัดการช่างและเจ้าหน้าที่",
    "profile.manageData": "จัดการข้อมูลระบบ",
    "profile.sub.newRequest": "สร้างคำขอแจ้งซ่อมรายการใหม่",
    "profile.sub.viewHistory": "ตรวจสอบรายการและสถานะงานแจ้งซ่อม",
    "profile.sub.viewHistoryTech": "ตรวจสอบประวัติการปฏิบัติงานที่ผ่านมา",
    "profile.sub.dashboard": "ดูภาพรวมสถิติและข้อมูลการดำเนินงาน",
    "profile.sub.manageStaff": "จัดการรายชื่อเจ้าหน้าที่และสิทธิ์การใช้งาน",
    "profile.sub.manageData": "จัดการข้อมูลประเภทงาน อาคาร และฝ่าย",
    "profile.editProfile": "แก้ไขข้อมูล",
    "profile.editModalTitle": "แก้ไขข้อมูลส่วนบุคคล",
    "profile.edit": "แก้ไข",
    "profile.editPhone": "แก้ไขเบอร์โทรศัพท์",
    "profile.editPhoneTitle": "แก้ไขเบอร์โทรศัพท์",
    "profile.phoneNote":
      "เบอร์โทรศัพท์นี้จะใช้สำหรับการติดต่อประสานงานเกี่ยวกับงานแจ้งซ่อม",
    "profile.changeAvatarTitle": "เปลี่ยนรูปโปรไฟล์",
    "profile.enterPhone": "กรุณาระบุเบอร์โทรศัพท์",
    "profile.phoneSaved": "อัปเดตเบอร์โทรศัพท์สำเร็จ",
    "profile.avatarSaved": "อัปเดตรูปโปรไฟล์สำเร็จ",
    "profile.emailGoogleNote":
      "อีเมลมหาวิทยาลัย (เชื่อมโยงกับ Google Account ไม่สามารถแก้ไขได้)",
    "profile.saveSuccess": "บันทึกข้อมูลเรียบร้อยแล้ว",
    "profile.saveError": "ไม่สามารถบันทึกข้อมูลได้",
    "profile.cacheWarning":
      "บันทึกข้อมูลบนระบบแล้ว แต่ไม่สามารถอัปเดตข้อมูลที่เก็บไว้ในเครื่องได้ กรุณาโหลดข้อมูลใหม่",
    "ticketRoute.notFound": "ไม่พบข้อมูลใบแจ้งซ่อม",
    "ticketRoute.back": "กลับไปหน้ารายการ",
    "asyncFeedback.loading": "กำลังโหลดข้อมูล...",
    "asyncFeedback.retry": "ลองอีกครั้ง",
    "profile.saveBtn": "บันทึกข้อมูล",
    "profile.cancelBtn": "ยกเลิก",
    "profile.selectAffiliation": "เลือกสังกัด / สำนักวิชา",
    "profile.avatar": "รูปโปรไฟล์",
    "profile.changeAvatar": "เปลี่ยนรูปโปรไฟล์",
    "profile.uploadPhoto": "อัปโหลดรูปภาพ",
    "profile.orChoosePreset": "หรือเลือกรูปประจำตัวเริ่มต้น",
    "profile.presetAvatar": "รูปโปรไฟล์สำเร็จรูป {number}",
    "profile.removeAvatar": "ใช้รูปเริ่มต้น",
    "profile.avatarSizeLimit": "ระบบปรับขนาดรูปภาพอัตโนมัติ (ไม่เกิน 1MB)",
  },
  en: {
    "brand.university": "Mae fah luang university",
    "brand.maintenanceShort": "Maintenance system",
    "notification.bell": "Notifications",
    "notification.panelTitle": "Notifications",
    "notification.markAllRead": "Mark all as read",
    "notification.clearRead": "Clear read",
    "notification.delete": "Delete",
    "notification.read": "Read",
    "notification.unread": "Unread",
    "notification.empty": "No notifications",
    "notification.loading": "Loading...",

    "common.cancel": "Cancel",
    "common.other": "Others",
    "common.all": "All",
    "common.items": "Items",
    "common.technician": "Technician",
    "common.logout": "Log out",
    "common.langTh": "TH",
    "common.langEn": "EN",
    "common.viewDetails": "View details",
    "common.close": "Close",
    "common.deleteSuccess": "Deleted successfully",
    "common.dialog": "Dialog",
    "common.search": "Search",
    "common.clearSearch": "Clear search",
    "common.filterLabel": "Filter:",
    "common.filterPlaceholder": "Search technician name or department...",

    "table.noResults": "No matching records found",
    "table.filterLabel": "Filter:",
    "table.filterPlaceholder": "Type to filter...",
    "table.itemsPerPageLabel": "Items per page:",

    "login.title": "Online maintenance request",
    "login.subtitle": "Mae fah luang university",
    "login.signIn": "Sign in",
    "login.mfuHint": "* Please use MFU mail to sign in",
    "login.externalNotice":
      "* Contract staff (external email) must be pre-registered by the administrator before logging in",
    "login.userManual": "User manual",
    "login.swalGoogleLoadingTitle": "Loading",
    "login.swalGoogleLoadingText":
      "Connecting to Google. please wait and try again.",
    "login.ok": "Ok",
    "login.verifyingTitle": "Verifying...",
    "login.verifyingText": "Please wait while we sign you in",
    "login.successTitle": "Signed in successfully",
    "login.errorTitle": "Something went wrong",
    "login.failGeneric": "Sign-in failed",
    "login.mockTitle": "DEVELOPMENT LOGIN",
    "login.mockRoleLabel": "Select role for testing",
    "login.mockRoleUser": "User (Reporter)",
    "login.mockRoleTech": "Technician",
    "login.mockRoleSup": "Supervisor",
    "login.mockRoleAdmin": "Admin",
    "login.mockPersonaLabel": "Select mock persona",
    "login.mockPersonaPlaceholder": "-- Please select mock persona --",
    "login.mockPersonaRequired":
      "Please select a mock persona before logging in",
    "login.mockSelectJobLabel": "Select technician job type",
    "login.mockSelectJobPlaceholder": "-- Please select job type --",
    "login.mockSelectSectionLabel": "Select section",
    "login.mockSelectSectionPlaceholder": "-- Please select section --",
    "login.mockLoginBtn": "Login as {role}",
    "login.mockNote": "For local development testing only",
    "login.mockJobRequired":
      "Please select technician job type before logging in",
    "login.mockSectionRequired":
      "Please select supervisor section before logging in",

    "nav.userManual": "User manual",
    "nav.studentHistory": "Student repair history",
    "nav.logout": "Log out",
    "nav.dashboard": "Dashboard",
    "nav.evaluation": "Technician evaluation",
    "nav.repairs": "Maintenance requests",
    "nav.staff": "Staff management",
    "nav.jobTypes": "Sections & Job Types",
    "nav.departments": "Department Management",
    "nav.buildings": "Manage Buildings",
    "nav.requesterOrgSync": "Connect Requester Affiliation Data",
    "requesterOrgSync.title": "Connect Requester Affiliation Data",
    "requesterOrgSync.description":
      "Connect and import requester organization data from University Master Data into the maintenance system",
    "requesterOrgSync.createOnlyNotice":
      "Confirmation only creates verified new records",
    "requesterOrgSync.checkUpdates": "Check Latest Updates",
    "requesterOrgSync.checking": "Checking...",
    "requesterOrgSync.previewSummary": "Preview Summary",
    "requesterOrgSync.newData": "New Data",
    "requesterOrgSync.unchanged": "Unchanged",
    "requesterOrgSync.conflicts": "Conflict",
    "requesterOrgSync.reviewRequired": "Review Required",
    "requesterOrgSync.upToDate": "Master data is up to date",
    "requesterOrgSync.noApplyNeeded": "No new records to apply",
    "requesterOrgSync.reviewBlocked":
      "Review required before apply can proceed",
    "requesterOrgSync.applyUpdates": "Apply {count} updates",
    "requesterOrgSync.confirmTitle": "Confirm Sync?",
    "requesterOrgSync.confirmText":
      "System will create {count} new records from approved plan",
    "requesterOrgSync.applyNow": "Apply Now",
    "requesterOrgSync.completed": "Sync Completed",
    "requesterOrgSync.added": "Added {count} records",
    "requesterOrgSync.previewFailed": "Preview Failed",
    "requesterOrgSync.applyFailed": "Apply Failed",
    "requesterOrgSync.errorCode": "Error Code",
    "requesterOrgSync.planId": "Plan ID",
    "requesterOrgSync.planHash": "Plan Hash",
    "requesterOrgSync.sourceFingerprint": "Source Fingerprint",
    "requesterOrgSync.alwaysCheck": "Always Check Blendata",
    "requesterOrgSync.autoSync": "Auto Sync",
    "requesterOrgSync.autoSyncNotice":
      "ระบบจะทำการซิงค์และบันทึกข้อมูลสังกัดที่เปลี่ยนแปลงจาก Blendata ลงฐานข้อมูลอัตโนมัติตามเวลาที่กำหนด",
    "requesterOrgSync.tabCreateNew": "Add New Organizations",
    "requesterOrgSync.tabUpdateName": "Update Existing Organizations",
    "requesterOrgSync.tabRequiresReview": "Requires Review",
    "requesterOrgSync.tabChangeHistory": "Change History",
    "requesterOrgSync.historyTitle": "Requester Organization Change History",
    "requesterOrgSync.historySearchPlaceholder":
      "Search code, name, previous, new value, operator...",
    "requesterOrgSync.historyActionAll": "All Action Types",
    "requesterOrgSync.historyActionCreate": "Add New Organization",
    "requesterOrgSync.historyActionUpdateName": "Update Organization Name",
    "requesterOrgSync.historyActionUpdateCode": "Update Organization Code",
    "requesterOrgSync.historyActionKeepDefault": "Keep Existing Organization",
    "requesterOrgSync.historyActionPostpone": "Postpone Decision",
    "requesterOrgSync.historyActionResume": "Resume for Review",
    "requesterOrgSync.historyDateFrom": "From Date",
    "requesterOrgSync.historyDateTo": "To Date",
    "requesterOrgSync.historyEmpty":
      "No change history found matching criteria",
    "requesterOrgSync.historyColTime": "Timestamp (Thai Time)",
    "requesterOrgSync.historyColOperator": "Operator",
    "requesterOrgSync.historyColOrg": "Code / Organization",
    "requesterOrgSync.historyColAction": "Action",
    "requesterOrgSync.historyColChanges": "Changes (Before → After)",
    "requesterOrgSync.historyColAlias": "Legacy Alias",
    "requesterOrgSync.historyColProvenance": "Record Source",
    "requesterOrgSync.historyColResult": "Result",
    "requesterOrgSync.noActionableItems": "No Pending Items to Review",
    "requesterOrgSync.noActionableItemsDesc":
      "All items have been processed or there are no pending reviews requiring action.",
    "requesterOrgSync.viewChangeHistoryBtn": "View Change History",
    "requesterOrgSync.confirmBatchBtn":
      "Confirm Add {createCount} and Update {updateCount} Item(s)",
    "requesterOrgSync.postponeBtn": "Postpone Decision",
    "requesterOrgSync.selectAll": "Select All",
    "requesterOrgSync.deselectAll": "Deselect All",
    "requesterOrgSync.batchConfirmTitle": "Confirm Organization Sync Updates?",
    "requesterOrgSync.batchConfirmDesc":
      "Do you want to save {createCount} new organization(s) and {updateCount} existing organization name update(s)?",
    "requesterOrgSync.preservedIdBadge": "Preserved _id",
    "requesterOrgSync.missingInMaster": "Not found in Master Data",
    "requesterOrgSync.missingInMasterDesc":
      "Retain existing data by default (no records deleted)",
    "requesterOrgSync.codeDriftDetail": "Specify Code Relationship",
    "requesterOrgSync.pendingBadge": "Pending Review: {count} Item(s)",
    "requesterOrgSync.scheduleEvery": "Check Schedule: Every",
    "requesterOrgSync.unitDay": "Day",
    "requesterOrgSync.unitMonth": "Month",
    "requesterOrgSync.unitYear": "Year",
    "requesterOrgSync.syncNowBtn": "Sync Data Now",
    "requesterOrgSync.syncNowDesc":
      "Check and sync organization data from Blendata immediately",
    "requesterOrgSync.confirmSyncNowTitle":
      "Confirm Requester Organization Sync?",
    "requesterOrgSync.confirmSyncNowText":
      "The system will inspect Master Data and prepare items pending Admin approval without directly mutating organizations",
    "requesterOrgSync.syncNowComplete":
      "Sync completed: Added {count} new organization(s)",
    "requesterOrgSync.syncNowUpToDate":
      "Affiliation data matches Master Data — No new records to add",
    "requesterOrgSync.syncNowBlocked":
      "Review required or sync blocked: {reason}",
    "requesterOrgSync.syncNowWarning":
      "Sync completed with warning: New records saved, but status refresh or notification was incomplete (please do not re-sync)",
    "requesterOrgSync.statusGreenTitle":
      "Affiliation data matches Master Data — No changes detected",
    "requesterOrgSync.statusGreenDesc":
      "Organization data in the maintenance system is fully up to date with University Master Data",
    "requesterOrgSync.statusRedTitle": "Changes detected from Master Data",
    "requesterOrgSync.statusRedDesc":
      "Differences or new organizations detected from Master Data",
    "requesterOrgSync.statusWarningTitle":
      "Not yet inspected or Blendata is unavailable",
    "requesterOrgSync.statusWarningDesc":
      "No valid comparison evidence available or upstream connection is currently unavailable",
    "requesterOrgSync.autoSyncTitle": "Auto Sync Settings",
    "requesterOrgSync.autoSyncDesc":
      "Configure schedule to check data on time and prepare pending items awaiting Admin review and approval",
    "requesterOrgSync.cancel": "Cancel",
    "requesterOrgSync.modeDay": "Daily",
    "requesterOrgSync.modeMonth": "Monthly",
    "requesterOrgSync.modeYear": "Yearly",
    "requesterOrgSync.everyNDays": "Every (1–7 days)",
    "requesterOrgSync.dayOfMonth": "Day of Month (1–30)",
    "requesterOrgSync.monthOfYear": "Month",
    "requesterOrgSync.syncTime": "Time (HH:mm)",
    "requesterOrgSync.timeThaiLabel": "Thai Time (Asia/Bangkok)",
    "requesterOrgSync.nextSyncCalculated": "Next Scheduled Sync:",
    "requesterOrgSync.previewScheduleTitle": "Next Sync Preview (Before Save):",
    "requesterOrgSync.clampingNote":
      "For months with fewer days (such as February), the system will automatically run on the last day of the month.",
    "requesterOrgSync.autoSyncUnconfigured":
      "Auto sync schedule not configured (please configure schedule)",
    "requesterOrgSync.saveAutoSyncSettings": "Save Auto Sync Settings",
    "requesterOrgSync.alwaysCheckTitle":
      "Change Detection Settings (Always Check)",
    "requesterOrgSync.alwaysCheckDesc":
      "Continuously inspects differences between database and Blendata in the background (Always enabled, cannot be disabled)",
    "requesterOrgSync.alwaysCheckMandatory": "Always Active (Mandatory)",
    "requesterOrgSync.checkIntervalDaysLabel":
      "Check for changes every (1–365 days):",
    "requesterOrgSync.saveAlwaysCheckSettings":
      "Save Change Detection Settings",
    "requesterOrgSync.saveSettings": "Save Settings",
    "requesterOrgSync.settingsSaved": "Settings saved successfully",
    "requesterOrgSync.statusPanel": "Sync & Check Status",
    "requesterOrgSync.blendataStatus": "Blendata Status",
    "requesterOrgSync.lastCheck": "Last Check",
    "requesterOrgSync.lastSuccessfulSync": "Last Successful Sync",
    "requesterOrgSync.nextCheck": "Next Scheduled Check (Planned)",
    "requesterOrgSync.masterDataStatus": "Master Data Status",
    "requesterOrgSync.lastSafeError": "Last Safe Error",
    "requesterOrgSync.checkNow": "Check Blendata Now",
    "requesterOrgSync.checkingNow": "Checking Blendata...",
    "requesterOrgSync.checkSuccess": "Blendata Check Completed",
    "requesterOrgSync.schedulerStatus": "Always Check Scheduler",
    "requesterOrgSync.schedulerActive": "Active",
    "requesterOrgSync.schedulerInactive":
      "Inactive (Worker stopped / flag disabled)",
    "requesterOrgSync.schedulerWarning": "Scheduler Warning",
    "requesterOrgSync.autoSyncDecision": "Auto Sync Decision",
    "requesterOrgSync.decisionUpToDate": "Up to date",
    "requesterOrgSync.decisionSafeCreateNew":
      "Safe create-only changes available",
    "requesterOrgSync.decisionReviewRequired": "Review required",
    "requesterOrgSync.decisionBlocked": "Blocked",
    "requesterOrgSync.decisionReason": "Decision Reason",
    "requesterOrgSync.safeCreateNotice":
      "Safe create-only candidate detected. Automatic Apply is not active yet (automaticApplyActive = false).",
    "requesterOrgSync.reviewRequiredNotice":
      "Manual review required. Please use Manual Preview / Controlled Sync.",
    "requesterOrgSync.blockedNotice":
      "Automated decision is blocked due to operational or validation errors.",
    "requesterOrgSync.decisionFingerprint": "Comparison Fingerprint",
    "requesterOrgSync.saveSettingsFailed": "Failed to save settings",
    "requesterOrgSync.checkFailed": "Failed to check Blendata",
    "requesterOrgSync.saving": "Saving settings...",
    "requesterOrgSync.checkingUpdates": "Checking for changes...",
    "requesterOrgSync.applying": "Adding new organizations...",
    "requesterOrgSync.refreshStatusWarning":
      "New organizations added successfully, but refreshing latest status failed. Data has been saved, please do not re-apply.",
    "requesterOrgSync.statusPanelNotice":
      "Latest check results (not a continuous live connection)",
    "requesterOrgSync.intervalRequired":
      "Please enter a positive integer interval",
    "requesterOrgSync.intervalMinError": "Interval must be at least 1",
    "requesterOrgSync.intervalMaxDay":
      "Day interval must be between 1 and 365 days",
    "requesterOrgSync.intervalMaxMonth":
      "Month interval must be between 1 and 120 months",
    "requesterOrgSync.intervalMaxYear":
      "Year interval must be between 1 and 10 years",
    "requesterOrgSync.confirmAddTitle": "Confirm Adding New Organizations?",
    "requesterOrgSync.confirmAddText":
      "The system will add {count} new organization records to the database without modifying or deleting existing records (Create-Only).",
    "requesterOrgSync.applyNowBtn": "Add New Organizations Now",
    "requesterOrgSync.addUpdatesBtn": "Add {count} new organizations",
    "requesterOrgSync.secondarySettingsTitle": "Schedule & Automation Settings",
    "requesterOrgSync.secondarySettingsDesc":
      "Manage automatic Blendata check intervals and related automation settings",
    "requesterOrgSync.secondaryCheckTitle": "Check & Record Current Status Now",
    "requesterOrgSync.secondaryCheckDesc":
      "Reads and compares organization data with Blendata and records the latest inspection status into the system (different from 'Check for Changes' which prepares an approval plan for adding new organizations).",
    "requesterOrgSync.technicalDetails": "Technical Audit Details",
    "requesterOrgSync.reviewRequiredDesc":
      "Items requiring review detected. Apply is blocked until these items are reviewed.",
    "requesterOrgSync.noNewItems": "No new records to add",
    "requesterOrgSync.showDetails": "Show details",
    "requesterOrgSync.hideDetails": "Hide details",
    "requesterOrgSync.autoApplyInactive": "Inactive",
    "requesterOrgSync.autoApplyActive": "Active",
    "requesterOrgSync.alwaysCheckWorkerStatus": "Always Check Worker Status",
    "requesterOrgSync.autoSyncWorkerStatus": "Auto Sync Worker Status",
    "requesterOrgSync.savedAutoSyncSetting": "Saved Auto Sync Setting",
    "requesterOrgSync.nextSyncTime": "Next Scheduled Sync",
    "requesterOrgSync.previewActionDesc":
      "Check differences from University Master Data to prepare an approved plan for adding new organizations (does not persist check status until applied).",
    "requesterOrgSync.blockerPrefix": "Apply blocked reason:",
    "requesterOrgSync.createCandidates":
      "Eligible new organization records (Create-Only)",
    "requesterOrgSync.reviewItemsTitle": "Items requiring review",
    "requesterOrgSync.applyDisabledTooltip":
      "Please check for changes first, or resolve items requiring review",
    "nav.manageData": "Manage data",
    "nav.new": "New",
    "nav.main": "Home",
    "nav.history": "History",
    "nav.navigation": "Navigation",

    "mainuser.pageTitle": "Maintenance",
    "mainuser.pageSubtitle": "Overview of maintenance and repair requests",
    "mainuser.createNewRequest": "New Request",
    "mainuser.detailsTitle": "Latest maintenance request",
    "mainuser.detailsSubtitle": "Detailed information about the repair ticket",
    "mainuser.activeRequestsTitle": "Maintenance Requests",
    "mainuser.activeRequestLabel": "Maintenance Requests",
    "mainuser.noActiveRequestTitle": "No active requests",
    "mainuser.noActiveRequestText":
      "New active maintenance requests will appear here.",
    "mainuser.noLatestRequestTitle": "No latest request yet",
    "mainuser.noLatestRequestText":
      "When a request is created, its details will appear here.",
    "mainuser.reportBtn": "New Request",
    "mainuser.tabReports": "My requests",
    "mainuser.tabHistory": "Request history",
    "userHistory.subtitle":
      "Review your previous maintenance requests and outcomes",
    "userHistory.allTransactions": "All Request History",
    "userHistory.empty": "No request history yet",
    "userHistory.ticketNo": "Ticket No.",
    "userHistory.dateTime": "Date/Time Reported",
    "userHistory.details": "Problem / Work Details",
    "userHistory.problemDetails": "Problem / Work Details",
    "userHistory.routing": "Responsible Department",
    "userHistory.section": "Section",
    "userHistory.department": "Department",
    "userHistory.jobType": "Job Type",
    "userHistory.satisfaction": "Satisfaction",
    "userHistory.reporterAndRole": "Reporter / Role",
    "userHistory.roleReporter": "Reporter",
    "userHistory.roleAssigned": "Assigned Task",
    "mainuser.ticketCancelledTitle": "Request cancelled",
    "mainuser.ticketCancelledText":
      "This maintenance request has been cancelled.",
    "mainuser.evalBeforeNewTitle": "Action required",
    "mainuser.evalBeforeNewText":
      "Please complete your evaluation for finished work before submitting a new request.",
    "mainuser.thanksEvalTitle": "Thank you for your feedback",
    "mainuser.evalTicketNo": "Ticket no.:",
    "mainuser.evalScore": "Rating:",
    "mainuser.evalStars": "Stars",
    "mainuser.evalComment": "Comment:",
    "mainuser.evalNoComment": "None",

    "home.kpiTotalReported": "Total Reported",
    "home.kpiCompleted": "Completed",
    "home.kpiAwaitingEval": "Awaiting Evaluation",
    "home.kpiUnassigned": "Unassigned",
    "home.kpiNewJobs": "New Requests",
    "home.kpiInProgressAll": "In Progress",
    "home.kpiCompletedJobs": "Repairs Completed",
    "home.kpiOverdue": "Overdue Jobs",

    "dashboard.kpiTotalRequests": "Total repair requests",
    "dashboard.kpiPending": "Pending",
    "dashboard.kpiAssigned": "Assigned",
    "dashboard.kpiInProgress": "In progress",
    "dashboard.kpiCompleted": "Closed",
    "dashboard.kpiOverSla": "Over SLA",
    "dashboard.kpiSatisfaction": "Average satisfaction",
    "dashboard.kpiAwaitingEval": "Awaiting evaluation",
    "dashboard.pieByDepartment": "Requests by department",
    "dashboard.pieByCategory": "Requests by category",
    "dashboard.barMonthly": "Monthly request statistics",
    "dashboard.heatmap": "Heat map",
    "dashboard.ticketDetails": "Ticket details",
    "dashboard.reportPdf": "Report",
    "dashboard.noData": "No data",
    "dashboard.slaTarget": "Target:",
    "dashboard.rangeCustom": "Custom",
    "dashboard.rangeToday": "Today",
    "dashboard.rangeWeek": "Week",
    "dashboard.rangeMonth": "Month",
    "dashboard.rangeHalfYear": "Half year",
    "dashboard.rangeYear": "Year",
    "dashboard.rangeAll": "All time",
    "dashboard.rangeEval": "Eval cycle",
    "dashboard.evalMonthsSuffix": "Months ago",
    "dashboard.filterAllDepts": "All departments",
    "dashboard.filterAllTechs": "All technicians",
    "dashboard.periodPrefix": "Period:",
    "dashboard.pdfTitle": "Maintenance summary report",
    "dashboard.pdfPrintedAt": "Printed:",
    "dashboard.shortMon": "Mon",
    "dashboard.shortTue": "Tue",
    "dashboard.shortWed": "Wed",
    "dashboard.shortThu": "Thu",
    "dashboard.shortFri": "Fri",
    "dashboard.shortSat": "Sat",
    "dashboard.shortSun": "Sun",
    "dashboard.downloadPdf": "Download PDF",
    "dashboard.downloadExcel": "Download Excel",
    "dashboard.colDepartment": "Department",
    "dashboard.colReporter": "Reporter",
    "dashboard.colCategory": "Category",
    "dashboard.closedJobsProportion": "Proportion of closed tasks",
    "dashboard.calcFromAllJobsHint":
      "Calculated from all tasks in selected period",
    "dashboard.pendingManagementTasks": "Tasks awaiting action",

    "evaluation.detailsFor": "Performance details for",
    "evaluation.excelExportError": "Failed to generate Excel report file",
    "dashboard.searchPlaceholder": "Search ticket or job type...",
    "evaluation.searchPlaceholder": "Search technician name or department...",
    "buildingMgmt.searchPlaceholder": "Search building or room name...",
    "evaluation.field.name": "Name",
    "evaluation.field.department": "Department",
    "evaluation.field.totalJobs": "Total jobs",
    "evaluation.field.completedJobs": "Completed",
    "evaluation.field.slaMetPercent": "SLA met %",
    "evaluation.field.avgRating": "Avg rating",
    "evaluation.field.rating": "Stars",
    "evaluation.field.comment": "Comment",
    "evaluation.excelExportSubtitle": "SmartFix MFU Report Management & Export System",
    "evaluation.quickPresets": "Quick Presets:",
    "evaluation.presetAll": "All",
    "evaluation.presetThisMonth": "This Month",
    "evaluation.presetLast30Days": "Last 30 Days",
    "evaluation.presetThisYear": "This Year",
    "evaluation.ownDepartmentOnly": "Own Department Only",
    "evaluation.supervisorDepartmentNote": "* Supervisor role can download reports and evaluations for their own department only.",
    "evaluation.scopeDepartment": "Department Scope:",
    "evaluation.allDepartments": "All Departments",
    "evaluation.matchingTickets": "Matching Tickets:",
    "evaluation.itemsCount": "{count} records",
    "evaluation.sheet1Title": "Sheet 1 (Maintenance Tickets Report):",
    "evaluation.sheet1Desc": "Comprehensive 15-column ticket details, dark navy header, zebra stripes, repair photo hyperlinks, and total expense summary.",
    "evaluation.sheet2Title": "Sheet 2 (Technician Evaluation Summary):",
    "evaluation.sheet2Desc": "Performance overview, SLA Met %, average rating, spare parts used, and total cost per technician.",
    "evaluation.generatingFile": "Generating file...",
    "evaluation.downloadExcelFile": "Download Excel (.xlsx)",
    "evaluation.yourDepartment": "Your Department",
    "evaluation.generalExpense": "General Expenses",
    "evaluation.exportError": "Failed to generate Excel report file",

    "dashboard.pdfKpiTotal": "Total jobs",
    "dashboard.pdfKpiCompleted": "Closed",
    "dashboard.pdfKpiInProgress": "In progress",
    "dashboard.pdfKpiOverdue": "Overdue (SLA)",
    "dashboard.pdfKpiAwaiting": "Awaiting evaluation",
    "dashboard.pdfKpiSatisfaction": "Average satisfaction",
    "dashboard.pdfWorkListTitle": "Job details",
    "dashboard.colTicketNo": "Ticket no.",
    "dashboard.colDateReported": "Reported date",
    "dashboard.colReporterDept": "Reporter / dept.",
    "dashboard.colStatus": "Status",
    "dashboard.colSla": "SLA",
    "dashboard.colClosedAt": "Closed at",
    "dashboard.noRowsInPeriod": "No data in this period",
    "dashboard.summaryTitle": "Summary by category",
    "dashboard.summaryColDept": "Department / unit",
    "dashboard.summaryColCategory": "Category / department",
    "dashboard.summaryColTotal": "Total jobs",
    "dashboard.summaryColCompleted": "Closed",
    "dashboard.summaryColInProgress": "In progress",
    "dashboard.summaryColOverdue": "Overdue",
    "dashboard.noSummaryRows": "No summary data",
    "dashboard.pdfModalTitle": "Select period for download",
    "dashboard.dateFrom": "From date",
    "dashboard.dateTo": "To date",
    "dashboard.download": "Download",
    "dashboard.slaOverdue": "Overdue",
    "dashboard.slaOnTime": "On time",
    "dashboard.supervisorPrefix": "Supervisor:",
    "dashboard.status.pending": "Pending",
    "dashboard.status.assigned": "Assigned",
    "dashboard.status.in_progress": "In progress",
    "dashboard.status.done": "Done",
    "dashboard.status.welldone": "Done (evaluated)",
    "dashboard.status.cancelled": "Cancelled",
    "dashboard.status.rejected": "Rejected",
    "dashboard.field.ticketNo": "Ticket no.",
    "dashboard.field.dateInformed": "Reported date",
    "dashboard.field.reporter": "Reporter / department",
    "dashboard.field.reporterName": "Reporter",
    "dashboard.field.department": "Department",
    "dashboard.field.category": "Job type",
    "dashboard.field.status": "Status",
    "dashboard.field.sla": "SLA",
    "dashboard.field.assignee": "Assignee",
    "dashboard.field.closedDate": "Closed date",
    "dashboard.techDashboardSubtitle":
      "Overview of repair jobs and your work performance",
    "dashboard.projectAnalytics": "Project Analytics",
    "dashboard.workProgress": "Work Progress",
    "dashboard.workProgressSubtitle": "Job proportion by category",
    "dashboard.workloadLabel": "Current Workload",
    "dashboard.noActiveWork": "No assigned work in progress",
    "dashboard.assignedPercentPrefix": "Assigned share",
    "dashboard.remainingAccumulatedShare": "Remaining accumulated share",
    "dashboard.ticketDetailsSubtitle":
      "List of repair tickets under responsibility",
    "dashboard.supervisorTicketDetailsSubtitle":
      "List of all repair tickets in the selected period",
    "dashboard.highlight": "Highlight",
    "dashboard.highlightSubtitle":
      "Maintenance request trend for the selected period",
    "dashboard.donutCompleted": "Completed",
    "dashboard.donutRemaining": "Remaining",
    "dashboard.barDatasetLabel": "Assigned jobs",
    "dashboard.subtitleToday": "Tickets by time period",
    "dashboard.subtitleWeek": "Tickets by day of week",
    "dashboard.subtitleMonth": "Tickets by date",
    "dashboard.subtitleHalfYear": "Tickets by month",
    "dashboard.subtitleYear": "Tickets by month",
    "dashboard.subtitleAll": "Tickets by year",
    "dashboard.pdfPeriodTpl": "Data from {from} to {to}",
    "dashboard.shortMonth1": "Jan",
    "dashboard.shortMonth2": "Feb",
    "dashboard.shortMonth3": "Mar",
    "dashboard.shortMonth4": "Apr",
    "dashboard.shortMonth5": "May",
    "dashboard.shortMonth6": "Jun",
    "dashboard.shortMonth7": "Jul",
    "dashboard.shortMonth8": "Aug",
    "dashboard.shortMonth9": "Sep",
    "dashboard.shortMonth10": "Oct",
    "dashboard.shortMonth11": "Nov",
    "dashboard.shortMonth12": "Dec",

    "ticketDetail.title": "Maintenance request details",
    "ticketDetail.timeline.waitShort": "Pending",
    "ticketDetail.timeline.submitted": "Submit Request",
    "ticketDetail.timeline.received": "Request Accepted",
    "ticketDetail.timeline.inRepair": "Repair in Progress",
    "ticketDetail.timeline.eval": "Rate Service",
    "ticketDetail.timeline.awaitingEval": "Awaiting evaluation",
    "ticketDetail.timeline.done": "Completed",
    "ticketDetail.role.user": "User",
    "ticketDetail.role.supervisor": "Supervisor",
    "ticketDetail.role.technician": "Technician",
    "ticketDetail.role.userConfirm": "User confirmation",
    "ticketDetail.rating.n1": "Needs improvement",
    "ticketDetail.rating.n2": "Fair",
    "ticketDetail.rating.n3": "Average",
    "ticketDetail.rating.n4": "Good",
    "ticketDetail.rating.n5": "Excellent",
    "ticketDetail.evalPlease": "Rate your satisfaction",
    "ticketDetail.evalResult": "Satisfaction result",
    "ticketDetail.evalSubmit": "Submit rating",
    "ticketDetail.saving": "Saving...",
    "ticketDetail.cancelWhy": "Cancellation reason",
    "ticketDetail.noReason": "No reason given",
    "ticketDetail.assignees": "Assignees",
    "ticketDetail.supervisorAssigner": "Assigning supervisor:",
    "ticketDetail.when": "When:",
    "ticketDetail.technician": "Technician:",
    "ticketDetail.waitTechAccept": "(waiting for technician to accept)",
    "ticketDetail.finishedWhen": "Completed on:",
    "ticketDetail.sectionReport": "Request information",
    "ticketDetail.ticketNo": "Ticket no.",
    "ticketDetail.reporter": "Reporter:",
    "ticketDetail.affiliation": "Reporter Affiliation:",
    "ticketDetail.section": "Responsible Department:",
    "ticketDetail.onBehalf": "On behalf of:",
    "ticketDetail.phoneMobile": "Mobile phone:",
    "ticketDetail.phoneWork": "Work phone:",
    "ticketDetail.jobType": "Job type:",
    "ticketDetail.workArea": "Work area:",
    "ticketDetail.timeSlot": "Preferred time:",
    "ticketDetail.mapPoint": "Report location map:",
    "ticketDetail.openMaps": "Open in Google maps",
    "ticketDetail.problem": "Problem / work:",
    "ticketDetail.assetCode": "Asset Code:",
    "ticketDetail.photoBefore": "Photo (before repair):",
    "ticketDetail.workOutcome": "Work summary",
    "ticketDetail.fixDetail": "Resolution details:",
    "ticketDetail.photoAfter": "Technician photo (after repair):",
    "ticketDetail.close": "Close",
    "ticketDetail.outdoor": "Outdoor",
    "ticketDetail.locationBuilding": "Building {b} / room {r}",
    "ticketDetail.mapPinTitle": "Report pin",
    "ticketDetail.swalEvalOk": "Rating saved",
    "ticketDetail.swalWarn": "Warning",
    "ticketDetail.swalError": "Something went wrong",
    "ticketDetail.swalSaveFail": "Could not save",
    "ticketDetail.techUnknown": "Name unknown (ID only)",
    "ticketDetail.techPending": "- (pending)",
    "ticketDetail.cancelTicketBtn": "Cancel request",
    "ticketDetail.closeDetail": "Close details",
    "ticketDetail.deptCombined": "Unit:",
    "ticketDetail.phonePersonalShort": "Mobile:",
    "ticketDetail.phoneWorkShort": "Work phone:",
    "ticketDetail.phoneTechnician": "Technician phone:",
    "ticketDetail.technicianPhone": "Technician phone:",
    "ticketDetail.otherCatBanner": "“Other” category — assign a department",
    "ticketDetail.userSpecifiedJob": "Type specified by user:",
    "ticketDetail.pickDept": "Select department:",
    "ticketDetail.placeholderDept": "-- select department --",
    "ticketDetail.assigningDept": "Assigning...",
    "ticketDetail.assignDeptBtn": "Assign department",
    "ticketDetail.assignTechHeading": "Assign to technician",
    "ticketDetail.changeTechHeading": "Change technician",
    "ticketDetail.pickTech": "Select technician:",
    "ticketDetail.placeholderTech": "-- select technician --",
    "ticketDetail.addAssignee": "Add technician",
    "ticketDetail.assignmentNetworkError":
      "The browser could not reach the assignment api. please refresh and try again.",
    "ticketDetail.confirmAssignTech": "Confirm assignment",
    "ticketDetail.selectTechFirst": "Select a technician first",
    "ticketDetail.assignSelectedTech": "Assign to selected technician",
    "ticketDetail.confirmChangeTechBtn": "Confirm",
    "ticketDetail.waitUserEval": "Awaiting user rating",
    "ticketDetail.adminAssignBox": "Assignment by admin",
    "ticketDetail.originalUserType": "Original type from user:",
    "ticketDetail.adminAssignedDeptLabel": "Department assigned by admin:",
    "ticketDetail.adminAssignerLabel": "Assigned by (admin):",
    "ticketDetail.assignDateLabel": "Assigned on:",
    "ticketDetail.supervisorLabelRole": "Assigning supervisor:",
    "ticketDetail.technicianLabelRole": "Technician:",
    "ticketDetail.techLeader": "Team lead",
    "ticketDetail.techHelper": "Helper",
    "ticketDetail.assignInline": "Assign",
    "ticketDetail.maxTechHint": "Max 3 people (1 lead + 2 helpers)",
    "ticketDetail.changeTechShort": "Change technician",
    "ticketDetail.otherAssignedSuffix": "(assigned)",
    "ticketDetail.otherWaitSuffix": "(awaiting assignment)",
    "ticketDetail.noLocationDetail": "No location detail",
    "ticketDetail.timeSuffix": "",
    "ticketDetail.youMarker": "(you)",
    "ticketDetail.noName": "Unknown name",
    "ticketDetail.techNotYet": "- (not assigned)",
    "ticketDetail.confirmAssignDeptTitle": "Assign to this department?",
    "ticketDetail.confirmAssignDeptHtml":
      "Assign this job to<br><strong>{name}</strong><br>?",
    "ticketDetail.assignDeptSuccess":
      "Department assigned. an email has been sent to that department’s supervisor.",
    "ticketDetail.assignDeptFail": "Could not assign department",
    "ticketDetail.fetchCategoriesFail": "Could not load departments",
    "ticketDetail.connectFail": "Could not reach the server",
    "ticketDetail.confirmChangeTechTitle": "Change technician?",
    "ticketDetail.confirmAssignTitle": "Confirm assignment?",
    "ticketDetail.confirmChangeTechHtml":
      "Change technician to<br><strong>{name}</strong><br>?",
    "ticketDetail.confirmAssignTechHtml":
      "Assign this job to<br><strong>{name}</strong><br>?",
    "ticketDetail.selectedTechFallback": "Selected technician",
    "ticketDetail.assignTechOk":
      "Assigned. an email has been sent to the technician.",
    "ticketDetail.changeTechOk": "Technician updated",
    "ticketDetail.assignTechFail": "Could not assign",
    "ticketDetail.cancelTicketTitle": "Cancel this request?",
    "ticketDetail.cancelTicketHtml":
      'This cannot be undone.<br><br><b style="color:red;">*please enter a reason</b>',
    "ticketDetail.cancelPlaceholder": "Reason...",
    "ticketDetail.cancelAria": "Cancellation reason",
    "ticketDetail.cancelConfirmBtn": "Confirm",
    "ticketDetail.closeBtn": "Cancel",
    "ticketDetail.removeAssignee": "Remove",
    "jobList.uploadIcon": "Upload",
    "ticketDetail.cancelReasonRequired": "Please enter a reason.",
    "ticketDetail.cancelOk": "Request cancelled",
    "ticketDetail.cancelFail": "Could not cancel",
    "ticketDetail.supervisor.forwardOther": "Forward to another department",
    "ticketDetail.supervisor.forwardOtherShort":
      "Forward to another department",
    "ticketDetail.supervisor.pickTargetDept": "Target department:",
    "ticketDetail.supervisor.placeholderDept": "-- select department --",
    "ticketDetail.supervisor.yourDeptTag": "(your department)",
    "ticketDetail.supervisor.processing": "Processing...",
    "ticketDetail.supervisor.confirmForward": "Confirm forward",
    "ticketDetail.supervisor.forwardConfirmTitle": "Forward this job?",
    "ticketDetail.supervisor.forwardConfirmText":
      "Send this job to another department?",
    "ticketDetail.supervisor.forwardOk": "Job forwarded",
    "ticketDetail.supervisor.forwardFail": "Could not forward",
    "ticketDetail.supervisor.waitEvalLine": "Awaiting user rating",
    "ticketDetail.tech.pageTitle": "Job details",
    "ticketDetail.tech.newJobTitle": "New job assigned",
    "ticketDetail.tech.newJobHint":
      "Review the repair details, then accept to start work",
    "ticketDetail.tech.acceptJob": "Accept job",
    "ticketDetail.tech.closeSection": "Report completion (close job)",
    "ticketDetail.tech.closeWorkHeading": "Report completion (close job)",
    "ticketDetail.tech.repairDetailLabel": "Work performed:",
    "ticketDetail.tech.fixDetailLabel": "Work performed:",
    "ticketDetail.tech.repairPlaceholder": "Describe the repair work...",
    "ticketDetail.tech.fixDetailPlaceholder": "Describe the repair work...",
    "ticketDetail.tech.photoAfterRequired": "After photo:",
    "ticketDetail.tech.photoAfterLabel": "After photo:",
    "ticketDetail.tech.choosePhoto": "Choose image...",
    "ticketDetail.tech.pickPhotoPlaceholder": "Choose image...",
    "ticketDetail.tech.photoHint": "Supports JPG, PNG max 10MB",
    "ticketDetail.tech.confirmClose": "Confirm close",
    "ticketDetail.tech.uploading": "Uploading...",
    "ticketDetail.tech.sparePartsLabel": "Spare parts used:",
    "ticketDetail.tech.sparePartsPlaceholder":
      "Specify spare part name or - if not used",
    "ticketDetail.tech.quantityLabel": "Quantity:",
    "ticketDetail.tech.costLabel": "Cost (THB):",
    "ticketDetail.parts.title": "Spare Parts & Equipment Used",
    "ticketDetail.parts.itemNo": "No.",
    "ticketDetail.parts.name": "Part Name / Item",
    "ticketDetail.parts.qty": "Qty",
    "ticketDetail.parts.unitPrice": "Unit Price (THB)",
    "ticketDetail.parts.lineTotal": "Total (THB)",
    "ticketDetail.parts.totalCost": "Grand Total",
    "ticketDetail.parts.noParts": "No parts used",
    "ticketDetail.parts.noneRecorded": "No spare parts recorded",
    "ticketDetail.parts.currency": "THB",
    "ticketDetail.tech.selfReporterBadge": "Your own request",
    "ticketDetail.tech.statusLine": "Status:",
    "ticketDetail.tech.waitReporterEval":
      "Work finished — awaiting reporter rating",
    "ticketDetail.tech.jobWelldone": "Repair completed",
    "ticketDetail.tech.etaTitle": "Estimated Repair Time (ETA)",
    "ticketDetail.tech.etaHint":
      "The reporter will automatically see this information on the status tracking page.",
    "ticketDetail.tech.etaPromptHint":
      "Please select an estimated repair duration before viewing the repair report.",
    "ticketDetail.tech.etaLabel": "Select timeframe",
    "ticketDetail.tech.etaCustomLabel": "Specify date or additional details",
    "ticketDetail.tech.etaCustomPlaceholder":
      "e.g. within 2 weeks, waiting for supplier parts",
    "ticketDetail.tech.saveEtaBtn": "Save ETA",
    "ticketDetail.tech.etaSaveBtn": "Save ETA",
    "ticketDetail.tech.etaSaving": "Saving...",
    "ticketDetail.tech.etaSavedPrefix": "Saved:",
    "ticketDetail.tech.etaNone": "None",
    "ticketDetail.tech.eta1_3d": "1 - 3 days",
    "ticketDetail.tech.eta3_7d": "3 - 7 days",
    "ticketDetail.tech.etaWaitingParts": "Waiting for parts (> 7 days)",
    "ticketDetail.tech.etaPostponed": "Postpone repair",
    "ticketDetail.tech.etaPostponeLimit": "Postpone repair (Postpone limit reached)",
    "ticketDetail.tech.etaCustomOption": "Custom",
    "ticketDetail.tech.step1Tab": "Estimate Repair Time (ETA)",
    "ticketDetail.tech.step2Tab": "Repair Outcome & Close Job",
    "ticketDetail.tech.step1Heading": "Step 1: Estimated Repair Time",
    "ticketDetail.tech.step2Heading": "Step 2: Repair Outcome (Close Job)",
    "ticketDetail.tech.step2Subheading":
      "Fill in repair details, spare parts used, and attach a photo to close the ticket",
    "ticketDetail.tech.ifRepairFinished": "If repair work is completed:",
    "ticketDetail.tech.goToCloseJob": "Go to Close Job Step ➔",
    "ticketDetail.tech.estimatedTimeSummary": "Estimated repair time:",
    "ticketDetail.tech.editEtaBtn": "Edit Estimated Time (ETA)",
    "ticketDetail.tech.onePhotoLimit": "(1 photo)",
    "ticketDetail.tech.dragDropClick": "Click to select image",
    "ticketDetail.tech.dragDropOr": "or drag file here",
    "ticketDetail.tech.changePhoto": "Change",
    "ticketDetail.tech.removePhoto": "Remove",
    "ticketDetail.tech.partsHeading": "Spare Parts & Equipment",
    "ticketDetail.tech.noPartsUsed": "No parts used",
    "ticketDetail.tech.partNameLabel": "Part Name",
    "ticketDetail.tech.partNamePlaceholder": "e.g. LED bulb, cable",
    "ticketDetail.tech.partQtyLabel": "Quantity",
    "ticketDetail.tech.partPriceLabel": "Unit Price",
    "ticketDetail.tech.partTotalLabel": "Total (THB)",
    "ticketDetail.tech.addPartBtn": "Add Spare Part / Equipment",
    "ticketDetail.tech.removePartTitle": "Remove item",
    "ticketDetail.tech.backToEta": "← Back to Estimated Repair Time (ETA)",
    "ticketDetail.tech.supervisorWhen": "When:",
    "ticketDetail.tech.youTechnician": "Technician (you):",
    "ticketDetail.tech.locationDetailLabel": "Location detail:",
    "ticketDetail.tech.problemLabel": "Problem details:",
    "ticketDetail.tech.photoAfterOptional": "Photo (after repair - optional):",
    "ticketDetail.tech.acceptConfirmTitle": "Accept job?",
    "ticketDetail.tech.acceptConfirmText": "Accept this job?",
    "ticketDetail.tech.acceptConfirmBtn": "Accept",
    "ticketDetail.tech.acceptOkTitle": "Accepted",
    "ticketDetail.tech.acceptOkText": "You can start work now",
    "ticketDetail.tech.acceptFail": "Could not accept",
    "ticketDetail.tech.rejectJob": "Reject job",
    "ticketDetail.tech.rejectNotice":
      "You have rejected this maintenance request",
    "ticketDetail.tech.rejectReasonLabel": "Reason: ",
    "ticketDetail.tech.rejectConfirmTitle": "Confirm job rejection",
    "ticketDetail.tech.rejectConfirmText":
      "Please specify the reason for rejecting this job",
    "ticketDetail.tech.rejectPlaceholder": "Enter rejection reason",
    "ticketDetail.tech.rejectRequired": "Please specify rejection reason",
    "ticketDetail.tech.rejectConfirmBtn": "Confirm reject",
    "ticketDetail.tech.rejectOkTitle": "Job rejected successfully",
    "ticketDetail.tech.rejectOkText":
      "The administrator/supervisor has been notified",
    "ticketDetail.tech.rejectFail": "Failed to reject job",
    "ticketDetail.tech.badgeAccepted": "Accepted",
    "ticketDetail.tech.badgeRejected": "Rejected",
    "ticketDetail.tech.badgeWaiting": "Pending",
    "ticketDetail.tech.selfAssignBtn": "I will fix this myself",
    "ticketDetail.tech.changeSelfAssignBtn": "Change to self-repair",
    "ticketDetail.tech.selfAssignTitle": "Confirm self-repair",
    "ticketDetail.tech.selfAssignText":
      "Do you want to assign and start this repair task yourself?",
    "ticketDetail.tech.selfAssignConfirmBtn": "Confirm self-repair",
    "ticketDetail.tech.selfAssignOkTitle": "Self-repair started",
    "ticketDetail.tech.selfAssignOkText": "Status updated to in-progress",
    "ticketDetail.tech.selfAssignFail": "Failed to assign self-repair",
    "ticketDetail.tech.etaCustomEmptyTitle": "Please enter details",
    "ticketDetail.tech.etaCustomEmptyText":
      "Please enter custom ETA details when selecting Custom option",
    "ticketDetail.tech.etaSaveOk": "Estimated repair time saved successfully",
    "ticketDetail.tech.etaSaveFail": "Failed to save estimated repair time",
    "ticketDetail.tech.noUserProfile": "User profile not found",
    "ticketDetail.tech.selfAdmin": "Me (Admin)",
    "ticketDetail.tech.selfSupervisor": "Me (Supervisor)",
    "ticketDetail.tech.receivedJobsCount": "Received Jobs",
    "ticketDetail.tech.imgOnlyError": "Please select image files only",
    "ticketDetail.tech.invalidData": "Invalid data",
    "ticketDetail.tech.invalidQty":
      "Quantity must be greater than or equal to 0",
    "ticketDetail.tech.invalidCost": "Cost must be greater than or equal to 0",
    "ticketDetail.tech.partInvalidTitle": "Invalid spare parts data",
    "ticketDetail.tech.partInvalidText":
      "Please specify part name, integer quantity greater than 0, and unit price 0 or more, or choose 'No parts used'.",
    "dashboard.invalidDateRangeTitle": "Invalid date range",
    "dashboard.invalidDateRangeText":
      "End date must be greater than or equal to start date",
    "dashboard.noDataPeriodText": "No tickets found in the selected period",
    "ticketDetail.tech.fileTooBig": "File too large",
    "ticketDetail.tech.needPhotoTitle": "Photo required",
    "ticketDetail.tech.needPhotoText": "Upload an after photo before closing",
    "ticketDetail.tech.needDetailTitle": "Details required",
    "ticketDetail.tech.needDetailText": "Describe the work before closing",
    "ticketDetail.tech.closeConfirmTitle": "Close job?",
    "ticketDetail.tech.closeConfirmText": "Close this repair job?",
    "ticketDetail.tech.closeOkTitle": "Saved",
    "ticketDetail.tech.closeOkText": "Job submitted",
    "ticketDetail.tech.closeFail": "Could not submit",
    "ticketDetail.statusFull.pending": "Submitted (awaiting team)",
    "ticketDetail.statusFull.assigned": "Acknowledged (awaiting technician)",
    "ticketDetail.statusFull.in_progress": "In progress",
    "ticketDetail.statusFull.done": "Repair done",
    "ticketDetail.statusFull.welldone": "Closed",

    "table.user.col.ticketNo": "Ticket no.",
    "table.user.col.reportedAt": "Reported date/time",
    "table.user.col.department": "Department",
    "table.user.col.detail": "Details",
    "table.user.col.status": "Status",
    "table.user.onBehalf": "On behalf of:",
    "table.user.btn.track": "Track",
    "table.user.btn.cancelRequest": "Cancel request",
    "table.user.legend1": "Submitted",
    "table.user.legend2": "Acknowledged",
    "table.user.legend3": "In progress",
    "table.user.legend4": "Done",
    "table.user.status.pending": "Submitted",
    "table.user.status.assigned": "Acknowledged",
    "table.user.status.in_progress": "In progress",
    "table.user.status.done": "Done",
    "table.user.status.welldone": "Done",
    "table.user.status.cancelled": "Cancelled",
    "table.user.unknownDept": "Unspecified",
    "table.user.swalCancelTitle": "Confirm cancellation?",
    "table.user.swalCancelHtml":
      'Cancel this maintenance request?<br><br><b style="color:red;">*please enter a reason</b>',
    "table.user.swalPlaceholder": "Reason...",
    "table.user.swalReasonRequired": "Please enter a cancellation reason.",
    "table.user.swalSuccess": "Cancelled",
    "table.user.swalSuccessText": "This request has been cancelled.",
    "table.user.swalErrCancel": "Could not cancel the request",
    "table.user.swalErrNetwork": "Could not reach the server",
    "table.user.btnConfirmCancel": "Confirm",
    "table.user.btnBack": "Cancel",
    "table.user.timeSuffix": "",
    "table.admin.col.ticketNo": "Ticket no.",
    "table.admin.col.reportedAt": "Reported date/time",
    "table.admin.col.reporter": "Reporter",
    "table.admin.col.detail": "Problem / Work Details",
    "table.admin.col.routing": "Responsible Department",
    "table.admin.section": "Section",
    "table.admin.department": "Department",
    "table.admin.jobType": "Job Type",
    "table.admin.col.status": "Status",
    "table.admin.col.satisfaction": "Satisfaction",
    "table.admin.onBehalf": "On behalf of:",
    "table.admin.btn.detail": "View details",
    "table.admin.btn.assignDept": "Assign department",
    "table.admin.legend1": "New request",
    "table.admin.legend2": "Department assigned",
    "table.admin.legend3": "Repair in progress",
    "table.admin.legend4": "Awaiting user confirmationation",
    "table.admin.legend5": "Cancelled",
    "table.admin.col.reporterDetail": "Reporter / details",
    "table.admin.col.actions": "Actions",
    "table.admin.status.pending": "New request",
    "table.admin.status.assigned": "Department assigned",
    "table.admin.status.in_progress": "Repair in progress",
    "table.admin.status.done": "Awaiting user confirmationation",
    "table.admin.status.welldone": "Closed",
    "table.admin.status.cancelled": "Cancelled",
    "table.admin.subAssigned": "(assigned)",
    "table.admin.subWaitAssign": "(awaiting assignment)",
    "table.admin.noUserName": "Unknown name",
    "table.tech.col.date": "Date",
    "table.tech.col.issueDetail": "Job details / reporter",
    "table.tech.reportedDateLabel": "Report date",
    "table.tech.byPrefix": "By:",
    "table.tech.supervisorFallback": "Supervisor",
    "table.tech.reportedBy": "Reported by:",
    "table.tech.badgeReporter": "My report",
    "table.tech.badgeAssignee": "Assigned",
    "table.tech.legend1": "New job",
    "table.tech.legend2": "Accepted",
    "table.tech.legend3": "Repairing",
    "table.tech.legend4": "Repair completed",
    "table.tech.status.pending": "Submitted (awaiting team)",
    "table.tech.status.assigned": "New job",
    "table.tech.status.in_progress": "In progress",
    "table.tech.status.done": "Work completed",
    "table.tech.status.welldone": "Closed",
    "table.tech.status.cancelled": "Cancelled",
    "table.tech.action.acceptJob": "Accept job",
    "table.tech.action.finishJob": "Complete job",
    "table.tech.action.detail": "View details",
    "table.tech.noUserName": "Unknown name",
    "table.supervisor.col.reporterDetail": "Reporter / details",
    "table.supervisor.badgeReporter": "My report",
    "table.supervisor.badgeDept": "Department",
    "table.supervisor.noCategory": "No category",
    "table.supervisor.noUserName": "Unknown name",
    "table.supervisor.action.assign": "Assign job",
    "table.supervisor.legend1": "New request",
    "table.supervisor.legend2": "Technician assigned",
    "table.supervisor.legend3": "Repair in progress",
    "table.supervisor.legend4": "Awaiting user confirmationation",
    "table.supervisor.status.pending": "New request",
    "table.supervisor.status.assigned": "Technician assigned",
    "table.supervisor.status.in_progress": "Repair in progress",
    "table.supervisor.status.done": "Awaiting user confirmationation",
    "table.supervisor.status.welldone": "Closed",
    "table.supervisor.status.cancelled": "Cancelled",
    "table.supervisor.action.track": "Track",

    "reportList.pageTitle": "Repairs",
    "reportList.newRequest": "New request",
    "reportList.tabActive": "Active requests",
    "reportList.tabHistory": "History",

    "sendReport.modalTitle": "Maintenance request",
    "sendReport.pageTitle": "New request",
    "sendReport.stepLabel": "Step {current} / {total}",
    "sendReport.nextStep": "Next step",
    "sendReport.back": "Back",
    "sendReport.submitRequest": "Submit request",
    "sendReport.sectionRepair": "Repair details",
    "sendReport.sectionRepairHint": "Describe the issue and location",
    "sendReport.jobType": "Job type",
    "sendReport.frequentlyUsed": "Frequently Used",
    "sendReport.allCategories": "All Categories",
    "sendReport.searchCategoryPlaceholder": "Search categories...",
    "sendReport.noCategoriesFound": "No matching categories found",
    "sendReport.noJobTypes": "No job types found",
    "sendReport.otherTypeLabel": "Specify other job type",
    "sendReport.otherTypePlaceholder": "Describe the job type...",
    "sendReport.problemLabel": "Problem / work required",
    "sendReport.problemPlaceholder": "Describe the problem or repair needed...",
    "sendReport.assetCodeLabel": "Asset / Equipment Code",
    "sendReport.assetCodePlaceholder":
      "Enter asset code, e.g. MFU-IT-2024-001 or AC-501-01",
    "sendReport.assetCodeHint":
      "Please provide the asset/equipment number on the device for faster inspection",
    "sendReport.imageLabel": "Attach photo",
    "sendReport.pickOrCapture": "Choose file or take a photo",
    "sendReport.remove": "Remove",
    "sendReport.changeImage": "Change Photo",
    "sendReport.takePhoto": "Take photo",
    "sendReport.choosePhoto": "Choose photo",
    "sendReport.attachedPhotos": "Attached Photos",
    "sendReport.takeMore": "Take More",
    "sendReport.chooseMore": "Choose More",
    "sendReport.takeOrAddPhoto": "Take/Add photo",
    "sendReport.viewFullPhoto": "View full-size photo",
    "sendReport.clickToView": "Click to view photo",
    "sendReport.prevPhoto": "Previous photo",
    "sendReport.nextPhoto": "Next photo",
    "sendReport.imageHint": "Images only (.jpg, .png)",
    "sendReport.newRequestHint":
      "Fill in the details below to submit a new maintenance request",
    "sendReport.workArea": "Work area",
    "sendReport.insideBuilding": "Inside building",
    "sendReport.insideBuildingSub": "Building",
    "sendReport.outsideBuilding": "Outside building",
    "sendReport.outsideBuildingSub": "Outdoor",
    "sendReport.buildingRoom": "Building – room",
    "sendReport.buildingPlaceholder": "e.g., C3-201 or Krua Lamduan",
    "sendReport.buildingFormatHint":
      "* Use format: building-room (e.g., c3-201)",
    "sendReport.buildingFound": "Building matched:",
    "sendReport.propertySectionNotice":
      "Responsible Unit: Property and Revenue Management Office (The request will be routed directly to the Property and Revenue Management Office)",
    "sendReport.pinLocation": "Pin location on map",
    "sendReport.mapMyLocation": "Locate my current GPS position",
    "sendReport.mapResetMFU": "Reset position to Mae Fah Luang University",
    "sendReport.mapMarkerTitle": "Selected location",
    "sendReport.mapGpsLoading": "Detecting GPS location...",
    "sendReport.mapGpsPermissionHint":
      "Please allow location access in your browser",
    "sendReport.mapGpsDeniedAlert":
      "Unable to detect GPS automatically — please click or drag the pin on the map",
    "sendReport.reporterSection": "Reporter",
    "sendReport.reporterHint": "Contact details",
    "sendReport.reporterName": "Reporter name",
    "sendReport.affiliation": "Reporter affiliation",
    "sendReport.affiliationNotSpecified": "Not specified",
    "sendReport.conflictAffiliationWarning":
      "Identity conflict detected (student/staff). Please contact administrator to resolve before submitting.",
    "sendReport.unverifiedAffiliationWarning":
      "No verified affiliation from Blendata. Repair requests cannot be submitted.",
    "sendReport.outageAffiliationWarning":
      "Blendata is temporarily unavailable and no verified affiliation history is found.",
    "sendReport.ratingLockTitle": "Evaluation Required Before New Request",
    "sendReport.ratingLockMessage": "You have {count} completed repair ticket(s){ticketNo} awaiting satisfaction rating. Please evaluate before submitting a new request.",
    "sendReport.goToRating": "Go to Evaluation",
    "sendReport.onBehalfLabel":
      "On behalf of (name of person requesting repair)",
    "sendReport.onBehalfPlaceholder": "Name if reporting for someone else",
    "sendReport.personalPhone": "Mobile phone",
    "sendReport.workPhone": "Work phone",
    "sendReport.phonePlaceholderMobile": "e.g., 0900000000",
    "sendReport.phonePlaceholderWork": "e.g., 021234567",
    "sendReport.availability": "Preferred date and time",
    "sendReport.dateLabel": "Date:",
    "sendReport.datePlaceholder": "dd/mm/yyyy",
    "sendReport.startLabel": "Start:",
    "sendReport.endLabel": "End:",
    "sendReport.availabilityHint":
      "Choose when you are available for the repair",
    "sendReport.cancel": "Cancel",
    "sendReport.confirm": "Confirm",
    "sendReport.submitting": "Sending...",
    "sendReport.defaultFirstName": "User",
    "sendReport.defaultLastName": "",
    "sendReport.timeSuffix": "At",
    "sendReport.errEndAfterStart":
      "End time must be after start time (same day).",
    "sendReport.errImageOnly": "Please select an image file only",
    "sendReport.optimizingImage": "Auto-optimizing image (Max 1MB)...",
    "sendReport.errImageSize": "Image too large",
    "sendReport.errImageProcess": "Could not process the image",
    "sendReport.errPhoneRequired": "Please enter your mobile phone number",
    "sendReport.errPhoneDigits": "Enter 9–10 digits (numbers only)",
    "sendReport.errPickDate": "Please choose a preferred date",
    "sendReport.errPickTime": "Please choose a time range",
    "sendReport.errPickJobType": "Please select a job type",
    "sendReport.errSpecifyOther": "Please specify the job type",
    "sendReport.errWorkArea": "Please select a work area",
    "sendReport.errBuildingFormat": "Use building-room format (e.g., c3-201)",
    "sendReport.errMapPin": "Please drop a pin on the map",
    "sendReport.errProblem": "Please describe the problem",
    "sendReport.errAssetCode": "Please enter the asset code",
    "sendReport.errAttachImage": "Please attach a photo",
    "sendReport.swalIncompleteTitle": "Incomplete information",
    "sendReport.swalIncompleteText":
      "Please fill in all required fields before submitting",
    "sendReport.otherPrefix": "Other",
    "sendReport.confirmLocation": "Location:",
    "sendReport.outdoorLocated": "Outdoor (location pinned)",
    "sendReport.confirmJobType": "Job type:",
    "sendReport.confirmProblem": "Problem:",
    "sendReport.confirmOnBehalf": "On behalf of:",
    "sendReport.confirmPersonalPhone": "Mobile:",
    "sendReport.confirmWorkPhone": "Work phone:",
    "sendReport.confirmAvailability": "Availability:",
    "sendReport.swalConfirmTitle": "Confirm maintenance request",
    "sendReport.swalEdit": "Edit",
    "sendReport.swalSuccessTitle": "Request submitted",
    "sendReport.swalErrorTitle": "Something went wrong",
    "sendReport.swalErrorText":
      "Could not submit the request. please try again.",

    "mgmt.cancel": "Cancel",
    "mgmt.save": "Save",
    "mgmt.add": "Add",
    "mgmt.edit": "Edit",
    "mgmt.delete": "Delete",
    "mgmt.actions": "Actions",
    "mgmt.confirm": "Confirm",
    "mgmt.confirmDelete": "Confirm delete",
    "mgmt.processing": "Processing...",
    "mgmt.loadingDelete": "Deleting...",
    "mgmt.loadingRead": "Reading file...",
    "mgmt.loadingSave": "Saving...",
    "mgmt.loadingDept": "Loading department...",
    "mgmt.errFillAll": "Please fill in all required fields",
    "mgmt.errFillAllShort": "Please complete all fields",
    "mgmt.success": "Success",
    "mgmt.warn": "Notice",
    "mgmt.error": "Error",
    "mgmt.editSaved": "Changes saved",
    "mgmt.saveSaved": "Saved successfully",
    "mgmt.manage": "Manage",
    "mgmt.edit": "Edit",
    "mgmt.delete": "Delete",
    "mgmt.confirm": "Confirm",
    "mgmt.cancel": "Cancel",
    "mgmt.save": "Save",
    "mgmt.add": "Add",
    "mgmt.deleteMultiple": "Delete Selected",
    "mgmt.confirmDelete": "Confirm Delete",
    "mgmt.addSaved": "Added successfully",
    "mgmt.deleteUserTitle": "Remove this user?",
    "mgmt.deleteUserBulkTitle": "Remove selected users?",
    "mgmt.sureDelete": "Are you sure?",
    "mgmt.demoteUserSuffix": "Will be changed to a regular user",
    "mgmt.demoteUsersBulk":
      "All selected users will be changed to regular users",
    "mgmt.demoteSuccess": "User role updated to regular user",
    "mgmt.countItems": "Count",
    "mgmt.itemsUnit": "Items",
    "mgmt.batchDeleted": "Removed",
    "mgmt.batchFailed": "Failed",
    "mgmt.batchAdded": "Added",
    "mgmt.doneTitle": "Done",
    "mgmt.donePartial": "Done (some rows failed)",
    "mgmt.noData": "No data",
    "mgmt.noDataToSave": "Nothing to save",
    "mgmt.fileReadError": "Could not read the file or invalid format",
    "mgmt.rowIncompleteSuffix": "Incomplete data",
    "mgmt.errOperation":
      "An error occurred while processing. Please try again.",
    "mgmt.accessDenied": "You do not have permission to perform this action.",
    "mgmt.deleteUserFailed": "Failed to delete staff member. Please try again.",
    "mgmt.cannotDelete": "Cannot delete",
    "mgmt.cannotDeleteActiveTasks": "Has active tasks, cannot be removed",
    "mgmt.activeTasksCount": "{count} active tasks",
    "mgmt.deleteBuildingTitle": "Confirm delete?",
    "mgmt.deleteBuildingBulkTitle": "Delete selected buildings?",
    "mgmt.deleteBuildingSure": "Are you sure?",
    "mgmt.deleteBuildingText": "Delete building",
    "mgmt.deleteBuildingAndRooms": "And all its rooms?",
    "mgmt.buildingWillDelete": "Will be permanently deleted",
    "mgmt.buildingsSelectedWillDelete":
      "All selected buildings will be permanently deleted",
    "mgmt.deleteBuildingBulkText": "Delete the selected",
    "mgmt.deleteOk": "Deleted",
    "mgmt.deleteBuildingDone": "Building removed",
    "mgmt.cannotDelete": "Could not delete",
    "mgmt.editRoomSaved": "Room name updated",
    "mgmt.editFail": "Update failed",
    "mgmt.addFail": "Could not add",
    "mgmt.loadFail": "Could not load data",
    "mgmt.saveFail": "Save failed",
    "mgmt.deleteFail": "Delete failed",

    "jobList.pageTitle": "Sections, Departments & Job Types Structure",
    "jobList.pageSubtitle":
      "Manage Sections ➔ Departments ➔ Maintenance Job Types",
    "jobList.addSection": "Add New Section",
    "jobList.searchPlaceholder":
      "Search by section name, code, department, or job...",
    "jobList.collapseAll": "Collapse All",
    "jobList.expandAll": "Expand All",
    "jobList.sectionsCount": "Sections",
    "jobList.deptsCount": "Departments",
    "jobList.hasDataBadge": "Has Active Depts & Jobs",
    "jobList.noDataBadge": "No Job Types",
    "jobList.activeSectionsGroup": "Sections with Departments & Job Types",
    "jobList.activeSectionsDesc": "Sections configured to receive repair tickets with active job types",
    "jobList.emptySectionsGroup": "General Sections without Departments/Job Types",
    "jobList.emptySectionsDivider": "Sections without configured departments or job types",
    "jobList.emptySectionsHint": "University organizational units with no repair services configured (Click section to add departments/job types)",
    "jobList.affiliatedDepts": "Affiliated Depts",
    "jobList.jobTypesCount": "Job Types",
    "jobList.addDept": "Add Department",
    "jobList.editSection": "Edit Section",
    "jobList.deleteSection": "Delete Section",
    "jobList.activeStatus": "Active",
    "jobList.inactiveStatus": "Inactive",
    "jobList.jobsUnit": "Jobs",
    "jobList.addJobInDept": "Add Job Type",
    "jobList.editDept": "Edit",
    "jobList.deleteDept": "Delete Dept",
    "jobList.responsibleAreas": "Responsible Areas",
    "jobList.emptyJobsInDept":
      "- No job types in this department yet. Click Add Job Type above -",
    "jobList.centralJobsTitle": "Central Jobs (Unassigned Dept)",
    "jobList.addCentralJob": "Add Central Job",
    "jobList.emptyCentralJobs":
      "- No central job types yet. Click Add Central Job above -",
    "jobList.iconCol": "Icon",
    "jobList.jobNameCol": "Job Type Name",
    "jobList.slaCol": "Standard SLA",
    "jobList.statusCol": "Status",
    "jobList.actionsCol": "Actions",
    "jobList.clickToUploadIcon": "Click to upload custom icon",
    "jobList.hoursUnit": "hrs",
    "jobList.active": "Active",
    "jobList.inactive": "Inactive",
    "jobList.collapse": "Collapse",
    "jobList.expand": "Expand",
    "jobList.emptyDepts": "No departments in this section yet",
    "jobList.emptyDeptsSub":
      "You can add departments to organize job types effectively",
    "jobList.addFirstDept": "Add first department in this section",
    "jobList.notFoundTitle": "No sections matched your search",
    "jobList.notFoundSub":
      'Try searching with another keyword or click "Add New Section" above',
    "jobList.editSectionTitle": "Edit Section Details",
    "jobList.addSectionTitle": "Add New Section",
    "jobList.sectionCodeLabel": "Section Code",
    "jobList.sectionNameLabel": "Section Name",
    "jobList.sectionNameEnLabel": "Section Name (English)",
    "jobList.sectionCodePlaceholder": "e.g., IT, MAINT, HR",
    "jobList.sectionNamePlaceholder": "e.g., Building and Facilities Section",
    "jobList.sectionNameEnPlaceholder": "e.g., Division of Buildings and Grounds",
    "jobList.saveSectionBtn": "Save Changes",
    "jobList.createSectionBtn": "Create Section",
    "jobList.editDeptTitle": "Edit Department Details",
    "jobList.addDeptTitle": "Add New Department",
    "jobList.affiliatedSection": "Affiliated Section:",
    "jobList.deptCodeLabel": "Department Code",
    "jobList.deptNameLabel": "Department Name",
    "jobList.deptNameEnLabel": "Department Name (English)",
    "jobList.deptCodePlaceholder": "e.g., IT-SUP, ENG-MEP",
    "jobList.deptNamePlaceholder": "e.g., Technical Support Division",
    "jobList.deptNameEnPlaceholder": "e.g., Technical Service and Support Division",
    "jobList.deptActiveSwitch": "Enable this Department",
    "jobList.deptInactiveSwitch": "Disable this Department",
    "jobList.saveDeptBtn": "Save Department",
    "jobList.createDeptBtn": "Create Department",
    "jobList.editJobTitle": "Edit Job Type",
    "jobList.addJobTitle": "Add New Job Type",
    "jobList.sectionColon": "Section:",
    "jobList.deptColon": "Department:",
    "jobList.affiliationColon": "Affiliation:",
    "jobList.jobNameLabel": "Job Type Name",
    "jobList.jobNameEnLabel": "Job Type Name (English)",
    "jobList.jobNamePlaceholder":
      "e.g., Electrical & Lighting, Software Installation",
    "jobList.jobNameEnPlaceholder": "e.g., Computers & Equipment",
    "jobList.slaLabel": "Standard SLA (Hours)",
    "jobList.deptSelectLabel": "Department",
    "jobList.centralOption": "-- Central Job (No Sub-Department) --",
    "jobList.jobActiveSwitch": "Enable this Job Type",
    "jobList.jobInactiveSwitch": "Disable this Job Type",
    "jobList.saveJobBtn": "Save Job Type",
    "jobList.createJobBtn": "Create Job Type",
    "jobList.deleteSectionConfirm": "Delete Section",
    "jobList.deleteDeptConfirm": "Delete Department",
    "jobList.deleteJobConfirm": "Delete Job Type",
    "jobList.sectionNameRequired": "Please enter section name",
    "jobList.deptCodeAndNameRequired":
      "Please enter both department code and name",
    "jobList.jobNameAndSlaRequired": "Please specify job name and SLA hours",
    "jobList.saveSectionSuccess": "Section saved successfully",
    "jobList.saveDeptSuccess": "Department saved successfully",
    "jobList.saveJobSuccess": "Job type saved successfully",
    "jobList.deleteSectionSuccess": "Section deleted successfully",
    "jobList.deleteDeptSuccess": "Department deleted successfully",
    "jobList.deleteJobSuccess": "Job type deleted successfully",

    "staffMgmt.pageTitle": "Staff management",
    "staffMgmt.totalStaff": "Total staff",
    "staffMgmt.peopleUnit": "People",
    "staffMgmt.scope": "Data scope",
    "staffMgmt.allSections": "All departments",
    "staffMgmt.searchPlaceholder":
      "Search name, email, department, or responsibility",
    "staffMgmt.noResults": "No matching staff found",
    "staffMgmt.addStaff": "Add staff",
    "staffMgmt.deleteSelected": "Delete selected",
    "staffMgmt.addModal": "Add staff",
    "staffMgmt.editModal": "Edit staff",
    "staffMgmt.previewModal": "Preview from file",
    "staffMgmt.firstName": "First name",
    "staffMgmt.lastName": "Last name",
    "staffMgmt.email": "Email",
    "staffMgmt.invalidEmailFormat": "Invalid email format",
    "staffMgmt.phone": "Phone",
    "staffMgmt.userType": "Role",
    "staffMgmt.section": "Responsible section",
    "staffMgmt.selectSection": "Select responsible section",
    "staffMgmt.department": "Department",
    "staffMgmt.jobType": "Technician job type",
    "staffMgmt.responsibleJob": "Responsible job",
    "staffMgmt.selectJobType": "Select technician job type",
    "staffMgmt.jobTypeUnassigned": "Unassigned",
    "staffMgmt.allDepts": "All departments",
    "staffMgmt.selectDept": "Select department",
    "staffMgmt.addViaXlsx": "Import .xlsx",
    "staffMgmt.downloadTemplate": "Download template",
    "staffMgmt.templateFile": "Template file",
    "staffMgmt.confirmBulk": "Confirm import",
    "staffMgmt.readyToImport": "Ready to import",
    "staffMgmt.invalidData": "Incomplete data",
    "staffMgmt.status": "Status",
    "staffMgmt.previewSummary":
      "Found {total} records ({ready} ready to import, {invalid} incomplete)",
    "staffMgmt.onlyValidImported":
      "Only valid and complete records will be imported",
    "staffMgmt.deptLabel": "Department:",
    "staffMgmt.yourDept": "Your department",

    "deptMgmt.title": "Department Management",
    "deptMgmt.addDept": "Add New Department",
    "deptMgmt.editDept": "Edit Department",
    "deptMgmt.filterSection": "Filter by Section",
    "deptMgmt.deptName": "Department Name",
    "deptMgmt.section": "Affiliated Section",
    "deptMgmt.code": "Department Code",
    "deptMgmt.name": "Department Name",
    "deptMgmt.nameEn": "Department Name (English)",
    "deptMgmt.nameEnPlaceholder": "e.g., Technical Support Division",
    "deptMgmt.status": "Status",
    "deptMgmt.active": "Active",
    "deptMgmt.inactive": "Inactive",
    "deptMgmt.activeStatus": "Enable this department",
    "deptMgmt.allSections": "All Sections",
    "deptMgmt.successAdd": "Department added successfully",
    "deptMgmt.successEdit": "Department updated successfully",
    "deptMgmt.successDelete": "Department deleted successfully",
    "deptMgmt.deleteTitle": "Confirm Delete Department",
    "deptMgmt.deleteMultipleTitle": "Confirm Delete Multiple Items",

    "jobTypeMgmt.pageTitle": "Job types",
    "jobTypeMgmt.addDept": "Add department",
    "jobTypeMgmt.deptNameCol": "Department",
    "jobTypeMgmt.jobTypesCol": "Job types",
    "jobTypeMgmt.icon": "Icon",
    "jobTypeMgmt.jobTypeName": "Job type name",
    "jobTypeMgmt.slaHours": "SLA (hours)",
    "jobTypeMgmt.slaShort": "SLA (h)",
    "jobTypeMgmt.status": "Status",
    "jobTypeMgmt.active": "Active",
    "jobTypeMgmt.inactive": "Inactive",
    "jobTypeMgmt.addDeptModal": "Add department",
    "jobTypeMgmt.editModal": "Edit job types",
    "jobTypeMgmt.deptNameInput": "Department name",
    "jobTypeMgmt.deptPlaceholder": "e.g., electrical, IT, building...",
    "jobTypeMgmt.colDelete": "Del",
    "jobTypeMgmt.addNewSub": "Add job type",
    "jobTypeMgmt.deleteSelectedSub": "Delete selected",
    "jobTypeMgmt.uploadIconHint": "Click to upload icon (png/jpg)",
    "jobTypeMgmt.removeImage": "Remove image",
    "jobTypeMgmt.warnDeptName": "Please enter a department name",
    "jobTypeMgmt.addDeptOk": "Department added",
    "jobTypeMgmt.removeIconTitle": "Remove image?",
    "jobTypeMgmt.removeIconText": "Remove this icon image?",
    "jobTypeMgmt.uploadToast": "Uploaded",
    "jobTypeMgmt.uploadErr": "Upload failed",
    "jobTypeMgmt.delSubTitle": "Confirm delete?",
    "jobTypeMgmt.delSubText": "Delete this job type?",
    "jobTypeMgmt.permanent": "This cannot be undone",
    "jobTypeMgmt.delBulkSubTitle": "Delete selected?",
    "jobTypeMgmt.delBulkSubText": "Delete",
    "jobTypeMgmt.delBulkSubHint":
      "Row(s)? (remove from table; click save to apply)",
    "jobTypeMgmt.delBulkSubLine":
      "Delete {n} selected job type(s)? (removed from the table; click save to apply)",
    "jobTypeMgmt.warnComplete": "Please complete all fields",
    "jobTypeMgmt.delDeptTitle": "Delete department?",
    "jobTypeMgmt.delDeptText": "Delete department",
    "jobTypeMgmt.delDeptLine": 'Delete department "{name}"?',
    "jobTypeMgmt.delDeptSure": "This will be permanent",
    "jobTypeMgmt.delDeptBulkTitle": "Delete departments?",
    "jobTypeMgmt.delDeptBulkText": "Delete the selected",
    "jobTypeMgmt.deptsWillDelete":
      "All selected departments will be permanently deleted",
    "jobTypeMgmt.delDeptOk": "Department deleted",
    "jobTypeMgmt.deptWillDeleteLine":
      'Department "{name}" will be permanently deleted',
    "jobTypeMgmt.addJobType": "Add job type",
    "jobTypeMgmt.addSubModal": "Add job type",
    "jobTypeMgmt.editSubModal": "Edit job type",
    "jobTypeMgmt.subNamePh": "Job type name",
    "jobTypeMgmt.slaPh": "SLA hours",
    "jobTypeMgmt.saveEditBtn": "Save changes",
    "jobTypeMgmt.addSubOk": "Job type added",
    "jobTypeMgmt.cannotLoadDept": "Could not load your department",
    "jobTypeMgmt.delSubNameText": "Delete job type",
    "jobTypeMgmt.subWillDelete": "This will be permanent",
    "jobTypeMgmt.delSubOk": "Job type deleted",
    "jobTypeMgmt.delSubLine": 'Delete job type "{name}"?',
    "jobTypeMgmt.subWillDeleteLine":
      'Job type "{name}" will be permanently deleted',

    "buildingMgmt.pageTitle": "Buildings",
    "buildingMgmt.addRoom": "Add room",
    "buildingMgmt.buildingCol": "Building",
    "buildingMgmt.roomCol": "Rooms",
    "buildingMgmt.editTooltip": "Edit",
    "buildingMgmt.deleteBuildingTooltip": "Delete building",
    "buildingMgmt.editRoomModal": "Edit room name",
    "buildingMgmt.newRoomName": "New room name",
    "buildingMgmt.addBuildingModal": "Add building",
    "buildingMgmt.nameTh": "Building name (Thai)",
    "buildingMgmt.nameEn": "Building name (English)",
    "buildingMgmt.buildingName": "Building name",
    "buildingMgmt.buildingPh": "Enter building name...",
    "buildingMgmt.roomName": "Room name",
    "buildingMgmt.roomPh": "Enter room name...",
    "buildingMgmt.editDataModal": "Edit",
    "buildingMgmt.roomNamesLabel": "Rooms",
    "buildingMgmt.roomInputPh": "Room name",
    "buildingMgmt.addRoomBtn": "Add room",
    "buildingMgmt.addOk": "Added successfully",
    "buildingMgmt.saveEditBuilding": "Save changes",
    "buildingMgmt.deleteBuildingLine":
      'Delete building "{name}" and all its rooms?',
    "buildingMgmt.buildingWillDeleteLine":
      'Building "{name}" will be permanently deleted',
    "buildingMgmt.deleteBulkLine":
      "Delete {n} selected building(s) and all their rooms?",
    "buildingMgmt.deletingTitle": "Deleting...",
    "buildingMgmt.batchResultTitle": "Deleted",
    "buildingMgmt.batchResultHtml": "Deleted {ok} item(s)",
    "buildingMgmt.batchFailLine": "Failed: {fail} item(s)",
    "buildingMgmt.pageSubtitle": "Manage buildings and room locations for maintenance requests",
    "buildingMgmt.buildingsCount": "Buildings",
    "buildingMgmt.roomsCount": "Rooms",
    "buildingMgmt.expandAll": "Expand All",
    "buildingMgmt.collapseAll": "Collapse All",
    "buildingMgmt.expand": "Expand",
    "buildingMgmt.collapse": "Collapse",
    "buildingMgmt.noRooms": "No rooms found in this building",
    "buildingMgmt.addRoomToBuilding": "Add room to this building",
    "buildingMgmt.roomNumber": "#",
    "buildingMgmt.deleteRoomConfirm": "Are you sure you want to delete room \"{name}\"?",
    "buildingMgmt.deleteRoomTitle": "Confirm Delete Room",
    "buildingMgmt.selectAll": "Select All",
    "buildingMgmt.deselectAll": "Deselect All",
    "buildingMgmt.deleteSelected": "Delete Selected",
    "buildingMgmt.quickAddRoom": "Add Room",

    "userManual.title": "User manual & workflow",
    "requesterOrgSync.title": "Sync Requester Org",
    "requesterOrgSync.description":
      "Update requester organization master data from University Master Data",
    "requesterOrgSync.createOnlyNotice":
      "Confirmation creates only reviewed new organization records.",
    "requesterOrgSync.checkUpdates": "Check Updates",
    "requesterOrgSync.checking": "Checking",
    "requesterOrgSync.previewSummary": "Preview summary",
    "requesterOrgSync.newData": "New data",
    "requesterOrgSync.unchanged": "Already present",
    "requesterOrgSync.conflicts": "Conflicts",
    "requesterOrgSync.reviewRequired": "Review required",
    "requesterOrgSync.upToDate": "Data is already up to date",
    "requesterOrgSync.noApplyNeeded": "No eligible records to add",
    "requesterOrgSync.reviewBlocked":
      "Review items must be resolved before apply.",
    "requesterOrgSync.applyUpdates": "Apply {count} Updates",
    "requesterOrgSync.confirmTitle": "Confirm requester organization sync?",
    "requesterOrgSync.confirmText":
      "The reviewed plan will create {count} new organization records.",
    "requesterOrgSync.applyNow": "Apply now",
    "requesterOrgSync.completed": "Sync completed",
    "requesterOrgSync.added": "New records added: {count}",
    "requesterOrgSync.previewFailed":
      "Unable to check requester organization data",
    "requesterOrgSync.applyFailed":
      "Unable to apply requester organization data",
    "requesterOrgSync.errorCode": "Error code",
    "requesterOrgSync.planId": "Plan ID",
    "requesterOrgSync.planHash": "Plan fingerprint",
    "requesterOrgSync.sourceFingerprint": "Source fingerprint",
    "userManual.tabUser": "Requester (user)",
    "userManual.tabSupervisor": "Supervisor",
    "userManual.tabTech": "Technician",
    "userManual.tabStudentAffairs": "Student Affairs",
    "userManual.tabAdmin": "Admin",
    "userManual.userHeading": "Workflow for requesters (user)",
    "userManual.u1t": "1. submit request",
    "userManual.u1d": "Describe the issue, location, and work type",
    "userManual.u2t": "2. awaiting triage",
    "userManual.u2d": "Track status in the list (e.g., pending)",
    "userManual.u3t": "3. technician works",
    "userManual.u3d": "Assigned technician performs the repair on site",
    "userManual.u4t": "4. confirm & rate",
    "userManual.u4d":
      "When work is done, you will be notified to confirm and rate satisfaction",
    "userManual.supHeading": "Workflow for supervisors",
    "userManual.s1t": "1. receive requests",
    "userManual.s1d":
      "Requests matching your department category appear in your queue",
    "userManual.s2t": "2. assign technician",
    "userManual.s2d": "Choose an available technician in your team",
    "userManual.s3t": "3. track progress",
    "userManual.s3d": "Monitor the job or reassign if needed",
    "userManual.s4t": "4. review outcome",
    "userManual.s4d":
      "When the technician finishes, review history for quality",
    "userManual.techHeading": "Workflow for technicians",
    "userManual.t1t": "1. receive assignment",
    "userManual.t1d": "Jobs assigned by a supervisor appear in your list",
    "userManual.t2t": "2. accept job",
    "userManual.t2d": "Confirm to set status to 'in progress'",
    "userManual.t3t": "3. perform repair",
    "userManual.t3d": "Complete the work on site per the ticket",
    "userManual.t4t": "4. record completion",
    "userManual.t4d": "Describe results and attach photos to close the job",
    "userManual.adminHeading": "Workflow for administrators",
    "userManual.a1t": "1. system overview",
    "userManual.a1d": "Use the dashboard for stats and repair status",
    "userManual.a2t": '2. handle "other" category',
    "userManual.a2d": "Route unclear requests to the correct department",
    "userManual.a3t": "3. manage people",
    "userManual.a3d": "Add/remove users and adjust departments or roles",
    "userManual.a4t": "4. master data",
    "userManual.a4d": "Maintain job types, buildings, and departments",

    "profile.title": "My Profile",
    "profile.subtitle": "Account information and operational details",
    "profile.personalInfo": "Personal Information",
    "profile.fullName": "Full Name",
    "profile.firstName": "First Name",
    "profile.lastName": "Last Name",
    "profile.email": "Email",
    "profile.phone": "Phone Number",
    "profile.role": "System Role",
    "profile.affiliation": "Affiliation / School",
    "profile.department": "Department",
    "profile.section": "Section",
    "profile.jobType": "Assigned Job Type",
    "profile.accountStatus": "Account Status",
    "profile.statusActive": "Active",
    "profile.accountType": "Account Type",
    "profile.accountTypeMfu": "University Account (MFU Mail)",
    "profile.accountTypeExternal": "External Account",
    "profile.quickActions": "Quick Actions",
    "profile.back": "Back",
    "profile.viewHistory": "History",
    "profile.newRequest": "New Request",
    "profile.dashboard": "Dashboard",
    "profile.manageStaff": "Staff Management",
    "profile.manageData": "Manage Data",
    "profile.sub.newRequest": "Submit a new maintenance request",
    "profile.sub.viewHistory": "View submitted requests & tracking status",
    "profile.sub.viewHistoryTech": "View completed repair tasks & history",
    "profile.sub.dashboard": "View operational overview and metrics",
    "profile.sub.manageStaff": "Manage staff accounts and permissions",
    "profile.sub.manageData": "Configure job types, buildings and departments",
    "profile.editProfile": "Edit Profile",
    "profile.editModalTitle": "Edit Personal Information",
    "profile.edit": "Edit",
    "profile.editPhone": "Edit Phone Number",
    "profile.editPhoneTitle": "Edit Phone Number",
    "profile.phoneNote":
      "This phone number will be used for coordinating maintenance requests.",
    "profile.changeAvatarTitle": "Change Profile Picture",
    "profile.enterPhone": "Please enter a phone number",
    "profile.phoneSaved": "Phone number updated successfully",
    "profile.avatarSaved": "Profile picture updated successfully",
    "profile.emailGoogleNote":
      "University email (linked with Google Account, read-only)",
    "profile.saveSuccess": "Profile updated successfully",
    "profile.saveError": "Failed to update profile",
    "profile.cacheWarning":
      "Saved on the server, but the local cache could not be updated. Please reload your profile.",
    "ticketRoute.notFound": "Ticket not found",
    "ticketRoute.back": "Back to reports",
    "asyncFeedback.loading": "Loading data...",
    "asyncFeedback.retry": "Retry",
    "profile.saveBtn": "Save Changes",
    "profile.cancelBtn": "Cancel",
    "profile.selectAffiliation": "Select Affiliation / School",
    "profile.avatar": "Profile Picture",
    "profile.changeAvatar": "Change Profile Picture",
    "profile.uploadPhoto": "Upload Photo",
    "profile.orChoosePreset": "Or choose a preset avatar",
    "profile.presetAvatar": "Preset avatar {number}",
    "profile.removeAvatar": "Reset to Default",
    "profile.avatarSizeLimit": "Auto-optimized image (Max 1MB)",
  },
};

export default messages;
